export const it = {
    addDatabase: {
        addDatabase: "Aggiungi il database",
        addFromFile: "Aggiungi da file",
        analyse: "Analyse",
        analysingYourData: "Analysing your data",
        createFromExcel: "Create from Excel",
        databaseImport: "Database import",
        databaseNotImported: "Import has finished with errors",
        databasePrepared: "Database successfully prepared",
        excelFile: "Excel file",
        fileInformation: "File information",
        fixErrors: "To continue please fix following errors and retry",
        importingYourData: "Importing your data",
        productFilesPath: "Product files path",
        productImagesPath: "Product images path"
    },
    availablePrice: {
        allPackage: "Tutti i Formati",
        onePackage: "Un formato",
        priceType: "Tipo di prezzo",
        setPriceVatVisibility: "Imposta la visibilitÃ  dell'IVA",
        setVisibilityAndOrder: "Imposta la visibilitÃ  e l'ordine dei tipi di prezzo",
        withAndWithoutVat: "Sia con che senza IVA",
        withVat: "Solo con IVA",
        withoutVat: "Solo senza IVA"
    },
    barvis: {
        base: "Nome della base",
        bigCanSize: "Grandi Barattoli",
        coating: "Rivestimento",
        identifier: "Identificatore",
        laboratory: "Laboratorio",
        orderOverview: "Panoramica degli Ordini",
        rank: "Classifica",
        smallCanSize: "Barattoli Piccoli"
    },
    basicSetup: {
        alreadyLoggedIn: "Sei giÃ  loggato come %{login}.",
        askSupplier: "Chiedi al tuo fornitore di software di assegnarti altre licenze.",
        asterisk: "Le voci contrassegnate da un asterisco devono essere compilate.",
        identificationKeys: "Chiave identificazione",
        importCustomData: "Se applicabile, importa i tuoi dati personalizzati dal precedente software di erogazione.",
        learnIdentification: "Impara le chiavi di identificazione dal vostro fornitore di software.",
        login: "I seguenti passaggi della configurazione iniziale richiedono diritti di amministratore.",
        noDatabase: "Non Ã¨ stato ancora aggiunto alcun database, Ã¨ necessario inserirne almeno uno.",
        offlineLicensing: "Licenze offline",
        productSelection: "Selezione del prodotto",
        registrationForm: "Modulo di registrazione",
        seeQuestionMark: "Guarda i piccoli punti interrogativi per saperne di piÃ¹ sull'impostazione.",
        selectDefaultPrinter: "Seleziona la stampante predefinita e imposta una configurazione aggiuntiva.",
        selectDefaultTemplate:
            "Seleziona i modelli predefiniti tra quelli giÃ  esistenti, crea un nuovo modello o carica il tuo.",
        selectDispenser: "Seleziona il tipo di dosatore che stai utilizzando.",
        selectLanguage: "Seleziona la tua lingua.",
        selectProducts: "Seleziona uno dei prodotti disponibili che desideri attivare.",
        selectSpectroType: "Seleziona il tipo di spettro che stai utilizzando.",
        setAdditionalPrinterOptions: "Imposta opzioni stampante aggiuntive.",
        setAutomaticUpdates: "Imposta le opzioni di aggiornamento automatico.",
        setCustomItems:
            "Imposta gli elementi personalizzati e la visibilitÃ  dei dati. Scorri verso il basso per vedere piÃ¹ opzioni.",
        setEnvironment: "Impostare l'ambiente generale del software. Scorri verso il basso per vedere piÃ¹ opzioni.",
        setFormulaRepresentation:
            "Imposta la rappresentazione della formula. Scorri verso il basso per vedere piÃ¹ opzioni.",
        summary:
            "Puoi modificare queste impostazioni in qualsiasi momento e trovare ancora piÃ¹ opzioni di configurazione. Divertiti ad usarli %{name}!",
        summarySuccess: "Ã¨ tutto pronto!"
    },
    beforeDispenseColorantBatch: {
        batchNumber: "Numero di lotto: %{batchNumber}",
        colorantIsDefective:
            "Il canestro Ã¨ stato riempito con un lotto del colorante non conforme. Non utilizzare questo lotto.",
        defectiveInfoLine1: "Si prega di non usare coloranti",
        defectiveInfoLine2: "con questo numero di lotto.",
        emptyQuickTint: "Svuotare il canestro  attraverso Erogazione Veloce.",
        warningInfoLine1: "Colorante",
        warningInfoLine2: "con questo numero di lotto puÃ² essere danneggiato."
    },
    canisterLevel: {
        canisterLevel: "Imposta livello canestro",
        criticalLevelCanister: "Livelli critici dei canestri",
        fillToMax: "Riempi al massimo",
        maxDispenseLevel: "Erogazione massima",
        otherCanisters: "Altri canestri",
        warningLevelCanister: "Attenzione livello canestro"
    },
    canisterRefillHistoryModal: {
        batchNumberOfFilling: "Numero di lotto di riempimento",
        ufiCodeStatus: "Stato del codice UFI"
    },
    canistersTab: {
        availableServiceActions: "Azioni di servizio disponibili",
        canisterInformation: "Informazioni sul canestro",
        canisterPreview: "Stato canestro",
        currentLevel: "Livello corrente",
        errors: "Errori",
        fillState: "Stato riempimento",
        fillToMax: "Riempi al massimo",
        fillingAmount: "QuantitÃ  di riempimento",
        finalLevel: "Livello finale ",
        minimumAmount: "QuantitÃ  minima",
        minimumLevel: "Livello minimo",
        moveTableToRefill: "Movimento tavola per riempimento",
        refillNoAmount: "Nessun importo inserito",
        refillOverLimit: "La quantitÃ  inserita supera la capacitÃ  massima del canestro",
        refillSummary: "%{amount} %{unit} del colorante %{colorant} sarÃ  aggiunto al Canestro %{canisterId}.",
        systemWarningAmount: "Sistema d'allarme quantitÃ ",
        warningAmount: "Allarme quantitÃ "
    },
    changeDatabase: {
        changeDatabase: "Cambia database",
        databaseWarning: "Il Database %{databaseName} non puÃ² essere utilizzato a causa di "
    },
    changelog: {
        allVersion: "Tutte le versioni",
        changelog: "Cronologia",
        link: "Collegamento ",
        links: "Collegamenti",
        version: "Versione",
        versionFilter: "Versione del filtro"
    },
    checkBeforeDispensing: {
        checkBeforeDispensingModal: "Non c'Ã¨ colorante sufficiente nel canestro per  %{numOfPackages} pezzi.",
        fillAdditionally: "Riempire aggiungendo",
        refillToMax: "Ricarica fino al max"
    },
    cleanChannels: {
        cleanAllChannels: "Pulizia di tutti i circuiti",
        cleanChannels: "Pulizia circuito",
        cleaningTime: "Intervallo di pulizia",
        selectChannels: "Seleziona Circuito",
        startCleaning: "Inizia Pulizia"
    },
    clientServerSettings: {
        activeServer: "Attiva il server",
        addNewServer: "Aggiungi nuovo server",
        availableServers: "Altri server disponibili",
        clientIdentifier: "Identificativo cliente",
        clientServerSettings: "impostazioni client/server",
        disabledStatus: "Disabilita",
        editServer: "Modifica server",
        fillRequiredFields: "I campi obbligatori devono essere compilati",
        noOtherServers: "Non ci sono altri server disponibili",
        offlineStatus: "Disconnesso",
        onlineStatus: "Connesso",
        port: "Porta",
        serverName: "Nome server",
        serverNameMissing: "Il nome del server deve essere compilato",
        stabileConnection: "Per assicurare una connessione stabile, si prega di utilizzare un indirizzo IP statico.",
        wrongFormatIp: "Formato errato dell'indirizzo IP"
    },
    colorSearchTab: {
        notEveryItemSelected: "Uno o piÃ¹ elementi non selezionati"
    },
    colorTab: {
        colorTone: "TonalitÃ  del colore",
        fandeckPosition: "Posizione della cartella colori",
        moreInfoIcons: "PiÃ¹ icone di informazioni",
        notExistingFormula: "Formula inesistente",
        orderBy: "Ordina per",
        selectYourGrid: "Seleziona la tua griglia",
        showInPanel: "Mostra nel pannello",
        warningIcon: "Icona di avvertimento formula inesistente"
    },
    colorantBatchNumberSettings: {
        batchNumberByPercentage: "Utilizzare i numeri di lotto per percentuale",
        batchNumberFromLastFilling: "Utilizzare i numeri di lotto dell'ultimo riempimento",
        defectiveBatchOfColorant: "Lotto del colorante difettoso",
        enableBatchNumber: "Attivare i numeri di lotto del colorante",
        possibleDamagedBatchOfColorant: "Lotto del colorante possibilmente danneggiato",
        scanOrTypeBatchNumber: "Scannerizzare o digitare il numero di lotto"
    },
    colorantPanel: {
        manualMachine: "macchina"
    },
    colorantsTable: {
        numberOfColorants: "Numero dei coloranti:",
        preview: "Stato",
        prices: "Prezzi"
    },
    currencySettings: {
        addNewCurrency: "Aggiungi nuova valuta",
        codePlaceholder: "Codice",
        currencySettings: "Imposta valuta",
        namePlaceholder: "Nome",
        ratePlaceholder: "VelocitÃ ",
        setDecimalPlaces: "Imposta i decimali",
        setMainCurrency: "Imposta la valuta principale",
        setRounding: "Impostare l'arrotondamento",
        symbolPlaceholder: "Simbolo"
    },
    customFandecks: {
        customFandecks: "Collezioni personali",
        deleteButtonWarning: "Verranno rimosse anche tutte le formule nella cartella colore",
        deleteCustomFandeck:
            "Vuoi davvero cancellare questa cartella colore personalizzata? Anche tutte le formule in questo esso saranno eliminate.",
        disableStandardFandecks: "Mostra solo le cartelle colori personalizzate",
        enableStandardFandecks: "Mostra solo le cartelle colori standard",
        fandeckName: "Nome cartella colore"
    },
    customRedlike: {
        addColorantFromBrand: "Aggiungi il colorante dalla %{brandName} marca",
        addNewCustomer: "Aggiungi nuovo cliente",
        addNewNote: "Aggiungi una nuova nota",
        addedDate: "Data aggiunta",
        addedQuantity: "QuantitÃ  aggiunta",
        availableMachine: "Tintometro pronto",
        brand: "Marca",
        brandPlease: "Selezionare la marca",
        cancelCustomer: "Elimina il cliente",
        colorPlease: "Selezionare il colore",
        confirmCustomerData: "Conferma i dati del cliente",
        confirmNoteData: "Conferma i dati",
        confirmSelectedUser: "Vuoi usare il cliente %{customerName} per questo ordine.",
        confirmed: "Confermato",
        controlData: "Controllo dei dati finali",
        customerCellNumber: "Numero di cellulare del cliente",
        customerFilter: "Filtro cliente",
        customerName: "Nome cliente",
        customerPhone: "Telefono cliente",
        customerPlease: "Selezionare il cliente",
        dateFilter: "Filtro data",
        enterPin: "Inserire il codice PIN",
        enterTheNumberOfPackages: "Inserire il numero di confezioni",
        existingCustomer: "Utente giÃ  esistente",
        fandeckPlease: "Selezionare la cartella colore",
        fillCanisterHistory: "Storico riempimento Canestri",
        findCustomer:
            "Per assegnare la carta fedeltÃ  a questo ordine, scansiona il codice a barre o cerca l'indirizzo e-mail",
        findCustomerByEmail: "Filtrare il cliente per email o per codice a barre",
        finishPreviousStep: "(Si prega di terminare il passo precedente)",
        formulaUnit: "UnitÃ  formula",
        getBackToList: "Torna alla lista clienti",
        historyOfOrders: "Storico ordini",
        insertNote: "Va all'inserimento delle note",
        loadHistoryOrder: "Caricare l'ordine selezionato?",
        loyaltyCards: "Carte fedeltÃ ",
        machineIsAvailable: "Tintometro pronto",
        machineIsUnavailable: "Tintometro non disponibile",
        newLoyaltyCard: "Nuova carta fedeltÃ ",
        noAvailableMachine: "Tintometro non disponibile",
        noCustomerSelected: "Nessun cliente selezionato. Vuoi continuare?",
        notePlease: "Inserisci note",
        openHistory: "Apri lo storico",
        orAdd: "o aggiungi cliente",
        orSelect: "o seleziona cliente",
        orderModification: "L'ordine originale sarÃ  modificato. Vuoi continuare?",
        orderOverview: "Controllo ordine",
        orderToMachine: "Spedisci il mio ordine al tintometro",
        ordersHistory: "Storico ordini",
        packagePlease: "Seleziona la confezione",
        pleaseSelectBrand: "Seleziona la marca",
        previewImage: "Stato IMG",
        previewPackage: "Stato confezione",
        productPlease: "Selezionare il prodotto",
        resetFilters: "Reset dei filtri",
        searchForHistoricalOrders: "O cerca lo storico degli ordini",
        selectBrand: "Selezionare la marca",
        selectColor: "Vai al colore scelto",
        selectCustomer: "Vai al cliente scelto",
        selectExistingCustomer: "Seleziona un cliente esistente",
        selectFandeck: "Vai alla mazzetta",
        selectManually: "If you want to use this color in %{brandNames} brand, please select it manually.",
        selectPackage: "Vai alla confezione scelta",
        selectProduct: "Selezionare il prodotto",
        shotsCoefficient: "Coefficente impulsi",
        showDetail: "Mostra i dettagli",
        showHideEshopName: "Mostra/Nascondi il nome dell'eshop del colore in una colonna separata",
        showKeyboard: "Mostra tastiera",
        skipCustomerButton: "Salta selezione cliente",
        skipCustomerText: "Salta se non vuoi inserire il cliente",
        skipNote: "Salta le note e visualizza il riassunto",
        spectroBrand: "Ricerca nel marchio %{brandName}",
        statusAccepted: "accettato",
        statusCanceled: "eliminato",
        statusCreated: "creato",
        statusDone: "fatto",
        statusPartlyDone: "parzialmente fatto",
        statusPreparing: "in preparazione",
        summaryChosenBase: "Base",
        summaryChosenBrand: "Marca",
        summaryChosenCanSize: "confezione",
        summaryChosenColor: "colore",
        summaryChosenColorCard: "mazzetta",
        summaryChosenProduct: "Prodotto",
        summaryChosenQuantity: "quantitÃ ",
        summaryColorPreview: "colore approssimativo",
        summaryCustomNote: "Nota cliente",
        summaryCustomerNumber: "numero cliente",
        summaryFormula: "Formula",
        summaryFormulaNote: "Nota formula",
        summaryNote: "nota",
        sureAboutSend: "Confermare l'ordine?",
        useCustomerInOrder: "Vuoi usare %{customerName} nel seguente ordine?",
        uuid: "Uuid",
        viewSummary: "Visualizza riassunto",
        volume: "Volume"
    },
    customRedlikeAnother: {
        pinOrderConfirmation: "Pin di conferma ordine",
        pinScreenSaverConfirmation: "Pin di conferma salva schermo",
        pinSettingsConfirmation: "Pin di conferma impostazioni",
        printAuto: "Consenti stampa automatica",
        printerSettings: "Impostazioni della stampante",
        selectColorWithFandeck: "Selezione comune del colore e della mazzetta",
        setKeyboard: "Imposta tastiera",
        setKioskMode: "Imposta modalitÃ  kiosk",
        setLanguage: "Imposta lingua",
        setModule: "Imposta modulo",
        setQuickSelect: "Imposta selezione veloce",
        setScreensaverTimeout: "Imposta il timeout dello screensaver",
        setUnit: "Imposta unitÃ "
    },
    customRedlikeMachine: {
        action: "Azione",
        additionalPrint: "Stampa aggiuntiva",
        brand: "Marchio",
        brandAccess: "L'utente '%{userName}' non puÃ² accedere ai dati del marchio '%{brandName}'",
        can: "Confezione in posizione",
        canistersLevel: "Stato dei livelli dei canestri",
        closeDetailInformation: "Chiudi i dettagli",
        colorantsAmount: "QuantitÃ  dei coloranti",
        confirmRefill: "Confermare riempimento colorante",
        deleteOrder: "Elimina l'ordine",
        dialogNoMachine: "Il tintometro non Ã¨ connesso",
        dialogNoRcc: "Nessun RCC Ã¨ collegata",
        dispense: "Erogare",
        dispenserInErrorState: "Anomalia tintometro",
        dispensingIsOk: "Tintometro pronto",
        emergencyButtonPressed: "Pulsante d'emergenza attivato",
        errorCode: "Codice errore",
        errorEvents: "Errori di erogazione",
        errorReset: "Errore di reset",
        explanation: "Motivo",
        imageNotAvailable: "Imagine non disponibile",
        incorrectCanister: "Scansione del Canestro non corretta!",
        incorrectColorant:
            "ERRORE: Scansione di una confezione di colorante non corretta, per favore scegliere il colorante giusto.",
        lastEvents: "Ultimi eventi ",
        machineActions: "Sensori tintometro",
        machineConfiguration: "Configurazione Tintometro",
        machineError: "Errore tintometro",
        machineIsBusy: "Il tintometro Ã¨ occupato",
        machineNotAvailable: "Il tintometro non Ã¨ disponibile",
        machineTinting: "Aspettare, erogazione in corso...",
        manualScan: "Scansione manuale",
        notEnoughSpace: "ERRORE: Non c'Ã¨ abbastanza spazio per caricare la confezione di colorante",
        numberOfCanistersUnderCriticalLevel: "Il numero di canestri sotto al livello critico Ã¨ %{0}",
        numberOfCanistersUnderWarningLevel: "Il numero di canestri sotto al livello d'allarme Ã¨ %{0}",
        offlinePressed: "Pulsante offline premuto",
        orderSettings: "Impostazioni ordine",
        otherOrderInformation: "Detagli ordine",
        packageCount: "Conteggio confezione",
        packageWithSeparator: "Confezione",
        received: "Ricevuti",
        receivedOrders: "Ordini ricevuti",
        receivedTime: "Tempo di ricezione",
        recirculation: "Ricircolo",
        refillInformation: "Colorante: %{0}, Riempimento: %{1}, Canestro: %{2}",
        resetErrors: "Errori di reset",
        scanCanister: "Scansiona questo canestro",
        scanColorantPackage: "Scansiona la confezione relativa di colorante",
        selectedOrder: "Ordine selezionato",
        shelfMovingDown: "Discesa ripiano confezione",
        shelfMovingUp: "Salita ripiano confezione",
        solution: "Soluzione",
        startDispensing: "Inizio erogazione",
        stirring: "Miscelazione",
        touchToStartFilling: "Premi per iniziare il riempimento colorante",
        unknownBrand: "Marchio sconosciuto"
    },
    customRedlikeSettings: {
        addPos: "Informazioni Punto vendita",
        addServer: "Aggiungi server",
        adminOperations: "Operazioni di amministrazione",
        adminSettings: "Impostazioni amministratore",
        another: "Altro",
        aslOrService: "ASL o servizio",
        availableMachines: "Macchine disponibili",
        barcode: "Codice a barre",
        basicOperations: "Operazioni di base",
        canisterBarcodes: "Barcode canestri",
        canisterLevels: "livelli dei canestri",
        closeConnection: "Chiudi la connessione ",
        closeRedlike: "Chiudi %{name}",
        databaseList: "Database",
        disabledStatus: "disabilitato",
        dispenseLogicType: "Tipo di logica di erogazione",
        dropServers: "Server disconnessi",
        editServer: "Modifica server",
        lastEvent: "Ultimo evento",
        logOut: "Disconnettersi",
        machineConfiguration: "Configurazione",
        maxDispenseAmount: "QuantitÃ  massima di erogazione",
        offlineStatus: "disconnesso",
        onlineStatus: "connesso",
        openFrondesk: "Apri richiesta",
        print: "Impostazioni di stampa",
        rebootPC: "Riavvia il PC",
        restartRedlike: "Riavvia %{name}",
        restoreConnection: "Ripristinare la connessione",
        scanCanisterBarcode: "Scansiona il codice a barre del Canestro",
        scanOrDeleteCanisterBarcode: "Scansiona o elimina il codice a barre",
        setCanisterBarcode: "Imposta il codice a barre del Canestro",
        swVersion: "Versione software",
        systemFunctions: "Funzioni di sistema",
        userSettings: "Impostazioni utente"
    },
    customTab: {
        cifCombinationCheck:
            "The color %{colorName} already exists in fandeck %{fandeckName}, but it contains different spectral data. Would you like to overwrite existing data?",
        editColor: "Visualizza colore",
        editColorant: "Modifica colorante",
        emptyColorant: "C'Ã¨ un colorante con una quantitÃ  vuota",
        formulaCombinationCheck:
            'The formula with the color name "%{colorName}" already exists. Would you like to overwrite existing formula with the new one?',
        formulaForMasterProduct: "Formula per il prodotto master",
        formulaForMasterProductWithParam: "Formula per il prodotto principale %{productName}",
        isNotAvailable: "Non disponibile",
        noBaseSelected: "E' richiesta la base",
        noColorantsSelected: "Nessun colorante selezionato",
        noFandeckSelected: "E' richiesta la mazzetta",
        noNameOrCode: "E' richiesto il nome e il codice della formula",
        noProductSelected: "E' richiesto il prodotto",
        productPreview: "Visualizza prodotto",
        saveCustomRecipe: "Salva formula personale",
        saveIsNotAvailable: "Salvataggio non disponibile",
        showSiblingProducts: "Mostra i prodotti fratelli",
        siblingProducts: "Prodotti fratelli per prodotto principale"
    },
    customersTab: {
        addCustomer: "Aggiungi cliente",
        additionalSettings: "Impostazioni aggiuntive",
        adress: "Indirizzo",
        createAndSelect: "Aggiungi e seleziona",
        createNewCustomer: "Crea nuovo cliente",
        editCustomer: "Modifica cliente",
        expiration: "il Cliente %{name} scadrÃ  in %{dayCount} giorni",
        identificationNumber: "Numero di identificazione",
        information: "Informazioni di contatto",
        listOfCustomers: "Lista dei clienti",
        rabat: "Sconto",
        selectCustomer: "Seleziona cliente",
        spentLastMonth: "Importo mese scorso",
        spentMoney: "Importo speso",
        typeOfMargin: "Tipo di margine",
        zipCode: "CAP"
    },
    dialog: {
        cheaperColorSearch: "La ricerca del colore piÃ¹ economico Ã¨ in corso",
        competitiveColorSearch: "La ricerca di colori competitivi Ã¨ in corso",
        reallyChangeModule: "Vuoi veramente cambiare il modulo?",
        reallyCloseRedlike:
            "Vuoi davvero chiudere %{name}? Tutti i pannelli %{name} saranno chiusi, le modifiche non salvate andranno perse.",
        reallyDeleteOrder: "Vuoi veramente eliminare questo ordine? Tutti i dati relativi all'ordine verranno persi",
        reallyRebootPC:
            "Vuoi veramente riavviare il PC? Tutte le finestre verranno chiuse, i dati non salavati verranno persi.",
        reallyRestartRedlike:
            "Vuoi veramente riavviare il %{name}? Tutte le finestre verranno chiuse, i dati non salavati verranno persi.",
        reallyShutdownPc:
            "Vuoi davvero spegnere questo computer? Tutti i pannelli %{name} saranno chiusi, le modifiche non salvate saranno perse.",
        unlockComputer: "Il computer sarÃ  sbloccato."
    },
    dispenseLogicTypes: {
        1: "Eroga solo la quantitÃ  massima dosabile",
        2: "Consenti l'erogazione manuale utilizzando la bilancia per quantitÃ  superiori alla quantitÃ  massima dosabile",
        3: "Ricarica durante l'erogazione (riproporziona la quantitÃ  in pezzi piÃ¹ piccoli)",
        4: "Force manual dispensing using scale only in case of custom package"
    },
    editCustomFandeck: {
        fandeckName: "Nome della cartella colore "
    },
    editFormulaRgbModal: {
        apply: "Applica",
        blue: "Blu",
        green: "Verde",
        modalLabel: "Genera il colore",
        red: "Rosso",
        tryGenerateRgb: "Prova a generare l'RGB per quantitÃ  di colorante"
    },
    environmentsSettings: {
        allowAutoCloseTab: "Chiudere automaticamente la scheda della formula",
        allowBarcodes: "Consenti i codici a barre",
        allowBuildingSitePanel: "Consenti di inserire le info Cantiere",
        allowCustomers: "Consenti i clienti",
        allowDeleteConfirmation: "Consenti la conferma di eliminazione",
        allowDiskSpaceNotification: "Consenti la notifica dello spazio sul disco",
        allowDispensing: "Consenti l'erogazione",
        allowFileTransfer: "Consenti il trasferimento automatico dei file",
        allowFormulaModificationPanel: "Abilita pannello di modifica formula",
        allowFormulaStatusPanel: "Consenti il pannello di stato della formula",
        allowInternalNotes: "Consenti note interne",
        allowLight: "Consenti %{name}",
        allowOrderNotificationModal: "Mostra notifiche di nuovi ordini",
        allowOrdering: "Consenti l'ordine",
        allowPricing: "Consentire la determinazione dei prezzi",
        allowPrint: "Consenti la stampa",
        allowProductPreviewImage: "Consenti l'anteprima del prodotto durante l'erogazione",
        allowQualityControl: "Consenti Controllo QualitÃ ",
        allowSearchCheaperColors: "Consenti la ricerca di colori piÃ¹ economici",
        allowSound: "Consenti la notifica acustica",
        allowSpectro: "Consenti spettro",
        allowTabs: "Consenti schede",
        applyZoom: "Applica zoom",
        automaticLogout: "Logout automatico",
        barcodeScan: "Scansione del codice a barre",
        canisterBarcode: "Codice a barre dei Canestri",
        canisterLevel: "Livelli Canestri",
        changelog: "Cambia registro",
        closeTab: "Chiudi Scheda",
        colorDifference: "Differenza colore",
        colorPanelNavItem: "Cartella Colori",
        competitiveColorSearch: "Ricerca competitiva dei colori",
        customBanner: "Banner personalizzato",
        customCurrencyFormat: "Formato della valuta",
        customDateFormat: "Formato della data",
        customNumberFormat: "Formato del numero",
        customTimeFormat: "Formato orario",
        deltaA: "Delta a",
        deltaB: "Delta b",
        deltaE: "Delta E",
        deltaL: "Delta L",
        deltaMetamerism: "Delta Metamerismo",
        discount: "Mostra sconto",
        dispensingHistory: "Storico dell'erogazione",
        dispensingNotes: "Consenti le note dell'erogazione",
        enableCustomers: "Abilita i clienti",
        enableDeleteConfirmation: "Abilita la conferma di eliminazione",
        enableDispensing: "Abilita l'erogazione",
        enableLight: "Abilita %{name}",
        enableMarginMarkup: "Abilita il margine o sovrapprezzo",
        enableNotes: "Abilita note",
        enableOrdering: "Abilita ordini",
        enableProductPreviewImage: "Attiva l'immagine di anteprima del prodotto",
        enableSpectro: "Abilita spettro",
        enableVirtualKeyboard: "Abilita tastiera virtuale",
        environmentsSettings: "Impostazioni dell'ambiente",
        exportTranslationKeys: "Esporta chiavi di traduzione",
        formulaNotes: "Consenti le note sulla formula",
        hintTooltips: "Informazioni utili",
        image: "Immagine",
        keyboardShortcuts: "Scorciatoie da tastiera",
        languageBased: "Basato sulla lingua",
        lockYourComputer: "Blocca il tuo computer",
        machineReset: "Reset Tintometro",
        manageTranslations: "Gestisci le traduzioni",
        margin: "Solo margine",
        markup: "Solo ricarico",
        matchingRowCount: "imposta il numero di risultati trovati",
        maxNumberTabs: "Numero massimo di schede formula",
        memoryTabs: "Memorizza le schede aperte di recente",
        moreInfo: "Colore + immagine + piÃ¹ informazioni",
        navigationItems: "Impostazioni delle voci di navigazione",
        newTab: "Nuova scheda",
        numberOfPriceGroups: "Numero dei gruppi di prezzo",
        order: "Ordine",
        orderId: "ID ordine",
        ordersHistory: "Storico degli ordini",
        overwriteLastTab: "Sovrascrivere l'ultima scheda della formula",
        priceCalculation: "Calcolo del prezzo",
        priceDefBothPurchasePrimary: "Entrambi, acquisto primario",
        priceDefBothSellPrimary: "Entrambi, vendita primario",
        priceDefPurchaseOnly: "Solo prezzo d'acquisto",
        priceDefSellOnly: "Solo prezzo di vendita",
        priceDefinition: "Definizione del prezzo",
        priceGroupsEnabled: "Abilita i gruppi di prezzi",
        runLightAtStartUp: "Esegui %{light} all'avvio",
        screenSaverTimeout: "Timeout del salvaschermo",
        selectedSpectro: "Selezionato lo spectro %{spectro} .",
        selectedSpectroNone: "Nessuno spettro selezionato.",
        setAutomaticClientStart: "Esegui %{name} al avvio del computer",
        setCustomHomeButton: "Configura Pulsante Home",
        setDecimalPlaces: "Impostare il numero di decimali",
        setFormulaPreview: "Anteprima della formula impostata",
        setFormulaUnit: "Imposta l'unitÃ  della formula",
        setFts: "Usa la ricerca fulltext",
        setInfoItemInRgb: "Configura le informazioni visibili nell'anteprima della formula RGB",
        setKeyboardShortcuts: "Imposta le scorciatoie da tastiera",
        setKioskMode: "Imposta modalitÃ  kiosk",
        setKioskModeOff: "Disattivare modalitÃ  kiosk",
        setKioskModeOn: "Attivare modalitÃ  kiosk",
        setNavigationItems: "Imposta le voci di navigazione",
        setNavigationItemsList: "Imposta la visibilitÃ  e l'ordine degli elementi di navigazione",
        setOrderSearchItems: "Imposta i parametri di ricerca degli ordini",
        setRounding: "Imposta arrotondamento",
        setSearchParameters: "Imposta i parametri di ricerca della formula",
        setTabLimit: "Imposta limite di scheda",
        setYourLanguage: "Imposta la tua lingua",
        setZoom: "Imposta lo zoom",
        showLocalPrices: "Mostra i prezzi locali",
        skipPlaceCanDialogEnabled:
            "Questo settagio non puÃ² essere cambiato perchÃ© il messaggio di posizionamento latta deve essere disattivato dal settaggio Macchina",
        sortItems: "Ordina gli elementi di navigazione",
        startDispensing: "Avvia l'erogazione",
        stir: "Agita coloranti"
    },
    error: {
        errorDetail: "Detaglio errore",
        errorOccurred: "Errore imprevisto. Contatta l'assistenza al %{0}, vi ricontatteremo appena possibile.",
        hideDetail: "Nascondi i dettagli"
    },
    favoritesTab: {
        addFolder: "Aggiungi cartella",
        closeTabToLoadFormula:
            "Hai raggiunto il numero massimo di schede aperte. Si prega di chiudere una delle formule per aprire una nuova scheda.",
        deleteFolder: "Elimina cartella",
        editFolder: "Modifica cartella",
        favoriteFormulas: "Formule preferite",
        formulaNotes: "Note della formula",
        message: {
            formulasFromFolder: "Formule dalla cartella",
            moveAllFormulas: "Spostare tutte le formule da questa cartella alla cartella superiore",
            removeAllFormulas: "Elimina tutte le formule da questa cartella",
            wantToDeleteFolder: "Vuoi eliminare questa cartella?"
        },
        newFolder: "Nuova cartella",
        packages: "Confezioni",
        pricePerPackage: "Prezzo per confezione",
        regularPrice: "Prezzo regolare",
        removeFromFavorites: "Elimina dai preferiti",
        specialPriceOff: "Prezzo speciale di sconto %{number}% ",
        specialPriceVIP: "Prezzo speciale VIP"
    },
    fileTransfer: {
        afterImport: "Dopo l'importazione",
        alreadyExists: "L'attivitÃ  per  il tipo fornito  e formato esiste giÃ ",
        customFormulaSimple: "Personalizzazione semplice di una formula",
        direction: "Direzione",
        exportTask: "AttivitÃ   di esportazione dei file",
        fileTransferNotification: "Notifica di trasferimento file",
        flashMessage: "Messaggio flash",
        importTask: "AttivitÃ  di importazione file",
        noInformation: "Nessuna informazione",
        protocol: {
            folder: "Cartella",
            ftp: "Protocollo FTP",
            ftps: "Protocollo FTPS",
            redlikeStorage: "Protocollo di archiviazione FTP %{softwareName} ",
            sftp: "SFTP protocol"
        },
        protocolDescription: {
            folder: "Protocollo di controllo dei file nella cartella locale definita.",
            ftp: "Controllo di protocollo dei file nella cartella FTP remota usando una connessione FTP standard.",
            ftps: "Controllo di protocollo dei file nel server FTPS (FTP-SSL / FTP Secure) remoto usando una connessione FTP standard.",
            redlikeStorage: "Protocollo di controllo dei file nella memoria del %{softwareName} ."
        },
        remoteFolder: "Cartella remota",
        startType: "Tipo di avvio",
        statusbar: "Informazioni della barra di stato",
        testConnection: "Connessione di prova",
        xMoreLeft: "(%{amount} more left)",
        xmlImporting: "XML file is being imported"
    },
    filtering: {
        consumptionType: "Tipo di consumo",
        filter: "Filtra",
        from: "Da",
        to: "A"
    },
    findText: {
        findTextTitle: "Trova il testo",
        removeMarks: "Rimuovere i segni",
        search: "Cerca parola"
    },
    flashMessage: {
        VMNotAllowed: "VM non consentita",
        addedToStock: "Articoli aggiunti con successo al magazzino",
        allRecordsDeleted: "All imported records were successfully deleted",
        autologinFailed: "Autologin del database fallito.",
        autotaskDuplicateName:
            "Errore di integritÃ  del database: %{0} elemento with %{1} %{2} esiste giÃ , usane uno differente %{3}",
        barcodeIsUsed: "Il codice a barre Ã¨ giÃ  utilizzato.",
        barcodeNotFound: "Codice a barre non trovato",
        bugReportSent: "La segnalazione dell'errore Ã¨ stata inviata.",
        cannoctConnectToServer: "Impossibile connettersi al server",
        cannotWriteLicense: "Impossibile inserire la licenza",
        clientConnectionRejected: "Connessione rifiutata",
        clientNotLoggedIn: "Il cliente non ha effettuato il login",
        colorFromInactiveDatabase: "Color is from inactive database %{0}.",
        colorantPackageRemovedStock: "Pacchetto colorante rimosso con successo dal magazzino.",
        competitiveSearchEmpty:
            "Non Ã¨ stato possibile trovare nessun colore competitivo. Cambia i parametri di ricerca o seleziona un colore diverso.",
        competitiveSearchSelectProduct: "Selezionare il prodotto per cercare Colore Alternativo",
        computerBackdated: "Computer obsoleto",
        connectionFailed: "Il test di conessione non Ã¨ andato a buon fine: %{0}",
        connectionSuccess: "Il test di connessione Ã¨ andato a buon fine ",
        corruptedLicenseFile: "File di licenza danneggiato",
        customFormulaCreated: "Formula personale creata con successo.",
        customFormulaCreationError: "Errore nel creare la formula personale",
        customFormulaFromXmlCreationError:
            "Error while creating custom formula with colorants '%{colorants}' for combination of product '%{product}', fandeck '%{fandeck}', color '%{color}' and base '%{base}'.",
        customerNotFound: "Il cliente non Ã¨ stato trovato",
        dataNotAvailable: "Il server non riesce a connettersi al database",
        datacolorMatching: {
            couldNotConnect:
                "Non posso connettermi al Colormatching Datacolor, o il server Ã¨ fuori servizio o il pc Ã¨ offline.",
            disabled: "Datacolor Matching disabilitato.",
            internalError: "Datacolor Matching Errore Interno: '%{0}'",
            invalidCredentials:
                "Credenziali invalide o non presenti per il Matching Datacolor, cottattare il formitore del DB",
            noCansAvailable:
                "Nessun formato disponibile per il colorfile selezionato (Linea Prodotto), contattare il fornitore del DB"
        },
        defaultMessage: "Si Ã¨ verificato un errore imprevisto durante l'ultima azione del server",
        deleteAll: "Eliminare tutto",
        deletingImportedData: "Deleting imported records.",
        disableWinterPlugin:
            "Ã possibile disabilitare il plug-in invernale utilizzando l'elenco a discesa sul lato destro della scheda di navigazione",
        duplicateBarcode: "Barcode dupplicato, esiste giÃ  lo stesso Barcode",
        duplicateName: "Nome duplicato, esiste giÃ  lo stesso nome",
        emptyFandeck: "La mazzetta selezionata Ã¨ vuota.",
        emptyStock: "Non ci sono record in stock per l'articolo che hai utilizzato.",
        expiredLicense: "La licenza Ã¨ scaduta",
        exportSuccess: "I dati sono stati esportati correttamente",
        fandeckExist: "Il nome della cartella colore personalizzata esiste giÃ ",
        featureNotAutorized: "Configurazione non autorizzata",
        fileExportComplete: "Il file Ã¨ stato esportato con successo.",
        fileExportError: "Errore durante l'esportazione del file.",
        fileSaveComplete: "File salvato con successo.",
        fileSaveError: "Si Ã¨ verificato un errore durante il salvataggio del file.",
        fileTransferCustomFormulaRecordsAdded: "Nuove formule personalizzate sono state aggiunte dal file ricevuto.",
        fileTransferCustomFormulaRecordsNotFullyProcessed:
            "Non Ã¨ possibile processare tutte le formule personali del file: '%{0}', Verificare il file di Log",
        fileTransferCustomFormulaRecordsProcessed:
            "Aggiunte (%{0} nuove formule personali sul totale di  %{1}) dal file ricevuto",
        fileTransferCustomerRecordsAdded: "Nuovi Clienti aggiunti dal file ricevuto",
        fileTransferCustomerRecordsNotFullyProcessed:
            "Could not fully process customer data in file: '%{0}', see error log files for more info.",
        fileTransferCustomerRecordsProcessed:
            "The new customer records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferFileNotProvided: "File non fornito o vuoto.",
        fileTransferHistoryRecordsAdded:
            "Sono stati aggiunti nuovi record della cronologia di erogazione dal file ricevuto.",
        fileTransferHistoryRecordsNotFullyProcessed:
            "Could not fully process dispensing history data in file: '%{0}', see error log files for more info.",
        fileTransferHistoryRecordsProcessed:
            "The new history records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferInvalidFile: "Impossibile elaborare i dati nel file, il file non Ã¨ valido.",
        fileTransferOrderRecordsAdded: "Nuovi record di ordini sono stati aggiunti dal file ricevuto.",
        fileTransferOrderRecordsNotFullyProcessed:
            "Could not fully process order data in file: '%{0}', see error log files for more info.",
        fileTransferOrderRecordsProcessed:
            "The new order records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferUnknownVersion: "Impossibile rilevare la versione del file.",
        filetransferNoData: "Nessuna connessione al database, controllare le impostazioni",
        formulaDataUnavailable: "I dati della formula non sono disponibili",
        helperDefaultMessage: "Si Ã¨ verificato un errore inaspettato durante l'ultima azione del Server Helper",
        helperServerError: "Errore del server Helper",
        importAborted: "Il processo di importazione Ã¨ stato interrotto",
        importSuccess: "I dati sono stati importati correttamente",
        incompatibleBaseCan: "La base non Ã¨ compatibile con il prodotto scelto, controllare base e confezione",
        incorrectPassword: "La tua vecchia password non Ã¨ corretta. Inserisci una password corretta.",
        invalidCurrency: "Il codice valuta non Ã¨ valido. L'Euro Ã¨ impostato come valuta predefinita.",
        invalidDatabaseName: "Il nome del database non Ã¨ valido",
        invalidEmail: "Il tuo indirizzo e-mail non Ã¨ valido",
        invalidFormulaColorants:
            "ATTENZIONE!!! C'Ã¨ il problema del software nella formula. La formula potrebbe essere sbagliata! Contatta il tuo supporto!",
        invalidLicenseCompanyUserKey: "Chiave azienda-utente non valida",
        invalidLicenseFile: "File di licenza non valido",
        invalidLicenseIdentificationKeys: "Le chiavi di identificazione della licenza non sono valide",
        invalidLicenseKey: "La tua licenza non Ã¨ valida",
        invalidLicenseProduct: "Il file di licenza non corrisponde al prodotto",
        invalidRccResponse: "Si Ã¨ verificato un errore imprevisto durante l'elaborazione dell'ultima risposta RCC",
        invalidServerResponse:
            "Si Ã¨ verificato un errore imprevisto durante l'elaborazione dell'ultima risposta del server",
        invalidUrl: "L'URL non Ã¨ valido",
        itemNotFound: "L'elemento non Ã¨ stato trovato",
        keyboardShortcutUsedInModal:
            "Questa scorciatoia da tastiera non puÃ² essere usata nella finestra modale. Per favore, chiudi la finestra modale.",
        keyboardShortcutValidation: "Non Ã¨ possibile avere la stessa scorciatoia da tastiera per due azioni diverse",
        licenseHasBeenRevoked:
            "La tua licenza Ã¨ stata revocata. Per rinnovarla, contatta il tuo fornitore del software.",
        licenseProlongationNeeded:
            "Ã necessario prolungare la licenza (collegare il PC a Internet per ottenere una nuova licenza)",
        licenseUpToDate: "La tua licenza Ã¨ aggiornata. Nessun aggiornamento necessario.",
        licenseUpdateUnsuccessful: "Impossibile aggiornare la licenza.",
        licenseUpdated: "La licenza Ã¨ stata aggiornata con successo.",
        licensedOnDifferentComputer: "Originariamente concesso in licenza su un altro computer",
        logFileArchiveDownloadComplete: "Il download dell'archivio dei log Ã¨ stato completato con successo",
        loginError: "Si Ã¨ verificato un errore imprevisto durante il login",
        logoutError: "Si Ã¨ verificato un errore imprevisto durante logout",
        machineIsConnecting: "La macchina si sta connettendo, attendere",
        machineIsNotConnected: "La macchina NON Ã CONNESSA a RCC. Si prega di verificare la configurazione RCC.",
        malformedFormula: "Formula is malformed.",
        matching: {
            correctionNotPossible: "La correzione non puÃ² essere fatta, usare la riformulazione",
            forbidden: "Request '%{0}' failed: forbidden.",
            internalServerError: "Internal server error.",
            invalidBase: "Base non valida in Prodotto",
            invalidBipp: "Base non valida in Formato Prodotto",
            invalidColorantId: "Colorante non valido con ID: %{0}.",
            invalidColorantName: "Colorante non valido con nome: %{0}.",
            invalidColorfile: "Color file non valido con  ID: %{0} per il prodotto con ID: %{1}.",
            invalidIlluminant: "Invalid illuminant: %{0}",
            invalidProduct: "Prodotto non valido con ID: %{0}.",
            invalidSpectralCurve: "Curva spettrale non valida.",
            noColorfiles: "Color File non definito per il prodotto con ID: %{0}.",
            notAuthorized: "Request '%{0}' failed: unauthorized.",
            notFound: "Request '%{0}' failed: not found.",
            reformulationNotPossible: "Reformulation cannot be done.",
            unknownError: "Errore sconosciuto.",
            validationError: "Request '%{0}' failed due to validation errors: %{0}."
        },
        maxFileSizeExceeded: "Maximum file size of %{0} MB exceeded",
        maxTabs: "QuantitÃ  massima di schede aperte, si prega di chiuderne una.",
        noTemplate: "La stampa non puÃ² essere effettuata perchÃ© non ci sono modelli disponibili.",
        openNewTab: "Si prega di aprire una nuova scheda formula per caricare la formula utilizzando il codice a barre",
        orderAlreadyAcquired: "L'ordine Ã¨ giÃ  stato acquisito, prima deve essere rilasciato",
        orderCreated: "L'ordine Ã¨ stato inviato con successo",
        passwordIsNotUnique: "La vecchia password deve essere diversa da quella nuova.",
        printCannotBeCarriedOut: "La stampa non puÃ² essere eseguita perchÃ© il nome della stampante non Ã¨ valido.",
        problemWithFileExport: "Si Ã¨ verificato un errore durante il salvataggio del file sul disco.",
        productFileWarning: "Il file del prodotto Ã¨ disponibile solo online.",
        productNotLicensed: "Il prodotto non Ã¨ stato licenziato",
        rccDefaultMessage: "Si Ã¨ verificato un errore imprevisto durante l'ultima azione RCC",
        rccError: "Errore RCC",
        rccNeedRestart: "Si prega di riavviare l'RCC",
        restoredSettings: "Le impostazioni sono state ripristinate.",
        revokedLicense: "La licenza Ã¨ stata revocata",
        runningOutOfSpace: "Il computer sta esaurendo lo spazio libero.",
        savedFormulaToHistory: "La formula Ã¨ stata salvata con successo nella cronologia.",
        savedLogArchive: "L'archivio del registro Ã¨ stato salvato con successo nella tua directory.",
        scanning: "Scansione in corso",
        serverError: "Errore del server",
        setClientIdentifier: "Si prega di impostare il codice del cliente",
        showLess: "Mostra meno",
        showMore: "Mostra di piÃ¹",
        spectroIsDisconnecting: "Lo spettro si sta disconnettendo, attendere",
        spectroIsNotConnected: "Lo spettro non Ã¨ CONNESSO. Si prega di verificare la configurazione RCC.",
        spectroIsNotSelected: "Lo spettro non Ã¨ stato SELEZIONATO. Si prega di verificare la configurazione RCC.",
        tmcNotAvailable: "%{tmc} is not available. Please check your %{collector}.",
        tmcNotConnected: "%{tmc} is not connected. Please start your %{collector} and restart server.",
        unknownError: "Errore Sconosciuto: %{0}",
        userAlreadyLoggedIn: "Sei giÃ  loggato!",
        versionNotAllowedByLicense: "La versione software Ã¨ troppo avanzata e non Ã¨ inclusa nella tua licenza.",
        webApiConnectionError: "Impossibile connettersi al server Web Api",
        webApiInternalError: "Errore interno del server Web Api",
        webApiInvalidUser: "Utente server Web Api non valido",
        webApiNoLicenseAvailable: "Server Web Api server nessuna licenza disponibile",
        wrongDataSaved: "I dati non validi sono stati salvati in XML nella cartella  %{0} .",
        wrongHelpInput: "Formato errato dell'input %{0}",
        wrongRccVersion: "Per favore, controlla la versione del tuo RCC. Il tuo client Ã¨ compatibile solo con RCC %{0}."
    },
    footer: {
        aboutApplication: "Informazioni sull'applicazione",
        activeUser: "Utente attivo",
        logOut: "Logout",
        machineErrors: "Errore della macchina"
    },
    formulaProperties: {
        exterior: "Esterno",
        interior: "Interno",
        invalid: "Invalido",
        solvent: "A Solvente",
        universal: "Universali",
        water: "All'Acqua"
    },
    formulaSettings: {
        allUnits: "Tutte le unitÃ  disponibili nel database",
        allowCustomFormulas: "Consenti formule personalizzate",
        allowCustomPackageSize: "Consenti lattaggio personalizzato",
        allowFormulaAutomaticNaming: "Consenti la denominazione automatica",
        automaticNaming: "Formula di denominazione automatica",
        basePanelSize: "Imposta la dimensione del pannello della base",
        bippPanelSize: "Imposta la dimensione della base nel pannello della confezione del prodotto",
        blendColorNameAndCode: "Unisci Nome colore e Codice colore",
        buttonBellowMoreInfo: "Mostra il pulsante sotto le note della formula",
        buttonInColorantPanel: "Mostra il pulsante nel pannello Coloranti",
        colorCodePrimary: "Codice colore come primario",
        colorPanel: "Cartella Colori",
        colorPreviewAsImage: "Anteprima colore come immagine",
        colorPreviewResizable: "Anteprima del colore ridimensionabile",
        competitiveColorSearch: "Ricerca competitiva dei colori",
        customFormula: "Custom formula",
        customFormulaForMasterProduct: "Allow create custom formulas for master product",
        customFormulaForMasterProductDefault: "Checked by default",
        customFormulas: "Formule personalizzate",
        customPackageSettingsUnitGrav: "Impostazioni personalizzate dell'unitÃ  gravimetrica del formato",
        customPackageSettingsUnitVol: "Impostazioni personalizzate dell'unitÃ  volumetrica del formato",
        customPackageSize: "Formato personalizzato",
        customUnits: "Scegliere le unitÃ  personalizzate",
        dropDownCalculate: "Espandi il menu a discesa all'altezza della finestra",
        editColorants: "Modifica coloranti",
        editColorantsAllowed: "Consenti la modifica dei coloranti",
        fandeckPanelSize: "Imposta la dimensione del pannello della cartella colore",
        favoriteFormulas: "Formule preferite",
        formulaColorPreview: "Colore formula",
        formulaDataSettings: "Impostazioni dei dati della formula",
        formulaPanel: "Menu formula",
        formulaPanelSize: "Imposta la dimensione del pannello della formula",
        formulaSettings: "Impostazioni formula",
        generateColorPreview: "Genera un'anteprima del colore",
        gravimetricOnly: "Solo unitÃ  gravimetriche",
        hideAlternativeFormulas: "Nascondi formule alternative",
        hideFormulaProperties: "Nascondi ProprietÃ  formule",
        hideHistoricalFormulas: "Nascondi formule storiche",
        imagesLocal: "Usa solo l'immagine dal database locale",
        imagesOnline: "Prova prima ad aprire l'immagine online, se l'operazione fallisce, apri l'immagine locale",
        infoPanelResizable: "Pannello informativo ridimensionabile",
        numberOfColorants: "Number of shown colorants",
        orderByDistance: "Ordina i risultati della riceda per distanza",
        productDependent: "L'unitÃ  dipende dal prodotto selezionato",
        productFilesDialog: "Mostra la finestra di dialogo per aprire il file locale o il file online",
        productFilesLocal: "Usa solo i file di prodotto dal database locale",
        productFilesOnline:
            "Prova prima ad aprire il file di prodotto online, se l'operazione fallisce, apri il file locale",
        productPanelSize: "Imposta la dimensione del pannello del prodotto",
        searchPanelQuickSelect: "Selezione rapida",
        setAdditionalFormulaPanel: "Imposta il pannello delle formule aggiuntive",
        setCompetitiveColorSearch: "Abilita la ricerca competitiva dei colori",
        setInitialFormulaPanel: "Imposta il menu formula iniziale",
        setMaxToleranceForCompetitiveColors: "Imposta la tolleranza massima per la ricerca competitiva dei colori",
        setNumberOfCompetitiveColors: "Impostare il numero di colori competitivi",
        setSearchPanel: "Imposta pannello di ricerca",
        setVisibilityAndOrder: "Imposta la visibilitÃ  e l'ordine dei vari dati delle formule",
        setVisibleUnit: "Imposta le unitÃ  visibili",
        showColorPreview: "Mostra colore",
        showInFormulaStatusPanel: "Mostra nel Pannello Status della Formula",
        showInMoreInfoPanel: "Mostra nelle Note Formula",
        sorting: "Ordinamento del pannello colorante",
        useBase: "Utilizzare la voce di selezione per la base",
        useBaseInProductPackage: "Utilizza la voce di selezione per la base nella confezione del prodotto",
        useColorCode: "Usa Codice Colore",
        useColorName: "Usa Nome Colore",
        useFandeckGroups: "Usa i Brand Cartelle colori",
        useProduct: "Utilizza voce di selezione per prodotto",
        useProductCode: "Utilizza codice prodotto",
        useProductGroups: "Usa gruppi di prodotti",
        volumetricOnly: "Solo unitÃ  volumetriche"
    },
    general: {
        accepted: "Accettato",
        active: "Ultima attivitÃ ",
        actual: "Attuale",
        actualLevel: "Livello attuale",
        add: "Aggiungi",
        addColorant: "Aggiungi colorante",
        addColorantForPackage: "Aggiungi colorante per una confezione",
        addFile: "Aggiungi file",
        all: "Tutti",
        amount: "Quantita",
        applyNow: "Apply now",
        attachments: "Allegati",
        automaticCorrection: "Correzione Automatica",
        automatically: "Automaticamente",
        available: "Disponibile",
        back: "Indietro",
        base: "Base",
        baseInProductPackage: "Base del prodotto e confezione",
        batchNumber: "Numero di lotto",
        bottom: "In basso",
        buildingSite: "Cantiere",
        calculate: "Calcola",
        can: "Confezione",
        canSize: "Formato",
        cancel: "Annulla",
        canister: "Canestro",
        canisterId: "ID canestro",
        canisterIndex: "Indice del canestro",
        canisters: "Canestri",
        cap: "Tappo",
        capacity: "CapacitÃ ",
        channels: "Pompe",
        choose: "Scegliere",
        city: "CittÃ ",
        clean: "Pulire",
        clear: "Elimina",
        client: "Utente",
        close: "Chiudi",
        closeAll: "Chiudere tutto",
        collapseAll: "Comprimi tutto",
        color: "Colore",
        colorCode: "Codice Colore",
        colorFile: "Colorfile",
        colorName: "Nome del colore",
        colorPreview: "Anteprima colore",
        colorant: "Colorante",
        colorantBatchNumber: "Numero di lotto del colorante",
        colorantPackage: "Formato del colorante",
        colorants: "Coloranti",
        colors: "Colors",
        company: "Azienda",
        competitiveColor: "Colore Alternativo",
        confirm: "Conferma",
        confirmDeletion: "Vuoi davvero eliminare questa voce in modo permanente?",
        confirmHelpSettings: "Vuoi davvero salvare il modulo e lasciare i campi vuoti?",
        connect: "Collega",
        continue: "Continua",
        correction: "Correction",
        country: "Paese",
        created: "Creato",
        creationDateOf: "Data di creazione di",
        criticalLevel: "Livello critico",
        currency: "Valuta",
        currentBatchNumber: "Numero di lotto attuale",
        currentUfiCode: "Codice UFI attuale",
        custom: "Passa a STANDARD",
        customData: "Custom Data",
        customFandeck: "Mazzetta personale",
        customFormula: "Formula personalizzata",
        customPackage: "Altro",
        customPackageSettings: "Impostazioni personalizzate del formato",
        customer: "Cliente",
        customerVersion: "Versione cliente",
        customers: "Clienti",
        database: "Database",
        date: "Data",
        default: "Default",
        delete: "Elimina",
        deleteImportedData: "Delete imported records",
        delta: "Delta",
        description: "Descrizione",
        disconnect: "Disconnetti",
        discount: "Sconto",
        discover: "Ricerca",
        dispense: "Erogazione",
        dispensing: "Erogazione",
        doNotShowAgain: "Non mostrare piÃ¹ questo messaggio.",
        downloadingFile: "Scaricare i file",
        edit: "Modifica",
        email: "Email",
        enabled: "Abilitato",
        error: "Error",
        expandAll: "Espandi tutto",
        exportData: "Esportazione di dati",
        exportPdf: "Esportazione PDF",
        fan: "Mazzetta",
        fandeck: "Cartella colore",
        fandeckCode: "Fandeck Code",
        fandeckName: "Nome cartella colore",
        fandecks: "Cartelle colori",
        favorite: "Preferiti",
        fileTransfer: "Trasferimento di file",
        filling: "Riempimento",
        fillingDate: "Data di riempimento",
        find: "Trova",
        finish: "Finitura",
        finishedCorrection: "Finished Correction",
        formula: "Formula",
        formulas: "Formulas",
        frontdesk: "Frontdesk",
        getQrCode: "Leggi il codice QR",
        gravimetric: "Gravimetrico",
        historical: "Historical",
        history: "Storico",
        hours: "Ore",
        id: "Id",
        images: "Immagini",
        in: "In",
        index: "Indice",
        insertBarcode: "Inserisci il barcode",
        install: "Installare",
        installed: "Installato",
        instructions: "Istruzioni",
        internalNote: "Nota interna",
        interval: "Intervallo",
        ip: "Indirizzo IP",
        itemNumber: "Num.  Articolo",
        itemXOfY: "Item %{x}/%{y}",
        itemsCount: "NÂ° Elementi",
        later: "Later",
        limit: "Limite",
        load: "Carica",
        loadFormula: "Caricamento Della Formula",
        localVersion: "Versione locale",
        machine: "Tintometro",
        manualCorrection: "Correzione Manuale",
        manually: "Manualmente",
        margin: "Margine",
        markup: "Ricarico",
        matching: "Matching",
        matchingFormula: "Matching formula",
        maxLevel: "Massimo livello",
        maxValue: "Valore massimo",
        maximum: "Massimo",
        mayTakeAWhile: "This may take a while",
        measured: "Measured",
        metamarism: "Metamarism",
        minimum: "Minimo",
        minutes: "Min.",
        missingItem: "Elemento mancante",
        missingRequiredItems: "Tutte le voci richieste (contrassegnate da un asterisco) devono essere compilate",
        modified: "Modificato",
        modifiedAutomaticCorrection: "Target color correction",
        modifiedCustomFormula: "Formula personale modificata",
        modifiedStandardFormula: "Formula personale modificata",
        moduleChange: "Cambio modulo",
        more: "Altro",
        moreInfo: "Altre info",
        moveDown: "Abbassare",
        moveUp: "Alzare",
        myOrders: "I Miei Ordini",
        name: "Nome",
        nameTitle: "Nome",
        new: "Nuovo",
        next: "Avanti",
        no: "No",
        noColorantsAvailable: "Nessun colorante disponibile",
        noFormulas: "Ancora nessuna formula",
        noPricesAvailable: "Nessun prezzo disponibile",
        nominalAmount: "QuantitÃ  nominale",
        notAvailable: "Non disponibile",
        note: "Nota",
        numberOfCanisters: "Numero dei canestri",
        numberOfItemCount: "Number of '%{item}': %{count}",
        numberOfLabels: "Numero di etichette",
        numberOfPackages: "Numero di confezioni",
        off: "Spento",
        ok: "OK",
        on: "Acceso",
        onFocus: "A fuoco",
        open: "Aperto",
        operator: "Operatore",
        options: "Opzioni",
        order: "Order",
        other: "Altro",
        otherError: "Altro errore",
        out: "Fuori",
        overwrite: "Overwrite",
        package: "Formato",
        packagePreview: "Anteprima Formato",
        partialUpdates: "Aggiornamento incrementale",
        phone: "Telefono",
        pleaseWait: "Si prega di attendere",
        previous: "Precedente",
        price: "Prezzo",
        priceGroup: "Gruppo di prezzo",
        print: "Etichetta",
        printTask: "AttivitÃ  di stampa",
        processingStep: "Processing %{step}",
        product: "Prodotto",
        productCode: "Codice prodotto",
        productName: "Nome prodotto",
        products: "Prodotti",
        pump1: "Pompa 1",
        pump2: "Pompa 2",
        purchasePrice: "Prezzo d'acquisto",
        purge: "Spurga",
        qualityControl: "Controllo QualitÃ ",
        quantity: "QuantitÃ ",
        quantityQty: "QTY",
        quickTint: "Erogazione Veloce",
        rccIsNotAvailable: "Rcc Non Ã¨ Disponibile",
        rccIsNotConnected: "Rcc Non Ã¨ Connesso",
        rccNotLicensed: "RCC non licenziato",
        reconnect: "Ricollegare",
        refill: "Riempi",
        refillManualLevelCorrection: "Correzione manuale",
        reformulation: "Reformulation",
        reloadTab: "Reload Tab",
        reset: "Ripristina",
        restart: "Riavvia",
        restore: "Ripristinare",
        retint: "Eroga Nuovamente",
        revision: "Revisione",
        safetySheet: "Scheda di sicurezza",
        save: "Salva",
        saveAs: "Salva come",
        saveToDispensingHistory: "Salva nella cronologia",
        searchResult: "Risultato della ricerca",
        searching: "Cercando",
        seconds: "Sec.",
        select: "Select",
        selectAll: "Seleziona tutto",
        selectChannels: "Selezionare i circuiti",
        selectColumns: "Select columns to work with",
        selectXFirst: "Seleziona Prima %{item}",
        sellPrice: "Prezzo di vendita",
        settings: "Impostazioni",
        shelf: "Piano",
        showItem: "Show %{item}",
        showOptions: "Show another options",
        size: "Dimensione",
        skip: "Salta",
        smartPurge: "Spurgo intelligente",
        softwareRestartInSeconds: "%{software} will be automatically restarted in %{seconds} seconds",
        sortResults: "Ordina Risultati",
        spectro: "Ricerca Strumentale",
        standardFormula: "Standard Formula",
        status: "Stato",
        street: "Via",
        sum: "Sum",
        summary: "Riassunto",
        sync: "Sync",
        technicalSheet: "Scheda tecnica",
        templates: "Modelli",
        threshold: "Soglia",
        ticketing: "Ticketing",
        tintometricSystem: "Sistema Tintometrico",
        toDispenseOrders: "Ordini da erogare",
        top: "Top",
        total: "Totale",
        totalAmount: "Quantita totale",
        totalBaseAmount: "QuantitÃ  totale della base",
        totalColorantAmount: "QuantitÃ  totale del colorante",
        type: "Tipo",
        ufiCode: "Codice UFI attuale",
        ufiThreshold: "Soglia UFI",
        unableToSynchronize: "Unable to synchronize",
        undefined: "Non Definito",
        unit: "UnitÃ ",
        units: "Le unitÃ ",
        unknown: "Unknown",
        update: "Aggiornamento",
        updated: "Aggiornato",
        user: "Utente",
        value: "Volre",
        vat: "IVA",
        verified: "Verificata",
        version: "Versione",
        versionId: "Versione ID",
        versionStructure: "Struttura della versione",
        volumetric: "Volumetrico",
        warning: "Attenzione",
        warningLevel: "Livello critico",
        withoutName: "(senza nome)",
        workingProperly: "Working properly",
        yes: "Si",
        zoom: "Zoom"
    },
    help: {
        autotasks: {
            brushMaintenance:
                "Imposta questo autotask per far sÃ¬ che %{name} richieda l'azione di pulizia del contenitore delle spazzole automaticamente al momento definito. L'operatore del tintometro deve rimuovere, pulire e poi restituire il contenitore delle spazzole manualmente.",
            capMaintenance:
                "Impostare questo autotask per far sÃ¬ che %{name} richieda l'azione di pulizia del tappo automaticamente al momento definito. L'operatore del tintometro deve pulire manualmente il tappo automatico dopo la sua apertura.",
            cleanAll:
                "Impostare questo autotask per fare in modo che l'erogatore esegua l'azione di pulizia di tutti i canali automaticamente al momento definito.",
            cleanChannels:
                "Impostare questo autotask per fare in modo che l'erogatore esegua l'azione di pulizia dei canali specifici automaticamente all'orario definito.",
            computerReboot:
                "Imposta questo autotask per far sÃ¬ che il computer venga riavviato automaticamente all'orario definito.",
            computerShutdown:
                "Imposta questa attivitÃ  automatica per far sÃ¬ che il computer si spenga automaticamente all'orario definito.",
            dispenserCleaning:
                "Impostare questo autotask per far sÃ¬ che %{name} richieda l'azione di pulizia dell'erogatore automaticamente al momento definito. L'operatore dell'erogatore deve pulire manualmente la macchina con un panno.",
            humidifierWaterLevelMaintenance:
                "Impostare questo autotask per far sÃ¬ che %{name} richieda l'azione di riempimento dell'umidificatore automaticamente al momento definito. L'operatore dell'erogatore deve controllare e riempire manualmente l'acqua nell'umidificatore.",
            purgeAll:
                "Impostare questo autotask per far sÃ¬ che l'erogatore esegua l'azione di spurgo di tutti i canali automaticamente al momento definito.",
            purgeChannels:
                "Impostare questo autotask per far sÃ¬ che l'erogatore esegua l'azione di spurgo di canali specifici automaticamente al momento definito.",
            recirculateAll:
                "Impostare questo autotask per far sÃ¬ che l'erogatore esegua l'azione di ricircolo di tutti i canali automaticamente al momento definito.",
            recirculateChannels:
                "Impostare questo autotask per far sÃ¬ che l'erogatore esegua l'azione di ricircolo di canali specifici automaticamente al momento definito.",
            refillAll:
                "Imposta questo autotask per far sÃ¬ che %{name} richieda l'azione di riempimento automatico di tutti i circuiti al momento definito. Il Tintometrista deve ricaricare manualmente i coloranti in tutti i canestri.",
            refillCanisters:
                "Impostare questo autotask per far sÃ¬ che %{name} richieda l'azione di riempimento automatico di circuiti specifici al momento definito. Il Tintometrista deve riempire manualmente i coloranti nei canestri che non soddisfano il criterio di riempimento.",
            smartPurgeAll:
                "Impostare questo autotask per far sÃ¬ che l'erogatore esegua l'azione di spurgo intelligente di tutti i canali automaticamente al momento definito. Lo spurgo verrÃ  eseguito a meno che le regole di spurgo intelligente non siano soddisfatte.",
            smartPurgeChannels:
                "Impostare questo autotask per far sÃ¬ che l'erogatore esegua l'azione di spurgo intelligente di canali specifici automaticamente al momento definito. Lo spurgo verrÃ  eseguito a meno che le regole di spurgo intelligente non siano soddisfatte.",
            stirAll:
                "Impostare questo autotask per fare in modo che l'erogatore richieda l'azione di mescolamento di tutti i canali automaticamente al momento definito.",
            stirCanisters:
                "Impostare questo autotask per fare in modo che l'erogatore richieda l'azione per mescolare i canali specifici automaticamente al momento definito.",
            switchPlateMaintenance:
                "Impostare questo autotask per far sÃ¬ che %{name} richieda l'azione di pulizia della piastra di commutazione automaticamente al momento definito. L'operatore del tintometro deve rimuovere, pulire e poi restituire la piastra di commutazione manualmente."
        },
        colorantBatchNumber: {
            batchNumberByPercentage:
                "Il numero di lotto che prevale viene utilizzato per la stampa considerando la quantitÃ  effettiva nel Canestro. Recarsi alle impostazioni del Canestro per definire la soglia per ogni Canestro.",
            batchNumberFromLastFilling:
                "Il lotto dell'ultima ricarica indicato dall'operatore viene utilizzato per la stampa, indipendentemente dalla quantitÃ  ricaricata.",
            enableBatchNumber: "Con questa impostazione attivata, i lotti di colorante ricaricati sono tracciati."
        },
        connection: {
            add: "Consenti di aggiungere un nuovo server manualmente se non puÃ² essere rilevato tramite la funzione Discover.",
            clientIdentifier:
                "L'impostazione permette di identificare questo client se ci sono piÃ¹ client collegati a un server.",
            disconnect:
                "Informazioni sul server attualmente utilizzato. Il pulsante di disconnessione permette di disconnettere questo server e passare ad un altro se disponibile.",
            discover: "Scopri se ci sono altri server disponibili nella rete.",
            dropServers: "Elimina dall'elenco tutti i server precedentemente rilevati.",
            dropServersNotAvailable: "Nessun server disponibile",
            edit: "Consenti di modificare manualmente un server giÃ  trovato.",
            editDisabled: "Nessun server selezionato."
        },
        continue: "Vuoi davvero continuare?",
        driverSettings: {
            alfaRestApi: {
                host: "Digitare il nome host del computer o l'indirizzo IP del computer.",
                machineType: "Valido per tutte le macchine Alfa. Sia Windows che Linux."
            },
            corobDsProxy: {
                machineType:
                    "Valido per le generazioni Slave (D200, D600..), 4G (First One) e 5G (EvoFlx). DspProxy deve essere installato. Solo per Windows."
            },
            corobEvoDriver: {
                machineType:
                    "Valido per la generazione 5G (EvoFlx). EVOservice deve essere installato. Sia Windows che Linux."
            },
            corobFlex500LLD: {
                dispenserConfigurationFile:
                    "Selezionare il file di configurazione dell'erogatore. Preimpostato di default.",
                hldRootDir: "Selezionare la cartella principale di HLD. Preimpostazione predefinita.",
                machineType:
                    "Valid for Corob Flex (500, 520, 540) = former Lenteq. HLD must be installed. Windows only."
            },
            corobNextDriver: {
                machineType:
                    "Valido per le generazioni Slave (D200, D600..), 4G (First One) e 5G (EvoFlx). NextDriver deve essere installato. Solo Linux."
            },
            dromontDDrv: {
                databasePath: "Percorso del file del database con i dati di calibrazione. Preimpostato di default.",
                driverPath: "Percorso al driver (D_DRV.exe). Preimpostato di default.",
                machineType:
                    "Indirect Dispenser Communication Via Set Paths. Valid For Generations V1 And V2. D_Set Must Be Installed. Windows As Well As Linux.",
                resultPath:
                    "Comunicazione indiretta dell'erogatore tramite percorsi impostati. Valido per le generazioni V1 e V2. D_SET devono essere installati. Sia per Windows che per Linux.",
                serviceSoftwarePath:
                    "Percorso del file dei risultati creato al termine dell'operazione. Preimpostato di default."
            },
            dromontDirect: {
                machineType: "Percorso al software di servizio Dromont (D_SET.exe). Pre-impostazione di default.",
                rootDir:
                    "Comunicazione diretta con l'erogatore. Valido per le generazioni V1 e V2. D_SET devono essere installati. Windows e Linux."
            },
            dromontMisura: {
                driverPath: "Selezionare la cartella principale Dromont",
                extensionPath:
                    "Il percorso del driver (MisuraRetail.exe) potrebbe cambiare in base alla versione di Misura Retail. Preimpostato di default.",
                formulaPath: "Percorso al file di comunicazione per le azioni di servizio.",
                machineType: "Percorso al file di comunicazione per l'erogazione."
            },
            fastAndFluidIDD: {
                machineType: "Valido per la generazione V3. Dromont Misura deve essere installato. Solo per Windows.",
                path: "Valido per tutte le macchine F&F. Solo Windows."
            },
            fastAndFluidUIDD: {
                host: "Type in the computer host name or computer IP address.",
                machineType: "Valido per tutte le macchine F&F. Windows e Linux.",
                password: "Type in the user password.",
                port: "Select the port number.",
                user: "Type in the user name."
            },
            heroPCPDriver: {
                machineType: "Valido per tutte le macchine Hero. Solo Windows."
            },
            italtinto: {
                machineType:
                    "Valido per tutte le macchine Italtinto. Deve essere installato Wcal o ItaltintoCal. Solo Windows.",
                path: "Percorso al file di configurazione Italtinto regolato."
            },
            manualAdvanced: {
                machineType: "Valido per tutte le macchine manuali, supporto canestri incluso. Sia Windows che Linux.",
                path: "Percorso al file di configurazione con i dati dell'erogatore e dei canestri"
            },
            manualSimple: {
                machineType: "Valido per tutte le macchine manuali. Windows e Linux.",
                path: "Percorso file di configurazione con i dati tintometro."
            },
            none: {
                machineType: "Nessun driver tintometro Ã¨ selezionato."
            },
            santintColorLink3: {
                machineType: "Valido per tutte le macchine Santint. Solo Windows."
            },
            simulation: {
                machineType:
                    "Valido per la simulazione del tintometro se non c'Ã¨ un tintometro reale collegato al computer.",
                path: "Percorso del file di configurazione della simulazione che deve essere in accordo con il database inserito."
            },
            udcp: {
                machineType: "Tintometro UDCP"
            }
        },
        environment: {
            activeServerPlugins: "Panoramica dei plugin software aggiuntivi.",
            allowAutoCloseTab:
                "Con l'impostazione attivata, ogni scheda della formula verrÃ  chiusa automaticamente al termine del processo di erogazione.",
            allowAutomaticClientStart:
                "Con questa impostazione attivata, %{name} si avvia automaticamente dopo l'avvio del computer",
            allowAutomaticPrint:
                "L'etichetta verrÃ  stampata automaticamente. Richiede ulteriori impostazioni sulla stampa prima dell'erogazione, dopo l'erogazione o entrambe.",
            allowBuildingSitePanel: "La sezione Cantiere sarÃ  accessibile nel pannello Formula",
            allowCustomers: "La sezione clienti sarÃ  accessibile nel panello della Formula.",
            allowDispensing: "Nel pannello Formula, verrÃ  attivato il pulsante Erogazione.",
            allowFileTransfer:
                "Con questa impostazione attivata, sono disponibili l'importazione e l'esportazione automatica dei dati tramite trasferimento di file.",
            allowFormulaModificationPanel: "Sul pannello delle formule, verrÃ  attivato il pannello di modifica.",
            allowFormulaStatusPanel: "Su Formula Panel, viene attivato il pannello di stato.",
            allowLight: "%{name} sarÃ  accessibile..",
            allowOrdering: "Nel pannello Formula, verrÃ  attivato il pulsante Ordine.",
            allowPricing:
                "Nel pannello Formula, i prezzi possono essere utilizzati. La visibilitÃ  dei prezzi Ã¨ impostata in Prezzi disponibili. I prezzi sono impostati in Impostazioni prezzi.",
            allowProductPreviewImage: "L'immagine del prodotto verrÃ  mostrata durante l'erogazione.",
            allowQualityControl: "Controllo QualitÃ  sarÃ  attivato.",
            allowSearchCheaperColors:
                "Su Formula Panel, la funzione di ricerca dei colori piÃ¹ economici sarÃ  disponibile.",
            allowSoundNotification:
                "La notifica dell'ordine riprodurrÃ  una melodia musicale quando viene ricevuto un ordine.",
            allowSpectro: "La sezione Spettro sarÃ  accessibile.",
            allowTabs: "Con questa impostazione attivata, Ã¨ possibile lavorare con piÃ¹ schede contemporaneamente.",
            applyZoom:
                "Lo zoom ingrandisce o riduce la risoluzione. Sono applicabili anche le scorciatoie da tastiera CTRL + e CTRL -.",
            automaticLogout: "Imposta dopo quanti minuti deve essere attivato il logout automatico.",
            availableDatabases:
                "Le impostazioni permettono di passare da un database all'altro se ce n'Ã¨ piÃ¹ di uno disponibile.",
            backupLocalDB: "Exports The Local Databse. The Exported File Can Be Used As Database Backup.",
            barcodeTesting:
                "L'ambiente di test dei codici a barre serve a verificare la correttezza del codice a barre scansionato confrontandolo con i codici a barre inseriti nel database.",
            customBanner: "Imposta il tuo logo o banner e la sua posizione.",
            customCurrencyFormat:
                "Il formato di valuta personalizzato puÃ² sovrascrivere il formato di valuta predefinito in base alla lingua selezionata.",
            customDateFormat:
                "Il formato di data personalizzato puÃ² sovrascrivere il formato di data predefinito in base alla lingua selezionata.",
            customNumberFormat:
                "Il formato numerico personalizzato puÃ² sovrascrivere il formato numerico predefinito in base alla lingua selezionata.",
            customTimeFormat:
                "Il formato orario personalizzato puÃ² sovrascrivere il formato orario predefinito in base alla lingua selezionata.",
            defaultPrinter:
                "La stampante selezionata verrÃ  utilizzata per la stampa di etichette, a meno che non venga modificata nella finestra delle opzioni della stampante.",
            defaultTemplate:
                "Il modello selezionato verrÃ  utilizzato per la stampa di etichette, a meno che non venga modificato nella finestra delle opzioni della stampante.",
            deleteImportedData:
                "Elimina i dati personalizzati precedentemente importati. I dati possono essere importati di nuovo dopo l'eliminazione.",
            diskSpaceNotification: "Controlla lo spazio disponibile su disco e avvisa in caso di spazio insufficiente.",
            dispensingNotes: "La sezione delle note di erogazione sarÃ  accessibile  sul pannello Formula",
            downloadListEmpty: "Nessun download in corso",
            enableVirtualKeyboard: "In %{name}, la tastiera virtuale sarÃ  disponibile.",
            exportLocalSettings: "Esporta le impostazioni locali di questo computer.",
            exportStaticSql:
                "Esporta le impostazioni locali di questo computer. Il file esportato puÃ² essere utilizzato per creare un database con questa impostazione.",
            exportTranslationKeys:
                "Esporta le traduzioni piÃ¹ recenti e dopo averle tradotte, inviale via e-mail al tuo fornitore di software per farle importare.",
            favoriteButton: "Clicca per aggiungere la formula come preferita",
            formulaNotes: "La sezione note formula sarÃ  accessibile nel pannello Formula.",
            helpSettings: "Le informazioni sono visibili nella sezione Aiuto del pannello di accesso rapido.",
            importCustomData: "Importa i dati personalizzati locali basati sul formato selezionato.",
            importExcelFile: "Import the excel file with data to be added to database.",
            importsLocalSettings: "Importa le impostazioni locali di questo computer.",
            internalNote: "La sezione delle note interne sarÃ  accessibile nel pannello Formula.",
            lockComputer:
                "Le impostazioni assicurano che l'ambiente di %{name} non possa essere lasciato - permette l'esperienza definitiva della modalitÃ  kiosk. Applicabile solo per Windows.",
            maxNumberTabs: "Imposta il numero di schede formula che possono essere aperte simultaneamente.",
            memoryTabs: "Consenti la riapertura delle schede aperte di recente dopo l'avvio del software.",
            printAfterDispensing:
                "L'impostazione richiede informazioni sul numero di copie dell'etichetta da stampare dopo il processo di erogazione.",
            printAsImage:
                "Stampa come immagine aiuta a risolvere i problemi quando la stampa standard non funziona. Non usatelo quando la stampa standard funziona correttamente. Compatibile solo con Linux.",
            printBeforeDispensing:
                "L'impostazione richiede informazioni sul numero di copie dell'etichetta da stampare prima del processo di erogazione.",
            printEnabled:
                "Questa impostazione consente di utilizzare la stampante con il software. Ulteriori impostazioni sono in Impostazioni di stampa.",
            printOnRequest: "Nel pannello Formula, verrÃ  attivato il pulsante Stampa .",
            printTaskVariable:
                "L'operazione di stampa viene elaborata solo se la variabile di stampa data Ã¨ disponibile nei dati di stampa",
            quickTintTemplate:
                "Il modello selezionato verrÃ  utilizzato per la stampa di etichette a Erogazione Veloce.",
            restoreLocalSettings: "Ripristina le impostazioni locali di questo computer.",
            runLightAtStartUp: "%{light} sarÃ  avviato al posto di %{name}.",
            screenSaverTimeout: "Impostare dopo quanti minuti lo screensaver deve essere attivato.",
            selectCustomDataFormat:
                "Seleziona il formato dei dati originali da importare. Ogni formato potrebbe richiedere diversi impostazioni e file aggiuntivi.",
            setCustomHomeButton: "Il pulsante Home in %{name} reindirizzerÃ  al pannello selezionato.",
            setFts: "La ricerca full-text permette la ricerca della formula full-text (anche dalla metÃ  della parola, ecc.).",
            setKeyboardShortcuts: "Non Ã¨ possibile impostare la stessa scorciatoia da tastiera per due azioni diverse.",
            setNumberOfDecimalPlaces: "Imposta il numero di cifre decimali dei coloranti utilizzati nella formula.",
            setOrderSearchParameters:
                "La ricerca ordini definisce quali parametri vengono utilizzati per la ricerca tra gli ordini. Accessibile solo in %{name}.",
            setOverwriteLastTab:
                "Quando si sceglie una nuova formula tramite la ricerca globale mentre il limite della scheda della formula Ã¨ raggiunto, l'ultima scheda della formula caricata sarÃ  sovrascritta dalla selezione della nuova formula.",
            setSearchPanel:
                "Imposta la visibilitÃ  e l'ordine degli elementi utilizzati quando cerchi una nuova formula.",
            setVisibilityAndOrder:
                "Le voci di navigazione selezionate saranno visibili nel pannello di accesso rapido. La posizione piÃ¹ alta definisce la posizione piÃ¹ a sinistra nel pannello. La quantitÃ  massima con elementi di navigazione Ã¨ 6.",
            setYourLanguage: "Il cambio di lingua richiede il riavvio del software.",
            settingsSearch: "Se non si trovano alcuni impostazioni, cercare nelle impostazioni generali",
            showNewOrderNotifications:
                "La notifica dell'ordine Ã¨ una finestra pop-up che annuncia la ricezione di un nuovo ordine.",
            sorting: "La tinta rapida puÃ² avere i canestri ordinati secondo i nomi dei coloranti o per ID canestro.",
            turnOnKioskMode: "La modalitÃ  Kiosk nasconde la barra delle applicazioni.",
            windowClosingRules:
                "L'impostazione decide se la finestra della tinta rapida si chiude prima o dopo l'inizio del processo di erogazione."
        },
        formulaSettings: {
            additionalFormulaTab:
                "L'impostazione decide quale pannello verrÃ  mostrato all'apertura di una nuova scheda formula.",
            allowCustomFormulas: "VerrÃ  attivata la creazione e la ricerca di formule personalizzate.",
            allowCustomPackageSize:
                "Nel pannello Formula, verrÃ  attivata l'opzione dimensione confezione personalizzato.",
            allowEditingColorants:
                "Nel pannello Formula, verrÃ  attivato il pulsante Modifica colorante (visibile dopo aver selezionato un colore).",
            alternativeFormulasPosition: "Definisce come accedere a formule alternative.",
            basePanelSize: "Imposta la dimensione della base sul pannello della Formula",
            bippPanelSize:
                "Impostare la dimensione della base nella confezione del prodotto nel pannello della Formula",
            blendColorNameAndCode:
                "L'impostazione unisce i campi di ricerca per il nome e il codice del colore per creare un solo campo di ricerca.",
            color: "Nel pannello Formula, l'anteprima del colore sarÃ  l'unica informazione visibile.",
            colorCodePrimary: "Il codice colore verrÃ  visualizzato per primo nel campo di ricerca.",
            colorPreviewAsImage:
                "Sul pannello della Formula, l'anteprima del colore sarÃ  rappresentata da un'immagine.",
            colorPreviewResizable: "Consenti di ridimensionare il pannello di anteprima dei colori.",
            colorantPanelLimit:
                "The settings sets the number of colorants that will be always visible before it hides under scroll bar.",
            colorantPanelOrderBy:
                "Il pannello della Formula puÃ² avere i coloranti ordinati in base ai nomi o alle quantitÃ .",
            customCanOption:
                "Scegliere quali unitÃ  di misura possono essere usate per le dimensioni personalizzate delle confezioni nel pannello della Formula.",
            customCanSettingsUnit:
                "Scegliere quale unitÃ  di misura puÃ² essere usata come predefinita per le impostazioni del pacchetto personalizzato sul pannello Formula.",
            customFormulaForMasterProduct:
                "Defines whether the option âFormula for master productâ is displayed when saving custom formula",
            customFormulaForMasterProductDefault:
                "Defines whether the option âFormula for master productâ is checked by default",
            deleteConfirmation:
                "Abilitando questa impostazione, si apriranno dei pop-up per confermare l'eliminazione di un elemento.",
            dropDownCalculate:
                "Il menu a tendina per selezionare la formula desiderata si estenderÃ  fino al fondo della finestra.",
            fandeckGroups:
                "L'impostazione abilita la gerarchia con i Brand Cartella colori,se disponibili nel database.",
            fandeckPanelSize: "Imposta la dimensione della cartella colore sul pannello della formula",
            favoriteFormulasInitial: "Quando si avvia %{name}, apparirÃ  il pannello Preferiti.",
            formulaAutomaticNaming:
                "Una formula modificata sarÃ  nominata automaticamente in base alle modifiche eseguite sul colorante.",
            formulaPanel: "Quando si apre una nuova scheda, apparirÃ  il pannello Formula.",
            formulaPanelInitial: "Quando si avvia %{name}, apparirÃ  il pannello Formula.",
            formulaPanelSize: "Imposta la dimensione della formula sul pannello della Formula",
            formulaPropertiesPosition: "Definisce come accedere alle proprietÃ  della formula.",
            generateColorPreview:
                "Con questa impostazione attivata, l'anteprima dei colori viene generata automaticamente. L'anteprima risultante non Ã¨ accurata.",
            historicalFormulasPosition: "Defines How To Access Historical Formulas.",
            image: "Nel pannello Formula, l'immagine del prodotto sarÃ  visibile accanto all'anteprima del colore con la possibilitÃ  di aprire il pannello con maggiori informazioni.",
            images: "L'impostazione definisce la fonte dei file di immagine.",
            infoPanelResizable: "Consenti di ridimensionare piÃ¹ pannelli informativi.",
            initialFormulaTab: "L'impostazione decide quale pannello verrÃ  mostrato dopo l'avvio di %{0}.",
            moreInfo:
                "Nel pannello Formula, il pannello informazioni sarÃ  visibile accanto all'anteprima colore e all'anteprima immagine del prodotto.",
            orderByDistance:
                "Con questa impostazione attivata, il risultato della ricerca del colore Ã¨ ordinato per metrica di distanza speciale.",
            productCode:
                "L'impostazione permette di utilizzare i codici dei prodotti insieme ai nomi dei prodotti se disponibili nel database.",
            productFiles:
                "L'impostazione definisce la fonte dei file dei prodotti che sono disponibili nel pannello Formula.",
            productGroups: "L'impostazione abilita la gerarchia con i gruppi di prodotti se disponibili nel database.",
            productPanelSize: "Imposta la dimensione del prodotto nel pannello Formula",
            searchNewFormula:
                "Quando si apre una nuova scheda, apparirÃ  Ricerca nuova formula (contiene informazioni sulle ultime formule dispensate e sulle formule preferite).",
            searchNewFormulaInitial:
                "Quando si avvia %{name}, apparirÃ  Ricerca nuova formula (contiene informazioni sulle ultime formule dispensate e sulle formule preferite).",
            searchPanelFormulaItems: "Almeno uno degli elementi della formula deve essere selezionato.",
            searchPanelProductItems: "PuÃ² essere selezionato solo uno degli elementi del prodotto.",
            searchPanelQuickSelect:
                "Non c'Ã¨ bisogno di premere il pulsante carica formula. Sarai reindirizzato direttamente alla scheda formula principale subito dopo la selezione della formula.",
            setCompetitiveColorSearch:
                "Con questa impostazione attivata, Ã¨ disponibile la funzione di ricerca competitiva dei colori nella Cartella Colori e nel pannello della Formula (solo per le formule non disponibili).",
            setFormulaInfoInPreview:
                "Nel pannello della Formula, il tipo di dati selezionato sarÃ  sempre visibile nell'anteprima del colore.",
            setFormulaPreview:
                "L'impostazione cambia la posizione e la visualizzazione dell'anteprima del colore, dell'immagine della confezione e dei dati informativi sul colore.",
            setFormulaRGBPreviewVisibleInformation:
                "Nel pannello Formula, il tipo di dati selezionato sarÃ  sempre visibile in anteprima colori.",
            setFormulaUnit:
                "Nel pannello Formula, questa impostazione decide quale unitÃ  colorante viene aperta per prima dopo aver selezionato un colore. Applicabile anche in tinta rapida.",
            setFormulaVisibilityAndOrder:
                "Nel pannello Formula, i dati selezionati saranno visibili nella sezione Maggiori informazioni (applicabile solo se l'anteprima formula Ã¨ settata su immagine o Maggiori informazioni).",
            setMaxToleranceForCompetitiveColors:
                "Impostare la tolleranza massima Delta E (CIA 2000) per la ricerca competitiva dei colori.",
            setNumberOfCompetitiveColors:
                "Definisci quanti colori competitivi dovrebbero essere visualizzati dopo la ricerca.",
            setVisibleUnit:
                "Nel pannello Formula, questa impostazione decide quali unitÃ  di colore sono visibili dopo aver selezionato un colore. Applicabile anche in Tinta Rapida.",
            showColorPreview:
                "Nel pannello Formula, mostra una piccola anteprima del colore accanto al nome del colore quando si cerca una nuova formula.",
            showSiblingProducts:
                "Defines whether the option âShow sibling productsâ is displayed when saving custom formula",
            useColorCode: "On Formula Panel, Shows The Information About Color Code."
        },
        formulaValidation: {
            batchNumberInvalid: "Canister (%{colorants}) is filled with a defective batch of colorant.",
            batchNumberWarning: "Il colorante (%{colorants}) con questo numero di lotto potrebbe essere danneggiato.",
            bellowBaseLimit: "La somma delle quantitÃ  di colorante Ã¨ inferiore al limite di base.",
            checkColorantBaseRules: "The Setting Checks If Used Colorants And Base Can Be Used In This Combination.",
            checkMinDosableAmount:
                "La quantitÃ  minima di tinta Ã¨ la piÃ¹ piccola quantitÃ  di colorante che puÃ² essere erogata come raccomandato dal laboratorio.",
            checkOverfill:
                "L'impostazione controlla se c'Ã¨ abbastanza spazio nel Canestro per i coloranti subito dopo aver impostato le quantitÃ .",
            checkTotalCntAmounts:
                "L'impostazione controlla se i limiti per le quantitÃ  minime e massime di colorante nella confezione base del prodotto sono stati superati. Questi limiti sono definiti nel database.",
            colorantBaseRules: "Colorant Is Not Valid For Selected Base.",
            colorantMinAmount: "La quantitÃ  di colorante Ã¨ inferiore alla quantitÃ  minima di tinta.",
            dispensingWithErrorsEnabled:
                "Se consentito, apparirÃ  un messaggio di avviso in caso di violazioni di convalida, ma sarÃ  comunque possibile procedere all'erogazione.",
            invalidBatchNumber: "Il colorante ha un numero di lotto non valido o difettoso",
            overBaseLimit: "La somma delle quantitÃ  di colorante Ã¨ superiore alla quantitÃ  massima di tinta.",
            overfill: "Ã stato rilevato un riempimento eccessivo.",
            unifyColorantBatchForMultipleCans:
                "If Allowed, An Info Refill To Max Modal Will Appear When Amount Of Colorant Is Bigger Than Maximum Of Canister And Canister Is Not Filled On Maximum Level.",
            warningConfirmBtn: "Ho valutato i rischi, Continua"
        },
        help: "Aiuto",
        helpLink: "Centro assistenza",
        helper: {
            automaticallyCheckForUpdates:
                "VerrÃ  controllato automaticamente se c'Ã¨ qualche aggiornamento disponibile per %{name} o database nell'intervallo di tempo dato.",
            automaticallyDownloadUpdates:
                "Se un aggiornamento Ã¨ disponibile, sarÃ  scaricato automaticamente senza dover confermare.",
            automaticallyInstallNewDatabases:
                "Se viene inviato un DB finora assente, verrÃ  installato come un nuovo DB. In seguito, il DB puÃ² essere utilizzato.",
            automaticallyInstallUpdates:
                "Se un aggiornamento Ã¨ stato scaricato, verrÃ  installato automaticamente senza dover confermare.",
            canBrowseChangeLog:
                "Quando si aggiorna il software, il registro ufficiale delle modifiche %{name} sarÃ  disponibile per la visualizzazione.",
            forceInstall: "VerrÃ  forzato l'installazione dell'aggiornamento.",
            installDuringNight: "L'aggiornamento verrÃ  installato durante la notte se il computer Ã¨ in funzione."
        },
        licensing: {
            collect:
                "I file di registro saranno scaricati nella posizione selezionata. I file di registro sono richiesti dal software fornito per l'analisi dei bug.",
            company: "La societÃ  che ha fornito la licenza.",
            computerID:
                "Identificazione della licenza per aiutare il fornitore del software in caso di assistenza necessaria.",
            email: "L'indirizzo email del titolare della licenza.",
            licenseUuid: "Identificazione della licenza per aiutare il fornitore del software in caso di assistenza.",
            name: "Il nome del titolare della licenza.",
            openBugreport:
                "Per favore fateci sapere se c'Ã¨ un bug nel software e inviateci un rapporto con la descrizione del bug.",
            posInfoContactperson: "Informazioni POS sul proprietario da stampare sull'etichetta.",
            posInfoMachineInformation:
                "Informazioni POS sull'erogatore da stampare sull'etichetta o da riconoscere nella rete.",
            posInfoPos: "Informazioni POS sulla posizione da stampare sull'etichetta.",
            reactivation: "Riattivazione o modifica della licenza corrente.",
            refresh: "Scarica le informazioni piÃ¹ recenti sulla licenza.",
            refreshUnavailable: "Aggiornamento della licenza non disponibile perchÃ© sei offline.",
            registrationContactperson: "Informazioni di registrazione per identificare il proprietario della licenza.",
            registrationMachineInformation: "Informazioni di registrazione per identificare la del tintometro.",
            registrationPos: "Informazioni di registrazione per identificare la posizione della licenza.",
            versionScope: "I limiti di scadenza del software.",
            versionType: "Il tipo di prodotto software."
        },
        machineIsBusy: "Gli errori non possono essere resettati perchÃ© la macchina Ã¨ occupata.",
        machineSettings: {
            allowManualColorantAddition:
                "Se la quantitÃ  di colorante richiesta supera la quantitÃ  massima erogata, l'impostazione consente di aggiungerla manualmente dopo l'erogazione.",
            autotasks:
                "Gli Autotask sono eventi di manutenzione automatica della macchina e del computer che possono essere impostati per essere eseguiti in un determinato momento o intervallo di tempo.",
            barcodeRefillValidation: "L'impostazione attiva la convalida del codice a barre durante la ricarica.",
            barcodeRefillValidationBaseAndColorant:
                "Il controllo del codice a barre viene eseguito durante la ricarica della tanica e della confezione di colorante.",
            barcodeRefillValidationColorant:
                "Il controllo del codice a barre viene eseguito durante la ricarica della tanica del colorante.",
            canisterBarcode:
                "Il codice a barre viene assegnato alla tanica in cui Ã¨ disponibile il colorante. Il codice a barre Ã¨ necessario per garantire la corretta ricarica del colorante.",
            checkCanBeforeDispense: "L'impostazione Ã¨ valida solo per la simulazione Fast & Fluid.",
            checkOverfill: "L'impostazione controlla se c'Ã¨ abbastanza colorante nei canestri prima dell'erogazione.",
            currentlySelectedMachine: "Fornisce informazioni sulla macchina attualmente selezionata.",
            dispenseInvalidColorants:
                "L'impostazione permette di erogare coloranti che non sono definiti nella configurazione della macchina richiedendo l'aggiunta manuale del colorante.",
            dispenserConfigurationBackup:
                "Scarica e salva la configurazione attuale della macchina per mantenere un backup.",
            dispensingLogic:
                "I tipi di logica di erogazione possono garantire un comportamento diverso per ogni tanica quando c'Ã¨ piÃ¹ colorante da erogare di quanto consentito o desiderato. Il comportamento aggiuntivo Ã¨ impostato in Dispensing Settings.",
            enableTmc: "L'impostazione consente di inviare dati a TMC.",
            enableUserIdentification: "L'utente deve effettuare l'accesso prima che sia consentita l'erogazione.",
            machineUnit: "L'unitÃ  macchina definisce l'unitÃ  di misura dei coloranti nei canestri.",
            minDispensedAmount:
                "La quantitÃ  minima erogata stabilisce quanto colorante deve essere stato erogato per considerare lo spurgo fatto (per evitare ulteriori spurghi).",
            minimalDispenseAmount:
                "La quantitÃ  minima erogabile Ã¨ la piÃ¹ piccola quantitÃ  di colorante consigliata che puÃ² essere erogata. In caso di violazione, apparirÃ  un messaggio (l'erogazione Ã¨ ancora possibile).",
            missingAutotaskCanisters: "Selezionare almeno 1 Canestro",
            missingAutotaskChannels: "Selezionare almeno 1 canale",
            missingAutotaskChannelsValue: "Inserire il volume di tutti i canali selezionati",
            missingAutotaskCleanTime: "Inserire il tempo della pulizia",
            missingAutotaskName: "Inserire il nome dell'autotask",
            missingAutotaskRecirculation: "Inserire il tempo e la velocitÃ  di ricircolo",
            missingAutotaskStirring: "Inserire il tempo e la velocitÃ  di agitazione",
            missingAutotaskVolume: "Riempire Il volume di spurgo",
            placeCanSensor:
                "L'impostazione attiva il sensore per il posizionamento della confezione della base - l'erogazione non inizierÃ  se la base non Ã¨ stata posizionata correttamente.",
            placeCanSensorDelay:
                "Impostazione consigliata, collegata al sensore di rilevamento confezione base. Assicura che l'erogazione inizi solo dopo il periodo di tempo definito durante il quale la base Ã¨ stata posizionata correttamente.",
            purgeVolume:
                "Il volume di spurgo imposta la quantitÃ  di colorante che viene erogata quando si esegue lo spurgo intelligente.",
            rccUrl: "Il Redlike Control Center (RCC) permette la comunicazione con la macchina (tintometro).",
            refillThreshold:
                "Se la quantitÃ  di colorante nella tanica con il dato numero UFI o di lotto scende al di sotto di questo limite, tale UFI o numero di lotto sarÃ  scartato.",
            refillThresholdBatch:
                "Se la quantitÃ  di colorante nella tanica con il numero di lotto indicato scende al di sotto di questo limite, tale numero di lotto verrÃ  scartato.",
            refillThresholdUfi:
                "Se la quantitÃ  di colorante nella tanica con l'UFI dato scende sotto questo limite, tale UFI sarÃ  scartato.",
            removeCanSensor:
                "L'impostazione attiva il sensore per la rimozione della confezione della base - l'erogazione non Ã¨ considerata eseguita a meno che non sia stata rimossa la base.",
            removeCanSensorDelay:
                "Impostazione consigliata collegata al sensore di rimozione della confezione della base. Assicura che l'erogazione sia stata completata e che solo dopo il periodo di tempo definito la base potrÃ  essere rimossa.",
            skipPlaceCanDialog:
                "Con questa impostazione attivata, il tintometro non aspetterÃ  quando si posiziona una confezione della base di dare la conferma con il pulsante OK, ma inizierÃ  automaticamente il processo di erogazione.",
            skipRemoveCanDialog:
                "Con questa impostazione attivata, il tintometro non aspetterÃ  quando si rimuove una confezione della base di dare la conferma con il pulsante OK, ma considererÃ  il processo di erogazione finito automaticamente.",
            smartPurgeType:
                "Il tipo di spurgo puÃ² prendere in considerazione solo l'erogazione o l'erogazione plus, oltre ad altri eventi di spurgo quando confermati se necessario utilizzare lo spurgo intelligente.",
            splitFormula:
                "Se la quantitÃ  di colorante richiesta supera la quantitÃ  massima erogabile, l'impostazione consente di erogare il quantitativo disponibile, riempire nuovamente il canestro e quindi continuare a erogare il resto.",
            tintometricSystem:
                "Tintometric System (Set Of Available Colorants) Defines What Colorants And Formulas Will Be Available In The Application And Application Settings.",
            validateBarcodeBaseCan:
                "La base deve essere convalidata tramite codice a barre prima che sia consentita l'erogazione. L'impostazione garantisce l'utilizzo della base corretta.",
            validateColorantsDuringInit:
                "La configurazione della macchina viene confrontata con il database ogni volta che l'RCC viene riavviato. In caso di discrepanze, si verificherÃ  una notifica."
        },
        matchingSettings: {
            matchingInformation: "On matching result panel, %{item} will be available.",
            matchingOptionsColorants: "On matching options panel, colorants panel will be available.",
            matchingOptionsColorfile: "On matching options panel, colorfile selectbox will be available.",
            matchingOptionsSortResults: "On matching options panel, sort results selectbox will be available.",
            matchingRowCount: "Defines How Many Results Should Be Offered After Matching."
        },
        navigation: {
            barcodeScan: "Apre una finestra con la possibilitÃ  di inserire manualmente il codice a barre.",
            canisterBarcodes:
                "Apre una finestra con la panoramica dei codici a barre delle taniche e la possibilitÃ  di impostare il codice a barre delle taniche.",
            canisterLevel:
                "Apre una finestra con la panoramica dei livelli delle bombole e la possibilitÃ  di impostare il livello delle bombole.",
            canisters:
                "Apre un pannello con la panoramica dei livelli delle bombole e la possibilitÃ  di impostare il livello delle bombole.",
            clean: "Apre la funzione per eseguuire la pulizia dei circuiti o l'apertura del autocap",
            colorPanel:
                "Apre un pannello con la possibilitÃ  di cercare una nuova formula in una cartella colore elettronica.",
            colorSearchTab: "Apre un pannello con la possibilitÃ  di cercare tutti i colori in tutte le mazzette.",
            colorantRefillHistory: "Apre una finestra con la panoramica delle ricariche delle taniche effettuate.",
            customFormula: "Apre un pannello con la possibilitÃ  di creare una nuova formula personalizzata.",
            customers:
                "Apre un pannello con la panoramica dei clienti e la possibilitÃ  di aggiungerli/modificarli/eliminarli.",
            dispensingHistory: "Apre un pannello con la panoramica delle erogazioni effettuate.",
            favorites: "Apre un pannello con la possibilitÃ  di selezionare una formula preferita.",
            help: "Apre una finestra con le informazioni del servizio clienti.",
            hideItems:
                "Apre una finestra con la possibilitÃ  di contrassegnare i prodotti e i cartelli colori come nascosti.",
            historyOfOrders:
                "Valido esclusivamente per %{name} , apre un pannello con la panoramica degli ordini erogati.",
            machineReset: "Avvia il reset del tintometro.",
            matching: "Apre una finestra con la possibilitÃ  di eseguire il ColorMatching con uno spettro.",
            myOrders: "Ordini che sono stati inviati da questo computer",
            purge: "Apre una finestra con la possibilitÃ  di impostare lo spurgo delle taniche.",
            quickTint: "Apre una finestra con la possibilitÃ  di eseguire l'erogazione veloce.",
            searchFormula: "Apre un pannello con la possibilitÃ  di cercare una nuova formula.",
            spectro: "Apre un pannello per effettuare una misura con uno spettro/colorimetro.",
            stir: "Apre una finestra con la possibilitÃ  di impostare l'agitazione del contenitore.",
            ticketing: "Apre una finestra con la possibilitÃ  di gestire i Ticket.",
            toDispense: "Ordini che sono stati ricevuti da questo computer"
        },
        noHelpForLicense: "Non Ã¨ disponibile alcun aiuto per la tua licenza, chiedi al tuo fornitore di aggiungerla.",
        posInfo: {
            sync: "Sincronizza i dati con la sezione Registrazione"
        },
        poweredByDeso: "Realizzato da %{name}",
        priceSettings: {
            VatPrice: "IVA del colorante in %",
            VatPriceProduct: "L'IVA generica del prodotto sarÃ  la stessa per ogni colorante. Impostato in %.",
            basePurchase: "Prezzo d'acquisto per la base (include esclusivamente la base).",
            basePurchasePriceProduct:
                "Prezzo di acquisto per il formato della base data. Impostato nella valuta selezionata.",
            baseSell: "Il prezzo di vendita solo per la base (incl. base e margine/ricarico).",
            baseSellFull: "Vendi il prezzo pieno per la base.",
            cntName: "Definisce a quale colorante si riferisce il prezzo.",
            cntPurchase: "Prezzo d'acquisto per i coloranti (inclusi esclusivamente i coloranti).",
            cntPurchaseByName:
                "Prezzo d'acquisto per i coloranti, calcolato individualmente per ciascuno di essi (include esclusivamente i coloranti).",
            cntPurchasePricePerLiter: "Prezzo di costo del colorante per litro (senza margine o ricarico).",
            cntSell: "Prezzo di vendita solo per i coloranti (incl. coloranti e margine/ricarico).",
            cntSellByName:
                "Prezzo di vendita di tutti i coloranti utilizzati nel prodotto, calcolato individualmente per ciascuno di essi (compresi i coloranti e il margine/ricarico).",
            cntSellFull: "Vendi a prezzo pieno i coloranti.",
            cntSellFullByName: "Vendi a prezzo pieno i coloranti per nome.",
            cntSellPricePerLiter:
                "Il prezzo di vendita del colorante al litro (incluso esclusivamente il colorante). Impostato nella valuta selezionata.",
            cntVat: "Valore IVA del colorante impostato in %.",
            colorants:
                "Prezzo generico dei coloranti sarÃ  lo stesso per ogni colorante. Questa funzione Ã¨ utile soprattutto per impostare l'IVA.",
            colorantsPosCoeficient: "Coefficiente colorante generico per POS.",
            colorantsSellPrice:
                "I prezzi dei coloranti generici saranno gli stessi per ogni colorante. Si raccomanda che il prezzo di vendita sia modificato dallo sconto. Impostare nella valuta selezionata.",
            currencyCodeNew: "Il codice valuta deve essere di tre lettere come da standard ufficiale, ad esempio EUR.",
            currencyNameNew: "Nome della valuta, ad esempio Euro.",
            currencyRateNew:
                "Il tasso di cambio verso la valuta principale, ad esempio 25,855 CZK per 1 â¬. Il tasso deve essere modificato continuamente per essere tenuto aggiornato.",
            currencyRoundingNew:
                "L'arrotondamento imposta il minor valore pagabile possibile della valuta, ad esempio l'Euro ha un arrotondamento di 0,01 perchÃ© il valore piÃ¹ piccolo possibile Ã¨ di 1 centesimo.",
            currencySymbolNew: "Simbolo ufficiale della valuta, ad esempio â¬ per l'Euro.",
            defaultPrice: "Prezzo del colorante impostato nel database selezionato (senza IVA).",
            defaultPriceGroup:
                "Prezzo del colorante per gruppo di prezzo impostato nel database selezionato (senza IVA).",
            defaultVatPrice: "IVA del colorante impostata nel database selezionato.",
            discountHeader:
                "Lo sconto sottrae il valore definito dal prezzo di acquisto del colorante. Impostato in %.",
            discountHeaderProduct:
                "Lo sconto sottrae il valore definito dal prezzo del colorante del prodotto. Impostare in %.",
            export: "Esporta un file con i prezzi attualmente inseriti. PuÃ² essere importato di nuovo dopo aver modificato i prezzi.",
            import: "Importare un file correttamente formattato (esportato) per inserire o modificare i prezzi.",
            localPrices:
                "I prezzi locali cambiano i prezzi suggeriti dal database principale e sono presenti solo localmente su questo particolare computer.",
            margin: "Scegliere quale calcolo dei prezzi deve essere utilizzato per la definizione del prezzo finale disponibile. Margine e markup si sommano mentre lo sconto si sottrae dal prezzo di vendita dato.",
            marginAll: "Prezzo per margine/ricarico per confezioni multiple (incluso margine/ricarico).",
            marginHeader: "Il margine aggiunge il valore definito al prezzo di acquisto del colorante. Impostato in %.",
            marginHeaderProduct:
                "Il margine aggiunge il valore definito fino al prezzo di acquisto del prodotto. Impostato in %.",
            marginPerPkg: "Prezzo per margine/ricarico per una confezione (incluso margine/ricarico).",
            markupHeader: "Il Markup aggiunge il valore definito al prezzo di acquisto del colorante. Impostato in %.",
            markupHeaderProduct:
                "Il Markup aggiunge il valore definito al prezzo di acquisto del prodotto. Impostato in %.",
            packagePricing: "Sovrapprezzo aggiuntivo per ogni dimensione della confezione.",
            packageSurcharge:
                "I prezzi generici delle confezioni saranno gli stessi per ogni sovrapprezzo delle relative confezioni.",
            priceDefinition:
                "L'impostazione definisce quali tipi di prezzo vengono utilizzati nel calcolo dei prezzi finali.",
            priceGroupNumber:
                "L'impostazione definisce quanti gruppi di prezzi verranno utilizzati. L'intervallo per i singoli gruppi di prezzi puÃ² essere impostato in Valori predefiniti.",
            priceGroupPricePerLiter: "Prezzo del colorante utilizzato per il calcolo del prezzo del gruppo di prezzi.",
            priceGroups:
                "Gruppi di prezzi visualizza il numero del relativo gruppo di prezzi (i limiti sono impostati nel database o in prezzi generici).",
            priceGroupsEnabled:
                "L'impostazione permette di lavorare con i gruppi di prezzi. Definisci la gamma in Valori predefiniti e i prezzi individuali in Prezzi dei coloranti.",
            priceGroupsGeneric:
                "I gruppi di prezzo sono intervalli di prezzo della tinta finale basata sui prezzi dei coloranti presenti nella formula.",
            productBasePackageSellPrice:
                "Prezzo di vendita per il formato della base data. Impostato nella valuta selezionata.",
            productBaseSellPrice:
                "Prezzo di vendita per la base calcolato al litro (incl. esclusivamente la base). Impostato nella valuta selezionata.",
            productBaseVat: "Valore IVA della base del prodotto per il formato dato impostato in %.",
            productName: "Definisce a quale base di prodotto si riferisce il prezzo.",
            productPosCoeficient: "The Generic Product Coeficient For Pos.",
            productPricing:
                "Il prezzo di acquisto per tutte le confezioni viene utilizzato per l'erogazione di confezioni personalizzate.",
            productSize: "Definisce a quale formato della base di prodotto data si riferisce il prezzo.",
            productVat: "Valore IVA di base del prodotto impostato in %.",
            products:
                "I prezzi generici dei prodotti saranno gli stessi per ogni prodotto. Questa funzione Ã¨ utile soprattutto per impostare l'IVA.",
            productsSellPrice:
                "I prezzi dei prodotti generici saranno gli stessi per ogni colorante. Si raccomanda che il prezzo di vendita sia modificato dallo sconto. Impostato nella valuta selezionata.",
            sellPriceAll:
                "Prezzo di vendita di confezioni multiple (incl. base, coloranti, sovrapprezzo e margine/ricarico).",
            sellPricePerKg:
                "Prezzo di vendita del prodotto per chilogrammo (incl. base, coloranti, sovrapprezzo e margine/ricarico).",
            sellPricePerL:
                "Prezzo di vendita del prodotto per litro (incl. base, coloranti, sovrapprezzo e margine/ricarico).",
            sellPricePerPkg:
                "Il prezzo di vendita di una confezione (incl. base, coloranti, sovrapprezzo e margine/ricarico).",
            setPriceTypesVisibilityAndOrder:
                "Nel pannello Formula, i prezzi selezionati saranno visibili nella sezione prezzi. La posizione piÃ¹ alta qui definisce la posizione piÃ¹ a sinistra nella sezione.",
            surchargeAll: "Prezzo del costo aggiuntivo per confezioni multipli (incl. sovrapprezzo).",
            surchargePerPkg: "Prezzo del costo aggiuntivo per una confezione (incl. sovrapprezzo).",
            tintPurchaseAll:
                "Prezzo d'acquisto per l'intero processo di colorazione delle confezioni multiple (incl. coloranti e sovrapprezzo).",
            tintPurchasePerPkg:
                "Prezzo d'acquisto per l'intero processo di colorazione di una confezione (incl. coloranti e sovrapprezzo).",
            tintSellFullAll: "Prezzo Vendita colorato per tutte le confezioni.",
            tintlSellFullAllPerPackage: "Tint sell full price per package.",
            totalPurchaseAll:
                "Prezzo totale di acquisto del prodotto per confezioni multiple (incl. base e coloranti).",
            totalPurchasePerKg: "Prezzo totale di acquisto del prodotto per chilogrammo (incl. base e coloranti).",
            totalPurchasePerL: "Prezzo totale di acquisto del prodotto per litro (incl. base e coloranti).",
            totalPurchasePerPkg: "Prezzo totale di acquisto del prodotto per una confezione (incl. base e coloranti).",
            totalSellFullAll: "Prezzo totale di vendita per tutti i formati.",
            totalSellFullPerKg: "Prezzo totale di vendita per chilogrammo.",
            totalSellFullPerLiter: "Prezzo totale di vendita per litro.",
            totalSellFullPerPackage: "Prezzo totale di vendita per formato.",
            withAndWithoutVat:
                "Sul pannello della formula, il prezzo sarÃ  visibile in entrambe le varianti, con e senza IVA, contemporaneamente.",
            withVat: "Sul pannello della formula, tutti i prezzi saranno visibili solo con IVA inclusa.",
            withoutVat: "Sul pannello della formula, tutti i prezzi saranno visibili solo con IVA esclusa."
        },
        qualityControlSettings: {
            colorDifference: "Formula differenza colore per Controllo QualitÃ .",
            deltaA: "Definisce il limite di tolleranza per Delta a nel controllo qualitÃ .",
            deltaB: "Definisce il limite di tolleranza per Delta b nel controllo qualitÃ .",
            deltaE: "Definisce il limite di tolleranza per Delta E nel controllo qualitÃ .",
            deltaL: "Definisce il limite di tolleranza per Delta L nel controllo qualitÃ .",
            deltaMetamerism: "Definisce il limite di tolleranza per Metamerismo nel controllo qualitÃ ."
        },
        registration: {
            sync: "Sincronizza i dati con la sezione Info POS"
        },
        searchingPleaseWait: "Si prega di attendere, Ã¨ in corso la ricerca della migliore corrispondenza",
        setupSteps: {
            customData: "Dati personalizzati",
            machineType: "Tipo di macchina",
            userPreferences: "Preferenze dell'utente"
        },
        spectroSettings: {
            ColorixNanoUseProfiledValues:
                "Quando si usano valori profilati, i risultati misurati vengono ricalcolati per rimuovere l'effetto del filtro. Consentire questa opzione per la misurazione spettrale universale.",
            XRiteModelRM400: "Nessun driver richiesto.",
            datacolorDiagnosticTile: "Datacolor usa una piastrella di diagnostica",
            datacolorSilent: "Datacolor silenzioso",
            measureModes: "Seleziona i livelli di brillantezza supportati.",
            model: "Modello",
            simulationPath: "Percorso del file di simulazione. Preimpostazione predefinita.",
            spectroType: "Ã necessario installare il driver ufficiale dello spectro. Solo per Windows.",
            spectroTypeCom:
                "Ã necessario installare il driver ufficiale dello spectro. Attenzione alla porta COM utilizzata. Sia Windows che Linux.",
            spectroTypeDataColorReader:
                "Il computer deve avere una connessione Bluetooth. Lo spectro deve essere connesso con il computer. Ã richiesto un aggiornamento automatico del 2018 con Windows 10.",
            spectroTypeMinolta2XXXd:
                "Ã necessario installare il driver ufficiale dello spectro. Attenzione alla porta COM utilizzata. Sia Windows che Linux.",
            spectroTypeNotSelected: "Seleziona il tuo modello di spectro.",
            spectroTypeRM400: "Nessun driver richiesto.",
            spectroTypeSimulation:
                "Valori di laboratorio necessari per ottenere i risultati della simulazione. Sia Windows che Linux.",
            spectroTypeXRite: "Solo Windows."
        },
        ufiCode: {
            baseUfiCodeValidation:
                "Il codice UFI della base deve essere convalidato tramite il codice a barre prima che l'erogazione sia consentita.",
            enableUfiCodes:
                "I codici UFI sono usati nell'UE e forniscono informazioni su quanto sia pericoloso un prodotto per l'ambiente.",
            invalidUfi: "Codice UFI non valido",
            printUfiCode:
                "Se un colorante in una formula supera il limite dato, il suo codice UFI sarÃ  stampato sull'etichetta di stampa.",
            printUfiCodePercentage:
                "Se un colorante in una formula supera il limite dato, il suo codice UFI sarÃ  stampato sull'etichetta di stampa insieme alla sua rappresentazione percentuale.",
            ufiCodesByPercentage:
                "Il codice UFI che prevale viene utilizzato per la stampa considerando la sua quantitÃ  effettiva nel contenitore. Navigate nelle impostazioni del Canestro per definire la soglia per ogni Canestro.",
            ufiCodesFromDatabase:
                "Il codice UFI dal database principale dato dall'amministratore del database Ã¨ usato per la stampa.",
            ufiCodesFromLastFilling:
                "Il codice UFI dell'ultima ricarica dato dall'operatore viene usato per la stampa indipendentemente dalla quantitÃ  di ricarica."
        },
        userManagement: {
            add: "L'impostazione aggiunge un nuovo utente che puÃ² accedere al software. L'utente puÃ² avere un codice a barre assegnato e puÃ² essere impostato per accedere automaticamente dopo l'avvio del software.",
            assignedGroups:
                "Questo definisce a quali gruppi di utenti appartiene l'utente. Vari gruppi di utenti assegnano vari privilegi.",
            availableGroups:
                "Questo definisce quali gruppi di utenti sono disponibili per l'utente. Vari gruppi di utenti assegnano vari privilegi.",
            loggedUserDelete: "L'utente attualmente loggato non puÃ² essere eliminato."
        },
        visit: "Oppure visita",
        visitNoLicense: "Per ulteriori informazioni, si prega di visitare il sito"
    },
    helpSettings: {
        customHelpLink: "Link personalizzato al centro assistenza",
        helpSettings: "Aiuto impostazioni",
        message: "Messaggio"
    },
    helper: {
        automaticallyCheckForUpdates: "Controlla gli aggiornamenti automaticamente",
        automaticallyDownloadUpdates: "Scarica automaticamente gli aggiornamenti",
        automaticallyInstallNewDatabases: "Installare automaticamente i nuovi DB",
        automaticallyInstallUpdates: "Installa automaticamente gli aggiornamenti",
        bugReport: "Segnalazione dei bug",
        canBrowseChangeLog: "Mostra il registro delle modifiche online di %{name} .",
        collect: "Raccogliere",
        collectLogFiles: "Raccogliere i file di log",
        component: "Componente",
        content: "Contenuto",
        contentSize: "Dimensione del contenuto",
        download: "Scarica",
        downloadLogFiles: "Scarica i file di log",
        downloadingData: "Scaricare i dati",
        everyHours: "Ogni %{interval} ore",
        forceInstall: "Forzare l'aggiornamento",
        installDuringNight: "Durante la notte (%{start} - %{end}) ogni %{interval} ora",
        newVersion: "Nuova versione",
        notConnected: "L'helper non Ã¨ collegato",
        openBugReport: "Aprire un rapporto di bug",
        packageSize: "Dimensione del pacchetto",
        pleaseWait: "Attendere prego, l'operazione potrebbe richiedere del tempo.",
        send: "Invia",
        sendBugReportToCustomerService: "Invia la segnalazione di un bug al servizio clienti",
        sendingReport: "Invio",
        subject: "Oggetto"
    },
    helperDialog: {
        1: "Puoi controllare gli aggiornamenti del software o del database.",
        2: "Continuare a scaricare i pacchetti di aggiornamento?",
        3: "Continuare con l'installazione dei pacchetti di aggiornamento scaricati?",
        10: "Controllo degli aggiornamenti del software e del database, attendere prego...",
        11: "C'Ã¨ un aggiornamento disponibile per il tuo computer. Vuoi scaricarlo?",
        12: "Non ci sono aggiornamenti disponibili per il tuo computer.",
        14: "Si Ã¨ verificato un errore durante il controllo degli aggiornamenti. %{0}",
        15: "Sincronizzazione dei database di zona, attendere prego...",
        20: "Scarico del pacchetto di aggiornamento, attendere prego...",
        21: "Il pacchetto di aggiornamento che Ã¨ stato scaricato Ã¨ in fase di verifica, attendere prego...",
        22: "Io scaricamento del pacchetto di aggiornamento non Ã¨ riuscito, vuoi riprovare?",
        23: "Io scaricamento del pacchetto di aggiornamento non Ã¨ riuscito (il file Ã¨ malformato), vuoi riprovare?",
        24: "Procedere con l'installazione dell'aggiornamento?",
        25: "L'installazione dell'aggiornamento automatico inizierÃ  in %{0}",
        26: "C'Ã¨ un aggiornamento disponibile per il tuo computer. Vuoi scaricarlo?",
        27: "Procedere con l'installazione dell'aggiornamento?",
        40: "Arresto delle applicazioni e dei servizi, attendere prego...",
        41: "Stiamo copiando i nuovi file, attendere prego...",
        42: "Avvio di applicazioni e servizi, attendere prego...",
        43: "Completamento dell'aggiornamento del software, attendere prego...",
        44: "Il tuo software Ã¨ stato aggiornato con successo.",
        45: "Vuoi riprovare l'installazione? Se decidi di riprovare, assicurati che i componenti del software non siano attualmente in uso.",
        46: "Il riavvio del PC Ã¨ richiesto per applicare le modifiche, il riavvio sarÃ  fatto in %{0}",
        999: "Si Ã¨ verificato un errore interno: %{0}",
        automaticInstallation: "Installazione automatica degli aggiornamenti",
        btnAbort: "Interrompi",
        btnCancel: "Annulla",
        btnCheckUpdate: "Controlla gli aggiornamenti",
        btnContinue: "Continua",
        btnDownloadUpdate: "Scarica l'aggiornamento",
        btnInstallUpdate: "Installare l'aggiornamento",
        btnOk: "OK",
        btnRetry: "Riprova",
        btnSkip: "Salta",
        checkingForUpdates: "Controlla se Ã¨ disponibile un aggiornamento",
        downloadingFailed: "Lo scaricamento non Ã¨ andato a buon fine",
        downloadingPackage: "Scaricamento del pacchetto di aggiornamento, attendere prego",
        finishingUpdate: "Aggiornamento terminato",
        installingUpdate: "Installazione dell'aggiornamento",
        internalError: "Errore interno",
        rebootRequired: "Ã richiesto il riavvio",
        startingComponents: "Avvio dei componenti software",
        stoppingComponents: "Arresto dei componenti software",
        synchronizingDatabases: "Sincronizzazione dei database di zona",
        updateAvailable: "Aggiornamento disponibile, selezionare i componenti da aggiornare",
        updateDownloaded: "L'aggiornamento Ã¨ stato scaricato",
        updateFailed: "Il processo di aggiornamento Ã¨ fallito",
        updateInstalled: "L'aggiornamento Ã¨ stato installato",
        verificationFailed: "Verifica del pacchetto di aggiornamento non riuscita",
        verifyingPackage: "Verifica del pacchetto scaricato",
        yourSoftwareIsUpToDate: "Il tuo software Ã¨ aggiornato",
        yourSoftwareVersion: "La tua versione del software: %{0}"
    },
    importData: {
        abortImportingData: "Annullare l'importazione",
        aborted: "L'importazione Ã¨ stata interrotta.",
        backupLocalDB: "Backup Database Punto Vendita",
        confirmRestore: "Vuoi davvero ripristinare tutte le impostazioni locali?",
        dataMissing: "L'importazione Ã¨ fallita perchÃ© il file sorgente non conteneva alcun dato.",
        deleteImportedData: "Elimina i dati importati",
        encodingFile: "Codifica del file",
        exportLocalSettings: "Esportazione delle impostazioni locali",
        exportStaticSql: "Esportazione SQL statico",
        fileDamaged: "Importazione fallita perchÃ© il file sorgente sembra essere danneggiato.",
        fileMissing: "Importazione fallita perchÃ© il file di origine non esiste.",
        format: "Formato",
        formatPath: "Percorso formato",
        headerMissing: "Importazione fallita perchÃ© manca l'intestazione dei file.",
        import: "Importare",
        importAborted: "Importazione interrotta",
        importAborting: "Importazione annullata",
        importFailed: "Importazione fallita a causa di un errore inaspettato.",
        importLocalSettings: "Importa impostazioni locali",
        importPrices: "Importa prezzi",
        imported: "Importato con successo",
        importedWithErrors: "Importing Has Finished With Errors. Error Lines Have Been Skipped.",
        importing: "Importazione",
        noFormatAvailable: "Nessun formato disponibile",
        processing: "Elaborazione",
        processingCustomFormulas: "Elaborazione delle formule personali",
        processingCustomers: "Elaborazione dei clienti",
        productsFile: "File dei prodotti",
        restoreLocalSettings: "Ripristinare le impostazioni locali",
        underProgress: "L'importazione Ã¨ in corso.",
        unknownFormat: "L'importazione non Ã¨ riuscita perchÃ© il file di origine Ã¨ in un formato sconosciuto.",
        userFormulasFile: "Archivio delle formule dell'utente"
    },
    infoType: {
        baseDensity: "DensitÃ  della base",
        baseMass: "Peso della base",
        baseUfiCode: "Codice UFI della base",
        baseVolume: "Volume della base",
        batchNumbersTable: "Tabella dei numeri di lotto",
        bfsGrade: "Classe BFS",
        colorLab: "Colore Lab",
        colorRgb: "Colore RGB",
        colorRgbHex: "Colore RGB Esadecimale",
        colorXyz: "Colore xyz",
        colorantBatchNumbers: "Numeri di lotto del colorante",
        colorantMass: "Peso colorante",
        colorantUfiCodes: "Codici UFI del colorante",
        colorantVolume: "Volume colorante",
        formulaDate: "Data della formula",
        formulaDatetime: "Data e ora della formula",
        formulaMoreInfo: "Maggiori informazioni sulla formula",
        formulaMoreInfoInternal: "PiÃ¹ informazioni interne sulla formula",
        formulaMoreInfoPrint: "Maggiori informazioni di stampa della formula",
        hbw: "HBW",
        isPackageGravimetric: "La confezione Ã¨ gravimetrica",
        maxColorantMass: "Massa massima consentita del colorante",
        maxColorantVolume: "Volume massimo consentito per il colorante",
        nominalMass: "Massa nominale della confezione",
        nominalVolume: "Volume nominale della confezione",
        overfillDetected: "Rilevato un riempimento eccessivo",
        totalPaintDensity: "Total paint density",
        totalPaintMass: "Peso totale della pittura",
        totalPaintVolume: "Volume totale pittura",
        ufiCodesTable: "Tabella dei codici UFI",
        verifiedFormula: "Formula verificata",
        yValue: "Y valore"
    },
    initialTab: {
        favoriteFormulas: "Formule preferite",
        lastDispensedFormulas: "Ultime formule erogate",
        searchNewFormula: "Ricerca nuova formula"
    },
    invalidBatchNumbersModal: {
        header: "Controllare il numero di lotto del colorante",
        info: "Probabilmente un Canestro Ã¨ stato riempito con un lotto del colorante sbagliato. Si prega di non usare questo lotto. Svuotare il Canestro con Erogazione Veloce.",
        unknownStatus: "Stato del lotto sconosciuto"
    },
    keyWords: {
        action: "azione",
        add: "aggiungi",
        addition: "aggiunta",
        additional: "In aggiunta",
        address: "indirizzo",
        admin: "admin",
        advanced: "Avanzato",
        after: "dopo",
        afterDispensing: "dopo l'erogazione",
        alfa: "Alfa",
        all: "tutti",
        allow: "consenti",
        alphabetically: "in ordine alfabetico",
        amount: "importo",
        api: "api",
        ask: "chiedere a",
        autocap: "autocap",
        autotask: "autotask",
        availablePrice: "prezzo disponibile",
        backup: "backup",
        banner: "banner",
        barcode: "codice a barre",
        barcodes: "codici a barre",
        base: "base",
        before: "prima",
        begin: "inizio",
        bfs: "bfs",
        bottom: "In basso",
        brand: "marchio",
        brush: "spazzola",
        bug: "bug",
        button: "pulsante",
        buy: "Acquista",
        cC3: "CC3",
        cM: "CM",
        calibration: "calibrazione",
        can: "latta",
        canHandling: "Manipolazione della latta",
        canister: "Canestro",
        canisterFilling: "riempimento del Canestro",
        canisterLevels: "livelli del Canestro",
        canisters: "Canestri",
        cap: "tappo",
        center: "Centro",
        centre: "Centro",
        change: "cambia",
        changelog: "Registro delle modifiche",
        channels: "canali",
        check: "controlla",
        chunk: "pezzo",
        chunks: "pezzi",
        city: "cittÃ ",
        clean: "pulire",
        cleaning: "pulizia",
        clientIdentifier: "identificazione del cliente",
        close: "chiudere",
        closest: "piÃ¹ vicino",
        code: "codice",
        collect: "raccogliere",
        color: "colore",
        colorLink3: "coloreLink3",
        colorPanel: "Cartella Colori",
        colorReader: "ColorReader",
        colorant: "colorante",
        colorantConsumption: "consumo del colorante",
        colorantPrice: "prezzo del colorante",
        colorants: "coloranti",
        colorix: "Colorix",
        colour: "colore",
        communication: "comunicazione",
        compare: "confronta",
        competitive: "competitivo",
        computer: "computer",
        config: "configura",
        configuration: "configurazione",
        confirm: "conferma",
        confirmation: "conferma",
        connection: "connessione",
        contactPerson: "Persona da contattare/Referente",
        control: "Controllo",
        copies: "copie",
        corob: "Corob",
        cost: "costo",
        country: "paese",
        create: "creare",
        currency: "valuta",
        current: "corrente",
        custom: "personalizzato",
        customers: "clienti",
        daily: "giornaliero",
        dark: "Dark",
        data: "dati",
        database: "database",
        datacolor: "Datacolor",
        date: "data",
        decimals: "decimali",
        default: "default",
        delay: "ritardo",
        delete: "elimina",
        deletion: "eliminazione",
        deltaE: "delta e",
        device: "dispositivo",
        devices: "dispositivi",
        diagnosticTile: "piastrella di diagnostica",
        dialog: "dialogo",
        direct: "diretto",
        disconnect: "disconnetti",
        discount: "sconto",
        dispense: "dispensa",
        dispenser: "Macchina di erogazione",
        dispensing: "erogazione",
        down: "giÃ¹",
        download: "scaricare",
        driver: "driver",
        dromont: "Dromont",
        dspProxy: "DspProxy",
        edit: "modifica",
        editor: "Modificatore",
        email: "email",
        error: "errore",
        evoDriver: "EvoDriver",
        evoService: "EvoService",
        excel: "excel",
        expiration: "scadenza",
        export: "esportazione",
        eyeOne: "Eye-One",
        fF: "F&F",
        fandeck: "Cartella colore",
        fastFluid: "Fast & Fluid",
        file: "file",
        fill: "riempire",
        fillToMax: "riempire al massimo",
        find: "trova",
        first: "prima",
        flex: "Flex",
        folder: "cartella",
        formula: "formula",
        formulas: "formule",
        from: "da",
        fts5: "fts5",
        fullScreen: "schermo intero",
        fullText: "tutto il testo",
        fulltext: "tutto il testo",
        g: "g",
        genericPricing: "prezzo generico",
        hLD: "HLD",
        hard: "hard",
        hbw: "hbw",
        help: "aiuto",
        helpCenter: "centro di assistenza",
        hero: "Hero",
        history: "storia",
        home: "Pagina d'inizio",
        host: "host",
        humidifier: "umidificatore",
        iDD: "IDD",
        identification: "identificazione",
        image: "immagine",
        impGallon: "imp. gallon",
        impQuart: "imp. quarto",
        import: "importare",
        individually: "individualmente",
        info: "info",
        information: "informazioni",
        initial: "iniziale",
        initialization: "inizializzazione",
        initialize: "inizializzare",
        insert: "inserire",
        install: "installare",
        intellyPurge: "spurgo intelligente",
        invalid: "non valido",
        ipAddress: "indirizzo ip",
        italtinto: "Italtinto",
        items: "articoli",
        keyboard: "tastiera",
        kg: "kg",
        kiosk: "chiosco",
        kioskMode: "modalitÃ  chiosco",
        l: "l",
        lLD: "LLD",
        lab: "laboratorio",
        label: "etichetta",
        labels: "etichette",
        language: "lingua",
        largo: "largo",
        last: "ultimo",
        lenteq: "Lenteq",
        levels: "livelli",
        license: "licenza",
        light: "Luce",
        limit: "limite",
        link: "Collegamento",
        linux: "Linux",
        load: "caricare",
        lock: "bloccare",
        logFiles: "file di log",
        logic: "logica",
        logo: "logo",
        lower: "inferiore",
        machine: "macchina",
        machineConfiguration: "configurazione della macchina",
        machineManagement: "gestione della macchina",
        machineName: "nome della macchina",
        main: "principale",
        maintenance: "manutenzione",
        manual: "manuale",
        manualAddition: "aggiunta manuale",
        manualDispensing: "erogazione manuale",
        manualScan: "scansione manuale",
        margins: "margini",
        markups: "markups",
        mass: "massa",
        match: "corrispondenza",
        measure: "misura",
        measurement: "misura",
        measurementUnits: "unitÃ  di misura",
        melody: "melodia",
        message: "messaggio",
        minimal: "minimo",
        minolta: "Minolta",
        minus: "meno",
        minutes: "minuti",
        misura: "Misura",
        ml: "ml",
        mode: "modo",
        model: "modello",
        modification: "modifica",
        modify: "modifica",
        monthly: "mensile",
        moreInfo: "piÃ¹ informazioni",
        movableTable: "tavolo mobile",
        move: "spostare",
        music: "musica",
        myOrders: "i miei ordini",
        name: "nome",
        naming: "nominare",
        nano: "Nano",
        navigation: "navigazione",
        new: "nuovo",
        nextDriver: "NextDriver",
        night: "notte",
        nixPro: "Nix Pro",
        notes: "note",
        notification: "notifica",
        number: "numero",
        off: "Spenta",
        open: "aprire",
        order: "ordine",
        ordering: "ordinazione",
        overfill: "troppo pieno",
        overview: "panoramica",
        overwrite: "sovrascrivere",
        own: "proprio",
        pCPDriver: "PCPDriver",
        package: "formato",
        packagePrice: "prezzo del formato",
        packages: "formati",
        panels: "pannelli",
        parameter: "parametro",
        path: "percorso",
        pc: "pc",
        phone: "telefono",
        phoneNumber: "numero di telefono",
        picture: "immagine",
        place: "posto",
        placement: "posizionamento",
        plug: "spina",
        plugger: "tappo",
        plugging: "tappatura",
        plugin: "plugin",
        plus: "piÃ¹",
        pointOfSale: "punto vendita",
        popUp: "pop-up",
        pos: "pos",
        present: "presente",
        preview: "anteprima",
        price: "prezzo",
        priceExport: "esportazione prezzo",
        priceGroup: "gruppo di prezzi",
        priceImport: "importazione prezzo",
        prices: "prezzi",
        pricing: "prezzo",
        primaryCurrency: "valuta primaria",
        print: "stampa",
        printer: "stampante",
        printing: "stampa",
        problem: "problema",
        product: "prodotto",
        productPrice: "prezzo del prodotto",
        profiledValues: "valori profilati",
        punch: "punch",
        puncher: "puncher",
        punching: "punching",
        purge: "spurgo",
        purgeType: "tipo di spurgo",
        purgeVolume: "volume di spurgo",
        quality: "qualitÃ ",
        quick: "quick",
        quickTint: "Erogazione Veloce",
        rM: "RM",
        raise: "alza",
        rcc: "rcc",
        reader: "lettore",
        reboot: "riavviare",
        receive: "ricevere",
        recirculate: "ricircolare",
        recirculation: "ricircolo",
        redlike: "Redlike",
        refill: "riempire",
        registration: "registrazione",
        regular: "regolare",
        removal: "rimozione",
        remove: "rimuovere",
        report: "segnalare",
        reset: "resettare",
        resolution: "risoluzione",
        restart: "riavviare",
        rgb: "rgb",
        rights: "diritti",
        rounding: "arrotondamento",
        rules: "regole",
        sanTint: "SanTint",
        save: "salva",
        scale: "scala",
        scan: "scansione",
        scope: "ambito",
        screen: "schermo",
        screensaver: "screensaver",
        search: "ricerca",
        secondaryCurrency: "valuta secondaria",
        select: "seleziona",
        selectedFormula: "formula selezionata",
        sell: "vendere",
        sensor: "sensore",
        serialNumber: "numero di serie",
        server: "server",
        servers: "server",
        service: "servizio",
        serviceAction: "azione di servizio",
        serviceActions: "azioni di servizio",
        serviceSoftware: "software di servizio",
        serviceWindow: "finestra di servizio",
        settings: "impostazioni",
        shelf: "scaffale",
        shortcuts: "scorciatoie",
        shot: "impulso",
        show: "mostra",
        shutDown: "spegnere",
        shutdown: "spegnere",
        silent: "silenzioso",
        simple: "semplice",
        simulation: "simulazione",
        size: "dimensione",
        skip: "salta",
        smartPurge: "spurgo intelligente",
        software: "software",
        softwareSupplier: "fornitore di software",
        sort: "ordinamento",
        sound: "suono",
        spectro: "spettro",
        spectrophotometer: "spettrofotometro",
        speed: "velocitÃ ",
        split: "split",
        start: "inizia",
        startup: "avvio",
        statistics: "statistiche",
        status: "stato",
        stir: "mescolare",
        stirring: "mescolando",
        street: "strada",
        support: "supporto",
        surcharge: "supplemento",
        tab: "scheda",
        tabs: "schede",
        task: "task",
        template: "modello",
        testing: "test",
        time: "tempo",
        tintingManagementCenter: "centro di gestione della tinta",
        to: "a",
        toDispense: "erogare",
        tolerance: "tolleranza",
        top: "top",
        total: "totale",
        translation: "traduzione",
        turnOff: "spegnere",
        turntable: "giradischi",
        type: "tipo",
        uIDD: "UIDD",
        uSGallon: "U.S gallon",
        uSQuart: "U.S quart",
        unit: "unitÃ ",
        up: "su",
        update: "aggiornamento",
        url: "url",
        user: "utente",
        userGroups: "gruppi di utenti",
        v1: "v1",
        v2: "v2",
        v3: "v3",
        vAT: "IVA",
        validate: "convalidare",
        validation: "validazione",
        version: "versione",
        virtual: "virtuale",
        volume: "volume",
        weekly: "settimanale",
        window: "finestra",
        windows: "finestre",
        with: "con",
        without: "senza",
        xRite: "X-Rite",
        xrite: "X-Rite",
        yValue: "valore y",
        zipCode: "codice postale",
        zoom: "zoom"
    },
    languages: {
        bg: "??Â´???????",
        cs: "CeÅ¡tina",
        da: "Danish",
        de: "Deutsch",
        el: "????????",
        en: "English",
        es: "EspaÃ±ol",
        fr: "FranÃ§ais",
        hr: "Hrvatski",
        hu: "Magyar",
        id: "Bahasa Indonesia",
        is: "Ãsland",
        it: "Italiano",
        lt: "Lithuanian",
        lv: "Latvian",
        ms: "Melayu",
        nl: "Nederland",
        no: "Norway",
        pl: "Polski",
        pt: "PortuguÃªs",
        ro: "Romana",
        ru: "???????",
        sk: "Slovencina",
        sr: "Srpski",
        sv: "Sverige",
        zh: "Chinese"
    },
    license: {
        activateLicense: "Attivare licenza",
        activateNewLicense: "Attivare la nuova licenza",
        checkLicenseKey: "Controllo chiave licenza",
        companyId: "ID azienda",
        contactPerson: "Persona da contattare",
        copy: "Copia",
        country: "Paese",
        emptyCity: "La cittÃ  Ã¨ un'informazione obbligatoria",
        emptyCountry: "Il paese Ã¨ un'informazione obbligatorio",
        emptyName: "Il nome del negozio Ã¨ un'informazione obbligatorio",
        enterIdentificationKeys: "Inserire la chiave di identificazione",
        expirationDate: "Data di scadenza %{dateTime}",
        fillRegistration: "Riempire i dati di registrazione",
        insertLicense: "Inserire la chiave generata per l'attivazione offline",
        invalidEmail: "L'email inserito non Ã¨ valido",
        invalidPhone: "L'inserimento del telefono non Ã¨ valido",
        itemsMarkedasterisk: "(le voci contrassegnate da un asterisco devono essere compilate)",
        lastUpdate: "Ultima modifica %{dateTime}",
        leasedLicense: "Leased license",
        licenseActivated: "Licenza giÃ  attivata",
        licenseStatus: "Stato della licenza",
        licenseWillExpire: "La tua licenza scade tra %{dayCount} giorni",
        licenseWillExpireOneDay: "La tua licenza scade tra %{dayCount} giorni",
        machineInformation: "Informazioni della macchina",
        noLicenseAvailable: "Licenza non disponibile",
        noProductsForKey: "Non ci sono prodotti disponibili per le chiavi di identificazione indicate.",
        pointOfSale: "Punto vendita",
        producer: "Produttore",
        reactivate: "Riattivare",
        reactivateLicense: "Reactivate license",
        region: "Regione",
        registerLicense: "Fare una copia della richiesta di attivazione e collegarsi al sito:",
        registrationForm: "Registrazione",
        selectProduct: "Seleziona il prodotto",
        serialNumber: "Numero di serie",
        skipNewLicense: "Se vuoi attivare la nuova licenza piÃ¹ tardi puoi cliccare su Skip",
        unlimitedLicense: "Licenza illimitata",
        userId: "Utente ID",
        uuid: "Licenza UUID",
        versionDetails: "Dettagli della versione",
        versionScope: "Version scope",
        versionType: "Tipo di versione",
        zip: "Cap"
    },
    login: {
        authenticate: "Authenticate",
        logIn: "Accedi",
        loginAs: "Accedi con un altro utente",
        messages: {
            incorrectUsername: "Password o nome utente errato."
        },
        password: "Password",
        username: "Nome utente"
    },
    machineActionHistory: {
        actionHistory: "Storico azioni"
    },
    machineErrors: {
        channel: "Pompe",
        code: "Codice",
        machineErrors: "Errori tintometro",
        noMachineErrors: "Attualmente non ci sono errori della macchina",
        resetErrors: "Azzerare gli errori"
    },
    machineSettings: {
        action: "Azione",
        addAutotask: "Aggiungi autotask",
        autoCanisterIn: "Inserimento canestro automatico",
        autoCanisterOut: "Rimozione canestro automatico",
        automaticRefill: "Riempimento automatico",
        autotaskSettings: "Impostazione dell'autotask",
        backupConfiguration: "Backup della configurazione tintometro",
        brushMaintenance: "Manutenzione spazzola",
        capMaintenance: "Manutenzione del tappo",
        checkCanisterBeforeDispense: "Controlla il barrattolo prima di erogare",
        checkColorantBaseRules: "Controlla regole Coloranti per Basi",
        checkMinDosableAmount: "Controllare la quantitÃ  minima colorabile di coloranti",
        checkOverfill: "Controllare il riempimento eccessivo della latta",
        checkTotalCntAmounts: "Controllare la quantitÃ  totale di coloranti per la base della verniciatura.",
        cleanAll: "Pulizia totale",
        computerReboot: "Riavvia computer",
        computerShutdown: "Spegni computer",
        connectMachine: "Tintometro connesso",
        days: "Giorni",
        daysOfMonth: "Giorni del mese",
        devices: "Dispositivi",
        disabled: "Disabilitato",
        dispenseAndPurge: "Erogazione e spurgo",
        dispenseOnly: "Solo erogazione",
        dispenserCleaning: "Pulizia tintometro",
        dispensingWithErrorsEnabled: "Consentire l'erogazione nonostante gli errori di convalida",
        editAutotask: "Modifica autotask",
        firstRun: "Prima esecuzione",
        hours: "Ore",
        humidifier: "Umidificatore",
        humidifierWaterLevelMaintenance: "Controllo livello della vaschetta",
        machineConfigurationNoCanisters: "La configurazione della macchina non contiene Canestri.",
        machineName: "Nome tintometro",
        machineSettings: "Impostazioni tintometro",
        manualPuncher: "Punzonatrice manuale",
        minDispensedAmount: "Quantita minima erogata",
        minutes: "Minuti",
        nextRun: "Esegui prossimo",
        noAutotasksSet: "Nessun autotask impostato",
        noDataAvailable: "Nessun dato disponibile",
        noMachine: "Nessun tintometro connesso",
        onStart: "all'avvio",
        plugger: "Otturatore",
        postpone: "Rinviare",
        puncher: "Punzone",
        purgeAll: "Spurga tutti",
        purgeOnly: "Solo spurgo",
        recirculateAll: "Ricircolo totale",
        recirculateChannels: "Ricircolo circuito",
        recirculationSpeed: "VelocitÃ  ricircolo",
        recirculationTime: "Tempo di ricircolo",
        refillAll: "Riempimento totale",
        refillCanisters: "Riempimento canestri",
        runAt: "Esegui alle",
        runDefinedDaysAt: "Giorni definiti al",
        runEvery: "Esegui ogni",
        runInDays: "Esegui nei giorni",
        serialNum: "Numero seriale",
        settingsMachine: "Impostazioni tintometro",
        smartPurgeAll: "Spurgo intelligente di tuttii coloranti",
        smartPurgeChannels: "Spurgo inteligente dei circuiti",
        smartPurgeRules: "Regole di spurgo intelligente",
        startType: "Tipo di avvio",
        stirAll: "Agitazione di tutti i coloranti",
        stirCanisters: "Agitazione canestri",
        stirringSpeed: "VelocitÃ  di agitazione",
        stirringTime: "Tempo di agitazione",
        switchPlateMaintenance: "Manutenzione del piatto girevole",
        theCurrentlySelectedMachine: "Tintometro selezionato",
        threshold: "Soglia",
        turntable: "Giradischi",
        unifyColorantBatchForMultipleCans: "Unifica il lotto di colorante per l'erogazione multipla",
        volume: "Volume",
        weekdays: "Giorni della settimana"
    },
    mainTab: {
        acceptedFormula: "Formula accettata",
        addBuildingSite: "Add building site",
        addToFavorites: "Aggiungi ai preferiti",
        alternativeFormulas: "Formule Alternative",
        alternativeValidFormulas: "Formule Alternative Valide",
        buildingSiteSpecification: "Building site specification",
        colorantsAreInvalid: "Uno o piÃ¹ coloranti non sono validi",
        dispensedPackages: "Formati erogate",
        dispensingInProgress: "Erogazione in corso",
        dispensingIsAborted: "L'erogazione Ã¨ stata interrotta",
        dispensingIsNotAvailable: "Erogazione non disponibile",
        dispensingProgress: "%{done} di %{all}",
        editColorant: "Modifica colorante",
        editNote: "Modifica nota",
        findCompetitiveColor: "Prova a trovare il colore competitivo",
        forceDispensing: "Forza l'erogazione",
        formulaInvalidColorants: "La formula contiene dei coloranti non validi: %{colorants}",
        formulaOutOfDate: "Formula may be out of date",
        formulaProperties: "ProprietÃ  Formula",
        hiddenFandecks: "Cartelle colori nascoste",
        hiddenProducts: "Prodotti nascosti",
        historicalFormulas: "Storico formule",
        lowerDeltaNumber: "Un numero delta piÃ¹ basso, ha una corrispondenza piÃ¹ accurata",
        machineError: "Errore della macchina",
        machineIsBusy: "Macchina occupata",
        machineNotConnected: "Tintometro non connesso",
        manualColorantAddition: "Aggiunta manuale del colorante",
        modifiedFormula: "Formula modificata",
        modifiedFormulaInLab: "Formula modificata in laboratorio",
        newColorAfterScaling: "Nuovo colore dopo il ridimensionamento",
        newRgbNotAccuratelyMeasured: "Il nuovo RGB non Ã¨ misurato accuratamente, Ã¨ solo indicativo",
        noBaseAvailable: "Nessuna base Ã¨ disponibile",
        noBuildingSiteAvailable: "Nessuna info Cantiere",
        noColorantForCorrection: "No Additional Colorants For Correction Selected",
        noColorants: "Nessun colorante",
        noCustomer: "Nessun cliente",
        noCustomers: "Nessun cliente disponibile",
        noDispenseNotesAvailable: "Non sono disponibili note per l'erogazione",
        noFormulaAvailable: "Hai selezionato una combinazione senza una formula!",
        noFormulaSelected: "Nessuna formula selezionata",
        noInternalNotesAvailable: "Non sono disponibili note interne",
        noNotesAvailable: "Non sono disponibili note",
        noPackageAvailable: "No package is available",
        noPackageSelected: "Nessun formato Ã¨ selezionato",
        noProductAvailable: "No product is available",
        noResultsFound: "Nessun risultato trovato",
        openLocalFile: "Apri dal database locale",
        openOnlineFile: "Aprire da Internet",
        order: "Ordine",
        orderingIsNotAvailable: "L'ordine non Ã¨ disponibile",
        originalColor: "Colore originale",
        overAvailableLevel: "Oltre il livello disponibile",
        package: "Formato",
        packageIsRequired: "Ã¨ richiesto il formato.",
        packaging: "Imballo",
        partialUpdateReload: "Partial updates may have affected this formula. Reload this tab to see an updated data.",
        printIsNotAvailable: "La stampa non Ã¨ disponibile",
        productFiles: "Schede del prodotto",
        productFilesViewer: "Visualizzatore delle schede del prodotto",
        productNotAvailable: "Product '%{productName}' is not available.",
        properties: "ProprietÃ ",
        regularPrice: "Prezzo regolare",
        resetFormulaData: "Nuova formula",
        rgbOnlyIndicative: "RGB Ã¨ solo indicativo!",
        saveAsCustom: "Salva come",
        saveToStatsIsNotAvailable: "Il salvataggio nella cronologia non Ã¨ disponibile",
        searchForCheaper: "Cercare il piÃ¹ economico",
        selectFromCompetitive: "Ã possibile selezionare il colore tra i colori della concorrenza.",
        specialPrice: "Prezzo speciale",
        specialPriceVip: "Prezzo speciale VIP",
        splitFormula: "Riproporziona formula",
        withVAT: "Con IVA",
        withoutVAT: "Senza IVA"
    },
    marginSettings: {
        allBases: "tutte le basi",
        allProducts: "Tutti i prodotti",
        editMargin: "Modifica margine",
        marginAndDiscountWarning:
            "Devi impostare l'opzione di calcolo del prezzo per utilizzare i margini e gli sconti.",
        marginSettings: "Imposta margine",
        marginsFor: "Margini per",
        markupColorants: "Sovrapprezzo colorante",
        sizeOfPackage: "Dimensioni della confezione",
        valueBase: "Valore base",
        valueColorant: "Valore colorante"
    },
    matching: {
        actualColor: "Actual color",
        allCorrections: "Tutte le correzioni",
        allTillItems: "Tuttoi fino al selezionato",
        auto: "Auto",
        autoSelectAll: "Tutti Auto",
        canStartCorrection: "Quindi puoi iniziare la correzione.",
        canStartMatching: "Quindi puoi iniziare a formulare",
        cannotBeUsed: "La formulazione non puÃ² essere usata",
        changeProductAndColorants: "Prova a cambiare prodotto o coloranti",
        checkConfig: "Si prega di controllare la configurazione formulazione.",
        colorCorrection: "Correzione Colore",
        colorIsIndicative: "Color preview is only indicative.",
        colorNotAccurate: "Color may not be accurately displayed, it always depends on your monitor settings.",
        colorantInDispensedFormula: "Coloranti In Formula Dosata",
        confirmDispensing: "Confirm dispensing",
        connectionProblem: "Problema di Correzione",
        correctionHistory: "Storico Correzioni",
        correctionRunning: "Correction Is Running",
        draftFormula: "Draft formula",
        exclude: "Escludere",
        excludeAll: "Escludi Tutto",
        include: "Includi",
        includeAll: "Includi Tutto",
        invalidProduct: "It is not possible to do the matching for product %{productName}",
        itemOnly: "Solo selezionato",
        manualColorCorrection: "Correzione Colore Manuale",
        matchFormula: "Match Formula",
        matchingInformation: "Matching information",
        matchingResult: "Risultato Formulazione",
        matchingRunning: "Formulazione in corso",
        matchingSearchOptions: "Opzioni Cerca Strumentale",
        measurement: "Lettura Colore",
        noCorrection: "Correzione non trovata",
        noSpectralCurveProvided:
            "Il dispositivo connesso non puÃ² essere utilizzato per la formulazione perchÃ© non fornisce la curva spettrale",
        notAvailableForMatching: "Non disponibile per Formulare",
        originalFormula: "Formula Originale",
        reformulate: "Riformulare",
        reformulationRunning: "Riformulazione in corso",
        resultColor: "Colore Risultato",
        saveAsCustomFormula: "Salva come formula personale",
        searchInProgress: "Ricerca in corso, attendere prego",
        selectColorfile: "Selezionare Colorfile.",
        selectRequiredItems: "Seleziona prodotto, base, coloranti e confezione.",
        selectedResult: "Risultato selezionato",
        spectralDataNotAvailable: "Dati spettrali non disponibili",
        startCorrection: "Inizia Correzione",
        startMatching: "Inizia Formulazione",
        targetColor: "Target color",
        unsavedDraft: "Unsaved draft",
        unsavedDraftWarning: "Once you are satisfied with formula â do not forget to save your result.",
        usedForMatching: "Usato per Matching"
    },
    modal: {
        changeColorantUnit: "Cambia unitÃ  colorante",
        payAttention: "Fai attenzione!"
    },
    module: {
        productGroups: "Gruppi di prodotti"
    },
    navigation: {
        globalSearch: {
            fandeckFilter: "Filtro Cartelle colori",
            formulasOverLimit: "Per %{count} risultati. Digita piÃ¹ caratteri.",
            foundFormulas: "%{count} formule trovate",
            help: "Aiuto:",
            helpText:
                "Digita ad es. '%{filter}' per cercare le formule da '%{formula}', prodotti da '%{product}' e collezioni da '%{fandeck}'.",
            productFilter: "Filtro prodotto",
            searchInFormulas: "Ricerca smart",
            typeMore: "Inserire piÃ¹ caratteri"
        },
        menu: {
            actionHistory: "Storico",
            additionalFormulaTab: "Scheda della Formula aggiuntiva",
            advancedSettings: "Impostazioni avanzate",
            autotaskSettings: "Imposta autotask",
            availableDatabases: "Basi di dati disponibili",
            availablePrices: "Prezzi disponibili",
            bugReport: "Segnalazione di bug",
            canisterBarcodes: "Barcode Canestro",
            canisterDispensingLogic: "Logica di erogazione",
            canisterFilling: "Riempimento Canestri",
            canisterSettings: "Imposta canestro",
            clientServerSettings: "Connessione Client/Server",
            closing: "Chiusura",
            color: "Colore",
            colorModification: "Modifica del colore",
            colorPanel: "Impostazioni della Cartella Colori",
            colorRepresentation: "Rappresentazione del colore e dei dati",
            colorSearch: "Ricerca del colore",
            colorant: "Colorante",
            colorantConsumption: "Consumo di colorante",
            colorantPricing: "Prezzi dei coloranti",
            colorantRefillHistory: "Storico della ricarica del colorante",
            competitiveSearch: "Ricerca competitiva del colore",
            connections: "Connessioni",
            currency: "Impostazioni valuta",
            customData: "Dati personalizzati",
            database: "Database",
            databaseCheck: "Controllo del database",
            databaseConnection: "Connessione database",
            defaultValues: "Valori predefiniti",
            devices: "Dispositivi",
            dispensingHistory: "Storico dell'erogazione",
            dispensingSettings: "Impostazioni di erogazione",
            driverSettings: "Impostazioni driver",
            environment: "Ambiente",
            environmentConfiguration: "Impostazioni ambiente",
            environmentalSettings: "Impostazioni Ambiente",
            favorites: "Preferiti",
            fileTransfer: "Trasferimento dei file DESO",
            formatting: "Formattazione",
            formula: "Formula",
            formulaData: "Dati",
            formulaModification: "Modifica della formula",
            formulaPanels: "Pannelli della formula",
            formulaSettings: "Impostazioni formula",
            formulaUnit: "UnitÃ  di formula",
            generalSearch: "Ricerca generale",
            globalSettingsSearch: "Ricerca globale delle impostazioni",
            helpItems: "Impostazioni di aiuto",
            importAndExport: "Importazione ed esportazione",
            importAndExportData: "Importazione di dati personalizzati",
            importCustomData: "Importazione di dati",
            initialFormulaTab: "Scheda della formula iniziale",
            interfaceSettings: "Impostazioni dell'interfaccia",
            keyboardShortcuts: "Scorciatoie da tastiera",
            language: "Impostazioni lingua",
            languageSettings: "Impostazioni della lingua",
            layout: "Layout",
            license: "Licenza",
            licenseData: "Dati della licenza",
            licenseIdentification: "Identificazione della licenza",
            licenseStatus: "Stato della licenza",
            licenseSupplier: "Fornitore della licenza",
            licenseVersion: "Versione della licenza",
            localData: "Dati locali",
            machine: "Info tintometro",
            machineActions: "Azioni tintometro",
            machineAndDevices: "Macchine & Dispositivi",
            machineManagement: "Gestione della macchina",
            machineSettings: "Impostazioni tintometro",
            mainSettings: "Impostazioni principali",
            maintenance: "Manutenzione",
            marginAndDiscount: "Margine e sconto",
            matchingSearchResult: "Risultato ricerca matching",
            matchingSettings: "Settaggi Matching",
            navigationItems: "Elementi di navigazione",
            newFormulaWindow: "Formula",
            orderSearch: "Ricerca ordine",
            orderSettings: "Impostazioni d'ordine",
            packageSurcharge: "Sovrapprezzo del Formato",
            popUps: "Pop-Ups",
            posInfo: "Informazioni del POS",
            price: "Impostazioni prezzi",
            priceManagement: "Gestione prezzi",
            priceSettings: "Impostazioni prezzi",
            pricingOptions: "Opzioni dei prezzi",
            printSettings: "Impostazioni di stampa",
            productPricing: "Prezzo dei prodotti",
            qualityControlSettings: "Impostazioni Controllo QualitÃ ",
            quickTint: "In manuale",
            rccConfig: "Impostazioni RCC",
            rccConnection: "Connessione RCC",
            rccSettings: "Impostazioni RCC",
            refillSettings: "Impostazioni di ricarica",
            refillingLogic: "Logica di ricarica",
            registration: "Registrazione",
            searchSettings: "Impostazioni di ricerca",
            serverPlugins: "Plugin del server",
            serviceActions: "Azioni di servizio",
            settings: "Impostazioni",
            simplifiers: "Semplificatori",
            singleActions: "Azioni singole",
            smartPurgeRules: "Regole di spurgo intelligente",
            softwareOptions: "Opzioni software",
            spectroSettings: "Impostazioni dello Spettro",
            statistics: "Storico formule",
            switchToFrontdesk: "Passa a Frontdesk",
            switchToFullRedlike: "Passa a %{name}",
            switchToLight: "Passa a %{name}",
            switchToMachine: "Passa alla macchina",
            tabs: "Schede & Pop-Up",
            testBarcodes: "Prova codici a barre",
            updateOptions: "Opzioni di aggiornamento",
            userManagemenet: "Gestione degli utenti",
            visibleUnits: "UnitÃ  visibili"
        },
        navBar: {
            barcode: "Codice a barre",
            help: "Aiuto",
            hideItems: "Prodotti nascosti / cartelle colori"
        },
        notificationPanel: {
            noNotifications: "Nessuna nuova notifica"
        },
        tabBar: {
            closeActive: "Chiudi l'attivitÃ ",
            closeAll: "Chiudi tutto",
            closeAllExceptActive: "Chiudi tutto a parte l'attivitÃ ",
            customFormula: "Formula personale",
            dispensingHistory: "Storico erogazione",
            favorites: "Favoriti",
            formulaSearch: "Ricerca formula",
            rewriteSettings: "Re-write local settings"
        }
    },
    ordering: {
        assign: "Assegna",
        assignment: "Assegnamento",
        createdDate: "Data di creazione",
        finishDispensing: "Termina l'erogazione",
        foundInOrders: "Trovato negli ordini",
        inactiveDatabase: "La formula proviene da un database inattivo o sconosciuto %{0}",
        inactiveUnknownDatabase: "La formula proviene da un database inattivo o sconosciuto",
        newOrderReceived: "Hai ricevuto un nuovo ordine!",
        noOrderSelected: "Nessun ordine selezionato",
        release: "Rilascio",
        status: {
            accepted: "accettato",
            canceled: "eliminato",
            created: "creato",
            done: "fatto",
            partlyDone: "parzialmente fatto",
            preparing: "in preparazione",
            unknown: "sconosciuto"
        }
    },
    partialUpdates: {
        applying: "Applying partial updates",
        cantBeUsedForYourDbVersion:
            "Gli aggiornamenti non possono essere utilizzati per questo database. Si prega di aggiornare tramite Helper.",
        newVersionWillBeInstalled: "InstallerÃ  la nuova versione inclusi tutti gli aggiornamenti parziali disponibili.",
        noPartialUpdatesAvailable: "Aggiornamento incrementale non disponibile",
        outOfDate: "obsoleto!",
        partialUpdates: "Partial updates",
        partialUpdatesArePreparing: "Partial updates are preparing",
        partialUpdatesAvailable: "Aggiornamento incrementale disponibile!",
        preparedUpdatesMessage: "The following partial updates are prepared to be applied",
        remindMeLater: "Ricordamelo  piÃ¹ tardi (dopo  %{time} minuti)",
        swOutOfDate: "La versione corrente del software Ã¨",
        updateAutomatically: "If you do not response, update will start automatically in: %{time} s",
        updateToNewVersion: "Aggiorna all'ultima versione",
        updateWillTakeMoreTime: "L'aggiornamento richiederÃ  piÃ¹ tempo.",
        updatesApplied: "Partial updates were successfully applied.",
        updating: "Aggiornando"
    },
    posInfo: {
        address: "Indirizzo",
        contactName: "Nome contatto",
        contactPerson: "Persona da contattare",
        identification: "Identificazione",
        machineInformation: "Informazioni sulla macchina",
        pos: "Negozio",
        secondAddress: "Indirizzo alternativo",
        shopIdentification: "Identificazione del negozio",
        shopName: "Nome del negozio",
        url: "Url",
        zipCode: "CAP"
    },
    priceTypeList: {
        priceBasePurchase: "Prezzo di costo per base",
        priceBaseSell: "Prezzo di vendita per base",
        priceBaseSellFull: "Vendere a prezzo pieno la base",
        priceCntPurchase: "Prezzo di costo per i coloranti",
        priceCntPurchaseByColorantName: "Prezzo di costo per %{0} di colorante",
        priceCntPurchaseByName: "Prezzo di costo per coloranti per nome",
        priceCntSell: "Prezzo di vendita dei coloranti",
        priceCntSellByColorantName: "Prezzo di vendita per %{0} di colorante",
        priceCntSellByName: "Prezzo di vendita dei coloranti per nome",
        priceCntSellFull: "Vendere a prezzo pieno i coloranti",
        priceCntSellFullByColorantName: "Vendere a prezzo pieno per %{0} del colorante",
        priceCntSellFullByName: "Vendere a prezzo pieno i coloranti per nome",
        priceGroupBarcode: "Codice a barre dei gruppo di prezzo",
        priceMarginAll: "Margine per tutte le confezioni",
        priceMarginPerPkg: "Margine per una confezione",
        priceSellPriceAll: "Prezzo di vendita per tutte le confezioni",
        priceSellPricePerKg: "Prezzo di vendita per kg",
        priceSellPricePerL: "Prezzo di vendita per litro",
        priceSellPricePerPkg: "Prezzo di vendita per una confezione",
        priceSurchargeAll: "Ricarico per tutte le confezioni",
        priceSurchargePerPkg: "Ricarico per una confezione",
        priceTintPurchaseAll: "Costo tinta per tutte le confezioni",
        priceTintPurchasePerPkg: "Costo tinta per una confezione",
        priceTintSellFullAll: "Tint sell full price for all packages",
        priceTintSellFullAllPerPackage: "Tint sell full price per package",
        priceTotalPurchaseAll: "Prezzo di costo totale per tutti i formati",
        priceTotalPurchasePerKg: "Prezzo di costo totale per Kg",
        priceTotalPurchasePerL: "Prezzo di costo totale per litro",
        priceTotalPurchasePerPkg: "Prezzo di costo totale per una confezione",
        priceTotalSellFullAll: "Prezzo totale di vendita per tutti i formati.",
        priceTotalSellFullPerKg: "Prezzo pieno di vendita per chilogrammo",
        priceTotalSellFullPerLiter: "Prezzo pieno di vendita per litro",
        priceTotalSellFullPerPackage: "Prezzo pieno di vendita per formato"
    },
    pricing: {
        allBases: "Tutte le basi",
        allPackages: "Tutte le confezioni",
        backup: "Backup",
        basesOfProduct: "Base di %{productName}",
        colorantPricing: "Prezzi dei coloranti",
        export: "Esporta",
        import: "Importa",
        packagePricing: "Prezzi confezioni",
        packageSurcharge: "Ricarico confezioni",
        packages: "Confezioni",
        packagesOfProduct: "Formato di %{productName}",
        posCoeficient: "Coefficiente Pos",
        priceGroupPricePerLiter: "Gruppo di prezzo per litro",
        priceGroups: "Gruppi di prezzo",
        pricePerLiter: "Prezzo per litro",
        productPricing: "Prezzo del prodotto",
        purchasePrice: "Prezzo d'acquisto",
        purchasePricePerLiter: "Prezzo d'acquisto per litro",
        sellPrice: "Prezzo di vendita",
        surcharge: "Ricarico"
    },
    print: {
        adminRightsRequired: "I diritti di amministratore sono necessari per modificare o creare un nuovo modello.",
        allowAutomaticPrint: "Consenti stampa automatica",
        allowPrintAfterDispensing: "Consenti stampa dopo l'erogazione",
        allowPrintBeforeDispensing: "Consenti stampa prima dell'erogazione",
        automaticPrint: "Stampa automatica",
        choosePrinter: "Scegliere la stampante",
        chooseSettings: "Modificare le impostazioni",
        chooseTemplate: "Scegliere il modello",
        copies: "Copie",
        createTemplate: "Crea modello",
        createTemplateHint: "Creare un nuovo modello da zero. Salvarlo nella cartella dei modelli e riavviare RCC.",
        defaultPrinter: "Stampante",
        defaultSettings: "Impostazioni predefinite",
        defaultTemplate: "Modello predefinito",
        editTemplate: "Modifica modello",
        editTemplateHint: "Modifica %{name}. Le modifiche saranno visibili dopo il riavvio di RCC.",
        noEditTemplate: "Nessun modello da modificare",
        noPrinterSelected: "Nessuna stampante selezionata",
        noPrintersAvailable: "Nessuna stampante disponibile",
        noTemplateSelected: "Nessun modello Ã¨ selezionato",
        noTemplatesAvailable: "Nessun modello disponibile",
        numberOfCopies: "Numero di copie",
        openTemplateEditor: "Apri l'editor dei modelli",
        printAfterDispensing: "Stampa dopo l'erogazione",
        printAsImage: "Stampa come immagine",
        printBeforeDispensing: "Stampa prima dell'erogazione",
        printOnRequest: "Stampa su richiesta",
        printOptions: "Opzioni di stampa",
        printPagesAfterDispensing: "Numero di copie dopo l'erogazione",
        printPagesBeforeDispensing: "Numero di copie prima dell'erogazione",
        printPreview: "Anteprima di stampa",
        printSettings: "Impostazioni di stampa",
        printTaskLinkVariable: "Collegamento ad una variabile",
        printVariable: "Stampa variabile",
        printerName: "Nome della stampante",
        printerOptions: "Opzioni della stampante",
        printerSettings: "Opzioni della stampante",
        quickTintTemplate: "Modello Erogazione Veloce",
        setDefaultPrinter: "Imposta la stampante predefinita",
        setDefaultTemplate: "Imposta modello predefinito",
        setQuickTintTemplate: "Imposta modello Erogazione Veloce",
        showPreviewDialogBeforePrint: "Mostra il dialogo di anteprima prima della stampa",
        template: "Modello",
        templateName: "Nome modello",
        templateSettings: "Impostazioni del modello"
    },
    printTemplate: {
        baseCode: "Codice della base",
        baseName: "Nome della base",
        bfs: "BFS",
        colorantType: "Colorant type",
        customerCity: "CittÃ  del cliente",
        customerEmail: "Email del cliente",
        customerName: "Nome del cliente",
        customerPhone: "Telefono del cliente",
        customerStreet: "Indirizzo del cliente",
        customerZipCode: "Cap del cliente",
        destinationOfUse: "Destination of use",
        infoBfsGrade: "Classe BFS",
        orderQrCode: "QR code",
        packageOrderCount: "Conteggio degli ordini dei formati",
        posAddress: "Indirizzo del punto vendita",
        posAddressSecond: "Indirizzo 2 del punto vendita",
        posCity: "CittÃ  del punto vendita",
        posContact: "Contatto del punto vendita",
        posEmail: "email del punto vendita",
        posPhone: "Telefono del punto vendita",
        posUrl: "Url del punto vendita",
        posZipCode: "Cap del punto vendita",
        priceBasePurchaseWithTax: "Prezzo di costo per base con IVA",
        priceBaseSellWithTax: "Prezzo di vendita per base con IVA",
        priceCntPurchaseWithTax: "Prezzo di costo per coloranti con IVA",
        priceCntTotalSellWithTax: "Prezzo di vendita per coloranti con IVA",
        priceMarginAllWithTax: "Margine per tutte le confezioni con IVA",
        priceMarginPerPkgWithTax: "Margine per una confezione con IVA",
        priceSellPriceAllWithTax: "Prezzo di vendita per tutte le confezioni con IVA",
        priceSellPricePerKgWithTax: "Prezzo di vendita per Kg con IVA",
        priceSellPricePerLWithTax: "Prezzo di vendita per litro con IVA",
        priceSellPricePerPkgWithTax: "Prezzo di vendita per una confezione con IVA",
        priceSurchargeAllWithTax: "Ricarico per tutte le confezioni con IVA",
        priceSurchargePerPkgWithTax: "Ricarico per una confezione con IVA",
        priceTintPurchaseAllWithTax: "Costo tinta per tutte le confezioni con IVA",
        priceTintPurchasePerPkgWithTax: "Costo tinta per una confezione con IVA",
        priceTotalPurchaseAllWithTax: "Costo totale per tutte le confezioni con IVA",
        priceTotalPurchasePerKgWithTax: "Costo totale peer kg con IVA",
        priceTotalPurchasePerLWithTax: "Costo totale per litro con IVA",
        priceTotalPurchasePerPkgWithTax: "Costo totale per una confezione con IVA",
        productAltName: "Prodotto",
        recipeInline: "Ricetta"
    },
    products: {
        bases: "Basi",
        numberOfProducts: "Numero dei prodotti",
        packagesFor: "Confezione per",
        sizeOfPackage: "Lattaggio"
    },
    purgeModal: {
        purgeAll: "Spurga tutti",
        purgeAllChannels: "Spurgare tutti i canali",
        purgeVolume: "Spurga volume",
        startPurge: "Avvia spurgo"
    },
    qualityControl: {
        darker: "Darker",
        dispensedMeasuredFormula: "Formula erogata (misurata).",
        lighter: "Lighter",
        measureDispensedFormula: "Leggere la Formula Erogata per calcolare il Delta E",
        moreBlue: "PiÃ¹ Blu",
        moreGreen: "PiÃ¹ Verde",
        moreRed: "PiÃ¹ Rosso",
        moreYellow: "PiÃ¹ Giallo",
        pleaseContinueToFormulaCorrection: "Continuare per correggere la formula",
        qualityControlFailed: "Controllo QualitÃ  Fallito!",
        qualityControlPassed: "Controllo QualitÃ  Passato"
    },
    quickTint: {
        dispensingInProgress: "Erogazione in corso",
        dispensingIsNotAvailable: "Erogazione non disponibile",
        machineNotConnected: "Il tintometro non Ã¨ connesso",
        noColorantsSelected: "Nessun colorante selezionato",
        noPrinterAvailable: "La stampa non puÃ² essere eseguita perchÃ© non c'Ã¨ una stampante disponibile.",
        noTemplateAvailable: "La stampa non puÃ² essere eseguita perchÃ© non c'Ã¨ un modello disponibile.",
        overMaxCanisterSize: "Una o piÃ¹ quantitÃ  di colorante sono oltre il loro massimo"
    },
    quickTintSettings: {
        alphabetically: "In ordine alfabetico",
        byCanister: "Per canestro",
        closeAfterDispensing: "Chiudere dopo l'erogazione",
        closeBeforeDispensing: "Chiudere prima dell'erogazione",
        quickTintSettings: "Impostazioni dosaggio manuale",
        sorting: "Ordinamento",
        windowClosingRules: "Regole di chiusura delle finestre"
    },
    rccButtons: {
        abort: "annulla",
        all: "tutti",
        cancel: "elimina",
        continue: "continua",
        help: "aiuto",
        ignore: "ignora",
        no: "no",
        noToAll: "no a tutti",
        ok: "ok",
        postpone: "posticipa",
        resume: "ricomincia",
        retry: "riprova",
        skip: "salta",
        yes: "si",
        yesToAll: "si a tutti"
    },
    rccDialog: {
        98: "Controllare la %{0} Base con il Barcode.",
        99: "Inserire Base %{0} e confermare (Click OK)",
        100: "Tintometro in errore, ripristinare?",
        101: "Errore tintometro, impossibile continuare",
        102: "Resetfallito, impossibile continuare",
        103: "La formula contiene dei coloranti non validi: %{0}",
        104: "La formula contiene dei coloranti non validi: %{0}",
        105: "Colorante: %{0} Ã¨ sotto il livello d'allarme",
        106: "Coloranti: %{0} sono sotto il livello d'allarme",
        107: "Colorante: %{0} Ã¨ sotto il livello critico",
        108: "Coloranti: %{0} sono sotto il livello critico",
        109: "Posizionare latta",
        110: "Posizionare la base: %{0} per la formula: %{1}",
        111: "Rimuovere la latta",
        112: "Forare la latta?",
        113: "Ripristino, aspettare",
        114: "Piano in movimento, aspettare",
        115: "Foratura latta, aspettare",
        116: "Erogazione formula %{0}, aspettare|Confezione: %{1} of %{2}|Prodotto: %{3}|Base: %{4}|Lattaggio: %{5}",
        117: "Erogazione formula %{0}, aspettare|Confezione: %{1} of %{2}|Prodotto: %{3}|Base: %{4}|Lattaggio: %{5}",
        118: "Erogazione, aspettare|Confezione: %{0} of %{1}",
        119: "Erogazione, aspettare|Confezione: %{0} of %{1}",
        120: "Eliminazione erogazione, aspettare",
        121: "Convalida barcode della latta",
        122: "Convalida barcode della base|Prodotto: %{0}|Base: %{1}|Lattaggio: %{2}",
        123: "Processo di erogazione annullato, vuoi riprendere l'erogazione?",
        124: "Si Ã¨ verificato un'errore col tintometro %{0} : %{1}. Vuoi riprendere l'erogazione?",
        125: "Assicurarsi che la latta precedentemente impiegata sia in posizione",
        126: "Utilizzare una latta nuova se il processo di dosaggio riparte da zero",
        127: "Colorante: %{0} Ã¨ sotto la quantitÃ  minima di dosaggio. Vuoi continuare nonostante l'avviso?",
        128: "Coloranti: %{0} sono sotto la quantitÃ  minima di dosaggio. Vuoi continuare nonostante l'avviso?",
        129: "La formula scelta infrange la regola del troppo-pieno, quantitÃ  totale dei coloranti: %{0} %{1}, quantitÃ  massime permesse di coloranti: %{2} %{3}. Vuoi continuare nonostante l'avviso?",
        130: "Il tintometro Ã¨ in stato di errore, ripristinare?",
        131: "Il tintometro Ã¨ in stato di errore, impossibile continuare",
        132: "Resetfallito, impossibile continuare",
        133: "Formula di spurgo vuota, impossibile continuare",
        134: "La formula di spurgo contiene elementi non dosabili, vuoi continuare?",
        135: "Posiziona una latta per lo spurgo",
        136: "Rimuovi la latta per lo spurgo",
        137: "Resetin corso, aspettare",
        138: "Piano in movimento, aspettare",
        139: "Spurgo, aspettare",
        140: "Spurgo in corso, aspettare",
        141: "Eliminazione spurgo, aspettare",
        142: "Contenitore per lo spurgo non presente, controllare che sia posizionato correttamente.",
        143: "Lo spurgo contiene coloranti che non possono essere spurgati, vuoi continuare?",
        144: "Posiziona il contenitore per lo spurgo",
        145: "In lavorazione, attendere",
        146: "Sto terminando, attendere",
        150: "Pulizia, aspettare",
        151: "Pulizia, aspettare",
        152: "Eliminazione pulizia, aspettare",
        160: "Ricircolo, aspettare",
        161: "Ricircolo, aspettare",
        162: "Eliminazione ricircolo, aspettare",
        170: "Agitazione, aspettare",
        171: "Agitazione, aspettare",
        172: "Eliminazione agitazione, aspettare",
        180: "Inizializzazione connessione al tintometro, aspettare",
        181: "La connessione al tintometro non puÃ² essere stabilita %{0}: %{1}",
        182: "La connessione al tintometro non puÃ² essere stabilita. Consultare i log files per info",
        183: "Dispenser is missing colorant: %{0} that is defined in your database",
        184: "Dispenser is missing colorants: %{0} that are defined in your database",
        185: "Chiusura connessione con tintometro, aspettare",
        190: "Chiudere la finestra per continuare",
        200: "Ripristino, aspettare",
        201: "Ripristino importante, aspettare",
        202: "Inizializzazione, aspettare",
        203: "Errori di ripristino, aspettare",
        205: "Apertura del tappo automatico, attendere",
        206: "Chiusura del tappo automatico, attendere",
        207: "Tappo in movimento, attendere",
        210: "Punzonatura in atto, attendere",
        211: "Inserimento, attendere per favore",
        215: "Piano in salita, aspettare",
        216: "Piano in discesa, aspettare",
        217: "Piano in movimento, aspettare",
        220: "Tavola in movimento per il riempimento: %{0}, aspettare",
        221: "Tavola in movimento per ripristino, aspettare",
        222: "Tavola in movimento, aspettare",
        230: "Tintometro occupato, aspettare",
        240: "Riempire il canestro %{0}",
        241: "Riempire il Canestro %{0}",
        242: "Posizionamento canestro: %{0} (%{1}) per riempimento",
        243: "Riempire il Canestro %{0} utilizzando il codice a barre",
        244: "Riempire il Canestro %{0} utilizzando il codice a barre",
        250: "Rimuovere il contenitore spazzole, pulirlo e riempirlo secondo istruzioni",
        251: "Rimettere il contenitore delle spazzole",
        254: "Apertura del tappo automatico",
        255: "Pulire il tappo automatico secondo istruzioni",
        256: "Confermare al termine della pulizia e riposizionare il tappo automatico",
        257: "Chiusura del tappo automatico",
        260: "Rimuovere la piastrina e pulirla",
        261: "Riposizionare la piastrina",
        265: "Pulire la macchina con un panno e rimuovere tutto il colorante o altro liquido versato",
        266: "Conferma al termine",
        270: "Riempire la vaschetta e confermare al termine dell'operazione",
        271: "Riempire la vaschetta e confermare al termine dell'operazione",
        272: "Il livello della vaschetta Ã¨ ancora basso, controlla di nuovo",
        273: "Il livello della vaschetta Ã¨ ancora basso, controlla di nuovo",
        274: "Controlla il livello della vaschetta",
        275: "Attenndere prego",
        280: "Riavvio del computer",
        281: "Arresto del computer",
        300: "Manca la base della latta, controllare che la latta sia posizionata correttamente",
        301: "In preparazione, attendere",
        302: "Sto terminando, attendere",
        303: "La formula non puÃ² essere colorata perchÃ© contiene il colorante: %{0} che Ã¨ al di sopra della quantitÃ  massima erogabile definita per il canestro",
        304: "La formula non puÃ² essere colorata in quanto contiene coloranti: %{0} che sono superiori alle quantitÃ  massime erogabili definite per i canestri.",
        305: "Colorante: %{0} non puÃ² essere erogato in una sola volta, vuoi dividere la formula?",
        306: "Coloranti: %{0} non possono essere erogati immediatamente, vuoi dividere la formula?",
        307: "Colorante: %{0} non sarÃ  erogato dal dispenser, vuoi continuare e aggiungerlo manualmente?",
        308: "Coloranti: %{0} non saranno erogati dal dispenser, vuoi continuare e aggiungerli manualmente?",
        309: "La formula selezionata Ã¨ vuota, usare la base cosÃ¬ com'Ã¨",
        310: "Nessun colorante puÃ² essere erogato, preparare la base per l'aggiunta manuale del colorante",
        311: "Rimuovere la base e prepararla per l'aggiunta manuale del colorante",
        312: "Aggiungere manualmente %{0} %{1} di colorante: %{2}, confermare al termine",
        313: "Erogare La formula manualmente",
        314: "La formula selezionata infrange la regola dell'overfill, quantitÃ  totale di coloranti: %{0} %{1}, quantitÃ  massima consentita di coloranti: %{2} %{3}. Vuoi continuare nonostante questo avvertimento?",
        315: "Scansiona o digita il codice UFI della base ",
        316: "Scansiona o digita il codice UFI della base |Prodotto: %{0}|Base: %{1}|Dimensione della latta: %{2}",
        317: "Prepare colorant: %{0} for manual addition, confirm when done",
        318: "Prepare colorants: %{0} for manual addition, confirm when done",
        319: "Add manually colorant: %{0}, confirm when done",
        320: "Add manually colorants: %{0}, confirm when done",
        400: "VerrÃ  avviata l'operazione di spurgo automatico",
        401: "VerrÃ  avviata l'operazione di spurgo automatico",
        405: "Eseguire la manutenzione della vaschetta",
        406: "Eseguire la manutenzione della vaschetta",
        410: "VerrÃ  avviata la manutenzione automatica del tappo",
        411: "VerrÃ  avviata la manutenzione automatica del tappo",
        415: "Pulire la piastrina",
        416: "Pulire la piastrina",
        420: "Pulire il tintometro",
        421: "Pulire il tintometro",
        425: "VerrÃ  avviato il riempimento dei canestri",
        426: "VerrÃ  avviato il riempimento dei canestri",
        430: "E' stato pianificato il riavvio del computer",
        431: "E' stato pianificato il riavvio del computer",
        435: "E' stato pianificato l'arresto del computer",
        436: "E' stato pianificato l'arresto del computer",
        440: "E' stata pianificata la pulizia del dispenser",
        441: "E' stata pianificata la pulizia del dispenser",
        445: "E' stato pianificato il ricircolo del dispenser",
        446: "E' stato pianificato il ricircolo del dispenser",
        450: "E' stata pianificata l'agitazione del dispenser",
        451: "E' stata pianificata l'agitazione del dispenser",
        990: "Si Ã¨ verificato un errore tintometro %{0} : %{1}. Vuoi riprovare l'attivitÃ ?",
        991: "Si Ã¨ verificato un errore interno: %{0}",
        200000001: "Posizionare latta",
        200000002: "Rimuovi la latta",
        200000003: "QuantitÃ  per '%{0}' inferiore alla quantitÃ  minima di erogazione, continuare a proprio rischio?",
        200000004: "Riempimento '%{0}'"
    },
    rccDriverSettings: {
        databasePath: "Percorso del database",
        dispenser: "Dosatore",
        dispenserConfigurationFile: "File di configurazione dell'erogatore",
        driverPath: "Percorso del driver",
        extensionPath: "Percorso delle estensioni",
        folder: "Cartella",
        formulaPath: "Percorso della formula",
        host: "Host",
        iddPath: "File IDD di configurazione",
        italtintoPath: "Percorso di configurazione Italtinto",
        lldPath: "Percorso LLD",
        machineType: "Tipo di macchina",
        noMachineAvailable: "Nessuna macchina Ã¨ disponibile",
        protocolVersion: "Versione del protocollo",
        rccDriverSettings: "Impostazioni driver",
        resultPath: "Percorso",
        save: "Salva impostazioni",
        saveSettingsWarning:
            "Attenzione! Le modifiche a questa sezione potrebbero causare un malfunzionamento del tintometro.",
        serviceSwPath: "Percorso dei servizi Software",
        simulationPath: "Simulazione percorso"
    },
    rccMachineSettings: {
        allowManualColorantAddition: "Consenti l'aggiunta manuale del colorante",
        ask: "Chiedi",
        canHandlingOptions: "Opzioni di gestione delle confezioni",
        checkCanBeforeDispense: "Controllare la confezione prima di erogare",
        checkOverfill: "Controlla il riempimento eccessivo",
        colorantBatchNumbers: "Numero di lotto del colorante",
        colorantPackageValidation: "Convalida solo il formato del colorante",
        disable: "Disabilita",
        dispenseInvalidColorants: "Erogare i coloranti non validi",
        dispensingOptions: "Opzioni di erogazione",
        enable: "Abilita",
        enableUserIdentification: "Identificazione dell'utente",
        fullValidation: "Validazione completa",
        machineAccuracyWarning: "Avviso di accuratezza macchina",
        machineOptions: "Opzioni della macchina",
        machineUnit: "UnitÃ  della macchina",
        minimalDispenseAmount: "QuantitÃ  minima erogabile",
        placeCanSensor: "Sensore confezione",
        placeCanSensorDelay: "Ritardo sensore confezione",
        rccMachineSettings: "Impostazioni della macchina",
        refillBarcodeValidation: "Convalida del codice a barre della ricarica",
        refillBarcodeValidationCanisterAndColorant: "Convalida la tanica e la confezione del colorante",
        refillBarcodeValidationColorant: "Convalida solo la confezione del colorante",
        refillSettings: "Impostazioni di ricarica",
        removeCanSensor: "Disabilita sensore confezione",
        removeCanSensorDelay: "Disabilita ritardo sensore confezione",
        save: "Salva impostazioni",
        sec: "sec.",
        skipPlaceCanDialog: "Salta il dialogo della latta",
        skipRemoveCanDialog: "Salta la finestra di dialogo di rimozione della latta",
        splitFormula: "Riproporziona formula",
        tmcEnabled: "Abilita TMC",
        ufiCode: "UFI code",
        validateBarcodeBaseCan: "Convalida il codice a barre della base",
        validateBarcodeRefill: "Convalidare il codice a barre prima del riempimento",
        validateColorantsDuringInit: "Convalidare i coloranti durante l'inizializzazione"
    },
    rccPanel: {
        actionsRunningOnDispenser: "Ci sono alcune azioni in esecuzione sulla macchina",
        addLevel: "AGGIUNGI LIVELLO",
        addManually: "Aggiungi manualmente",
        barcodeNotSet: "Il Canestro %{colorantName} (%{canisterName}) non ha un codice a barre assegnato.",
        cancel: "ELIMINA",
        dispenseFormula: "Erogare la formula",
        dispenserIdle: "Tintometro pronto",
        dispenserIsBusy: "Tintometro in lavorazione",
        dispenserIsIdle: "Tintometro pronto",
        dispenserIsReady: "Tintometro pronto per altre lavorazioni",
        dispensingFormula: "Erogazione formula",
        errorCode: "Codice errore",
        explanation: "Spiegazione",
        fillToMax: "Riempi al massimo",
        finished: "Finito",
        inProgress: "In corso",
        machineIsReady: "Tintometro pronto",
        moveToFill: "Sposta per riempire",
        noMachineDialog: "Tintometro non collegato",
        of: "da",
        packageSize: "Lattaggio",
        placeBaseCan: "Posiziona la base",
        pleaseCheckYourMachineConnection: "Per favore, controlla la connessione della tua macchina.",
        pleaseRefill: "Riempire il canestro",
        solution: "Soluzione",
        subErrors: "Errori secondari",
        timeToEnd: "Tempo alla fine",
        tintingFormula: "Erogazione formula",
        tintingPleaseWait: "In erogazione, aspettare",
        validateBaseCan: "Convalida la base",
        waiting: "In attesa"
    },
    rccSettigns: {
        rccSettigns: "Connessione RCC",
        rccUrl: "Url RCC"
    },
    rccSpectroDialog: {
        100: "Connessione al dispositivo tramite Bluetooth. Assicurasi di avere il Bluetooth abilitato e che lo strumento sia acceso.",
        101: "Lo strumento non Ã¨ stato rilevato. Vuoi riprovare?",
        110: "Assicurarsi che Nano sia collegato e premere il pulsante dello strumento per avviare l'inizializzazione",
        111: "Nano non Ã¨ stato rilevato. Vuoi riprovare?",
        112: "Disconnetti Nano, attendi 10 secondi, ricollegalo e continua",
        120: "Connessione al dispositivo, attendere",
        121: "Lo strumento non Ã¨ stato rilevato. Vuoi riprovare?",
        200: "Posizionare lo strumento sulla piastra nera e continuare o premere il pulsante dello strumento",
        201: "Posizionare lo strumento sulla piastra nera e continuare.",
        202: "Posizionare lo strumento sulla piastra nera e premere il pulsante dello strumento",
        205: "Posizionare lo strumento sulla piastra bianca e continuare o premere il pulsante dello strumento",
        206: "Posizionare lo strumento sulla piastra bianca e continuare.",
        207: "Posizionare lo strumento sulla piastra bianca e premere il pulsante dello strumento",
        210: "Posizionare lo strumento sulla piastra di diagnostica e continuare o premere il pulsante dello strumento",
        211: "Posizionare lo strumento sulla piastra di diagnostica e continuare.",
        212: "Posizionare lo strumento sulla piastra di diagnostica e premere il pulsante dello strumento",
        215: "Chiudere il coperchio dello strumento e continuare o premere il pulsante dello strumento.",
        216: "Chiudere il coperchio dello strumento e continuare",
        217: "Chiudere il coperchio dello strumento e premere il pulsante dello strumento",
        220: "Posizionare lo strumento sulla piastra zero e continuare o premere il pulsante dello strumento",
        221: "Posizionare lo strumento sulla piastra zero e continuare",
        222: "Posizionare lo strumento sulla piastra zero e premere il pulsante dello strumento",
        224: "Posizionare lo strumento sul cuscinetto di calibrazione e continuare o premere il pulsante dello strumento",
        225: "Posizionare lo strumento sul cuscinetto di calibrazione e continuare",
        226: "Posizionare lo strumento sul cuscinetto di calibrazione e premere il pulsante dello strumento",
        227: "Posizionare lo strumento sul cuscinetto di calibrazione e premere il pulsante dello strumento",
        295: "Finire la calibrazione",
        296: "Lo strumento non Ã¨ connesso, vuoi aprire la connessione ad esso?",
        297: "Preparazione per la fase di calibrazione, si prega di attendere",
        298: "In calibrazione, attendere",
        299: "Sto terminando la calibrazione, attendere",
        300: "Posizionare lo strumento sul campione e continuare o premere il pulsante dello strumento",
        301: "Posizionare lo strumento sul campione e continuare",
        302: "Posizionare lo strumento sul campione e premere il pulsante dello strumento",
        303: "Lo strumento non Ã¨ calibrato, vuoi procedere con la calibrazione?",
        304: "Lo strumento non Ã¨ collegato, vuoi aprire una connessione ad esso?",
        390: "Selezionare la modalitÃ  di misura",
        395: "Termina la misurazione nella finestra del driver",
        397: "Sto per eseguire la lettura, attendere",
        398: "Lettura della tinta, attendere",
        399: "Sto terminando la lettura, attendere",
        498: "Sto scaricando i dati della lettura, attendere",
        499: "Sto scaricando i dati di tutte le letture, attendere",
        900: "Si Ã¨ verificato un errore dello strumento %{0} : %{1}. Vuoi riprovare l'operazione?",
        901: "Si Ã¨ verificato un errore interno: %{0}"
    },
    rccSpectroSettings: {
        DatacolorColorReader:
            "Il computer deve avere una connessione Bluetooth. Lo spectro deve essere associato al computer. Ã necessario Windows 10 con l'aggiornamento automatico 2018.",
        DatacolorSilent:
            "Quando si utilizza la modalitÃ  silenziosa, le finestre Datacolor vengono visualizzate direttamente in %{name}. In queste finestre, i parametri dello spettro non possono essere modificati.",
        DatacolorUseDiagnosticTile: "L'utilizzo del tile diagnostico migliora la qualitÃ  della misurazione.",
        comPort: "Porta Com",
        diagnosticTile: "Piastra di diagnostica Datacolor",
        measureModes: "ModalitÃ  di misura",
        measureModesOrder: "Ordine dei modi di misura",
        model: "Modello",
        noSpectroAvailable: "Nessuno spettro Ã¨ disponibile",
        rccSpectroSettings: "Impostazioni spettro",
        save: "Salvare le impostazioni",
        silent: "Datacolor Silenzioso",
        simulationPath: "Simulazione percorso",
        spectroType: "Tipo Spettro",
        useProfiledValues: "Utilizza i valori del profilo"
    },
    recirculateChannels: {
        recirculateAllChannels: "Ricircolo di tutte le pompe",
        recirculateChannels: "Ricircolo pompe",
        recirculatingSpeed: "VelocitÃ  di ricircolo",
        recirculatingTime: "Tempo di ricircolo",
        startRecirculating: "Inizio ricircolo"
    },
    redlikeLight: {
        finishPreviousSteps: "Si prega di completare i passaggi precedenti",
        searchBySpectro: "Ricerca da spettro",
        searchFormula: "Ricerca formula",
        selectBase: "Seleziona la base",
        selectColor: "Seleziona il colore",
        selectCustomer: "Seleziona il cliente",
        selectFandeck: "Seleziona la mazzetta",
        selectPackage: "Seleziona la confezione",
        selectProduct: "Seleziona il prodotto",
        startSelectFandeck: "Inizia selezionando la cartella colore",
        startSelectProduct: "Inizia selezionando il prodotto",
        stepByStepProgress: "Ã possibile procedere passo dopo passo",
        typeHereToSearch: "Digitare qui per la ricerca",
        typeToFilter: "Tipo di filtro"
    },
    restartModal: {
        computerNeedsRestart: "Il computer deve essere riavviato!",
        notCompletelyTranslated:
            "Il cambio di lingua richiede il riavvio del software. Alcune parti del software potrebbero non essere tradotte completamente in questo momento.",
        restartIsRequired: "Il riavvio del software Ã¨ necessario dopo che le modifiche sono state apportate.",
        softwareNeedsRestart: "%{name} deve essere riavviato!"
    },
    searchPanel: {
        basePlaceholder: "o digitare un nome della base",
        baseStartPlaceholder: "Inizia digitando il nome della base",
        colorCodeNamePlaceholder: " O digita un Codice/Nome Formula",
        colorCodeNameStartPlaceholder: "Inizia digitando il Nome o il Codice Formula",
        colorCodePlaceholder: "Digita Il Codice Della Formula",
        colorCodeStartPlaceholder: "Digita Il Codice Della Formula",
        colorNameCodePlaceholder: "Oppure digitare un nome/codice formula",
        colorNameCodeStartPlaceholder: "Inizia digitando il nome/codice formula",
        colorNamePlaceholder: "Nome Colore",
        colorNameStartPlaceholder: "Nome Colore",
        colorPreviewIsNotAvailable: "Color preview is not available. Select a fandeck to see relevant color preview.",
        fandeckPlaceholder: "Mazzetta colori",
        fandeckStartPlaceholder: "Mazzetta colori",
        formulaByColor: "Formula in base al colore",
        noResultsFound: "Nessun risultato trovato",
        packagePlaceholder: "o digita il nome di un pacchetto",
        packageStartPlaceholder: "Inizia digitando il nome di un pacchetto",
        productPlaceholder: "Nome prodotto",
        productStartPlaceholder: "Nome prodotto",
        standard: "Passa a PERSONALE",
        typeFandeckToFilter: "Digita nome della cartella colore ",
        typeProductToFilter: "Digita nome del prodotto"
    },
    sendOrderModal: {
        customNote: "Nota cliente",
        noCompatibleServers: "Non sono disponibili server compatibili nella tua rete",
        orderOverview: "Riepilogo ordine",
        selectTargetMachine: "Selezionare la macchina di destinazione",
        sendOrder: "Invia ordine",
        sendOrderTo: "L'ordine sarÃ  inviato a %{serverName}",
        targetMachine: "Macchina di destinazione"
    },
    server: {
        computerId: "ID Computer",
        ip: "IP",
        selectServer: "Scegliere uno dei servers disponibili",
        server: "Server"
    },
    serverDialog: {
        1: "C'Ã¨ un errore nella definizione dei marchi per la tua licenza. Per favore, contatta il tuo fornitore.",
        2: "Non Ã¨ possibile processare i dati %{0}: %{1}",
        3: "Path di rete non valido.",
        4: "Tipo Path non valido (solo %{0} e %{1} sono supportati)",
        5: "Errore in scrittura del file %{0} .",
        6: "%{0} File creato con successo.",
        7: "Colorante non trovato: '%{0}' alla riga '%{1}'",
        8: "Formato non trovato : '%{0}' alla riga '%{1}'",
        9: "Base non trovata per il Prodotto: '%{0}' e nome Base: '%{1}' alla riga '%{2}'",
        10: "Base non trovata nel prodotto formato con il Nome Prodotto: '%{0}', Nome Base: '%{1}' Nome Formato: '%{2}' alla riga '%{3}'",
        11: "Impossibile analizzare il valore del prezzo: '%{0}' alla riga '%{1}' nel foglio '%{2}'",
        12: "Preparazione dei dati  base, attendere",
        13: "Preparazione dei dati delle basi dei  prodotti, attendere",
        14: "Preparazione dei dati delle confezioni, attendere",
        15: "Preparazione dei dati dei colori, attendere",
        16: "Preparazione dei dati dei colori delle mazzette, attendere",
        17: "Preparazione dei dati delle mazzette, attendere",
        18: "Preparazione dei dati per la ricerca, attendere",
        19: "Preparazione dei dati dei  prodotti, attendere",
        30: "Partial updates can't be applied on database '%{0}'. Update your software to the latest version. Minimal required version is '%{1}'.",
        31: "Partial updates can't be applied on database '%{0}'. Database versions doesn't match. Contact your technical support.",
        32: "Partial updates can't be applied on database '%{0}'. Database structure version doesn't match. Contact your technical support.",
        33: "Partial updates can't be applied on database '%{0}'. The update is corrupted. Contact your technical support.",
        34: "Unknown error occurred during partial update. If this error repeats contact your technical support.",
        35: "No partial updates available. Please check your internet connection or contact your technical support.",
        36: "Prepared partial updates for database '%{0}' are for newer version of Redlike. Update your Redlike to the latest version. Minimal required version is '%{1}'.",
        37: "Partial updates can't be prepared. There is not enough space on the drive. Minimal required space is 20 GB.",
        38: "Partial updates can't be applied on database '%{0}'. The update is invalid. Contact your technical support.",
        39: "Partial updates can't be applied on database '%{0}'. The update can't be downloaded. Contact your technical support.",
        40: "Partial updates can't be applied on database '%{0}'. Downloaded file is corrupted. Contact your technical support."
    },
    serverPlugins: {
        activeServerPlugins: "Plugin del server attivi",
        currentlyActive: "I plugin attualmente attivi",
        plugin: "Plugin",
        pluginName: "Nome del plugin",
        statusActive: "Attivo",
        statusInactive: "Non attivo"
    },
    serviceActionsSettings: {
        canisterLevel: "Livello canestro",
        capClose: "Chiuso",
        capMiddle: "Intermedio",
        capOpen: "Aperto",
        cleanAllChannels: "Pulire tutte le pompe",
        cleanChannels: "Pulire le pompe",
        computer: "Computer",
        computerReboot: "Riavvio del computer",
        computerShutdown: "Spegnimento del computer",
        connectMachine: "Collega il tintometro",
        general: "Generale",
        initialize: "Inizializzazione",
        noMachineIsConnected: "Nessun tintometro collegato",
        plug: "Plug",
        plugger: "Plugger",
        punch: "Punzone",
        puncher: "Punzonare",
        purgeChannels: "Spurgo pompe",
        recirculate: "Ricircolo",
        recirculateAllChannels: "Ricircolo di tutte le pompe",
        recirculateChannels: "Ricircolo pompe",
        serviceActions: "Operazioni di manutenzione",
        setCanisterLevel: "Imposta il livello del canestro",
        shelfDown: "Discesa piano",
        shelfUp: "Salita piano",
        showServiceWindow: "Mostra finestra di servizio",
        smartPurgeAllChannels: "Spurgo intelligente di tutti i canali",
        smartPurgeChannels: "Spurgo intelligente dei canali",
        startErrorReset: "Inizio Reset degli errori",
        startHardReset: "Inizio Reset forzato",
        startReset: "Inizio Reset",
        stirAllCanisters: "Agitazione di tutti i canestri",
        stirCanisters: "Agitazione canestri",
        stirCanistersMore: "Agitazione canestri"
    },
    spectroMode: {
        eggshell: "Eggshell",
        flat: "Piatto",
        gloss: "Lucido",
        matt: "Opaco",
        matte: "Opaco",
        pearl: "Perla",
        satin: "Satinato",
        selectGlossLevel: "Confronta il campione colore con la scala gloss e seleziona il livello di gloss",
        semiGloss: "Semi-lucido"
    },
    spectroTab: {
        bestMatch: "The best match",
        calibrate: "Calibrazione",
        calibrateInstrument: "Calibrare lo strumento",
        connectDevice: "Connetti dispositivo",
        connectedTo: "Connesso a:",
        connectingDevice: "Connessione del dispositvo",
        deselectAll: "Deseleziona tutti",
        deviceCalibrated: "Your device has been calibrated and you can start measuring",
        deviceIsNotCalibrated: "Il dispositivo non Ã¨ calibrato",
        eraseResult: "Cancellare il risultato",
        filter: "Filtro",
        foundInFormulas: "Trovato nelle formule",
        inactiveSpectro: "The Spectro function is inactive for selected brand.",
        instrumentCalibration: "Il tuo strumento deve essere calibrato.",
        manualInput: "Inserimento manuale",
        measure: "Misura",
        measurementResult: "Risultato della lettura",
        noFilters: "Nessun filtro disponibile",
        noFormulas: "Nessuna formula trovata",
        noSelectedSpectro: "Nessuno spettro selezionato",
        notSelected: "Non selezionato",
        pressConnectButton: "Assicurarsi che il dispositivo sia collegato e premere il pulsante di connessione",
        searchFormulas: "Ricerca formule",
        selectSpectro: "Seleziona spettro",
        showDetails: "Mostra dettagli",
        skipCalibration: "Salta la calibrazione",
        spectroIsConnected: "Lo spettro Ã¨ connesso",
        spectroIsReady: "Lo spettro Ã¨ pronto",
        spectroReady: "Il dispositivo Ã¨ pronto per altre attivitÃ ",
        startCalibrateNow: "Iniziare a calibrare ",
        startMeasureText: "Il tuo dispositivo Ã¨ calibrato e puoi iniziare a misurare",
        tolerance: "Delta E (CIE 2000)",
        toleranceOfDevitation: "Delta E (CIE 2000) tolleranza"
    },
    statisticsTab: {
        allRecords: "All records",
        customPackageName: "Personale %{1} %{2}",
        deleteSelectedRecords: "Cancella i dati selezionati",
        exportHistory: "Storico dell'esportazione",
        finishFormula: "Formula finale",
        foundInFormulas: "Trovato nelle formule",
        hideHiddenRecords: "Non mostrare i record nascosti",
        hideSelectedRecord: "Nascondi il record selezionato",
        historicalFormula: "Formula Storica",
        onlyFiltered: "Only filtered",
        restoreSelectedRecord: "Ripristina il record selezionato",
        showAllRecords: "Mostra tutti i record",
        standardFormula: "Formula standard",
        unknownFormula: "Formula sconosciuta"
    },
    stirCanisters: {
        selectCanisters: "Seleziona i canestri",
        startStirring: "Avvia l'agitazione",
        stirAllCanisters: "Agitazione dei canestri",
        stirCanisters: "Agitazione canestri",
        stirringSpeed: "VelocitÃ  di agitazione",
        stirringTime: "Tempo di agitazione"
    },
    stock: {
        addColorant: "Aggiungi colorante...",
        addColorantPackagesToStock: "Aggiungi formati di colorante allo stock",
        addPackagesToStock: "Aggiungi formato a magazzino",
        addedToStock: "Aggiunto al magazzino",
        allDatabases: "Tutti i database",
        checkStockPackageInventory: "Se hai usato formato dal magazzino, controlla se il tuo inventario Ã¨ valido.",
        clearAllItems: "Cancella tutti gli articoli",
        colorantInventory: "Inventario dei coloranti",
        colorantsStockInventory: "Inventario di stock di coloranti",
        confirmSendingOrder: "Confermare l'ordine di invio",
        consumptionPrediction: "Previsione di consumo per le prossime %{weeks} settimane",
        createOrder: "Crea Ordine (%{sum})",
        expirationDate: "Data di scadenza %{dateTime}",
        inDelivery: "In consegna",
        manualOrder: "Ordine Manuale",
        manualOrderProgress: "Step %{step}/%{total}",
        noPackagesFoundInStockForColorant: "Non ci sono confezioni in magazzino per questo colorante.",
        onStock: "In magazzino",
        orderSummary: "Riassunto dell'ordine",
        prediction: "Previsione",
        removePackageFromStock: "Rimuovi il formato %{colorantName} dal magazzino",
        removePackageNameFromStock: "Vuoi rimuovere un formato%{packageName} dal magazzino?",
        scanBarcodeOrSelectColorant: "Scansiona il codice a barre dalla confezione o seleziona il colorante",
        selectPackageToRemove: "Seleziona il formato da rimuovere",
        sendConfirmed: "Invio confermato",
        setAmountsByPrediction: "Impostare gli importi in base alla previsione",
        sortByColorantName: "Ordina per nome del colorante",
        sortByOrderNeed: "Ordina per necessitÃ  di ordine",
        sortByStockLevel: "Ordina per livello di stock",
        toOrder: "Per ordinare"
    },
    testBarcode: {
        noItemAssigned: "Nessun elemento Ã¨ assegnato al codice a barre %{code}.",
        pleaseScanBarcode:
            "Scansiona il codice a barre della base, del prodotto, del pacchetto o di un altro articolo...",
        testBarcodes: "Test dei codici a barre"
    },
    ticketing: {
        answer: "Risposta",
        answered: "Risposto",
        chooseType: "Scegli il tipo",
        closeRequest: "Chiudi richiesta",
        comment: "Note",
        create: "Crea",
        createNewTicket: "Crea un nuovo Ticket",
        formulaAttached: "The requested formula is attached to the answer. Click the %{loadFormula} button to open it.",
        formulaClaim: "Reclamo Formula",
        formulaRequest: "Richiesta Formula",
        formulaUnrealizable: "The requested formula is unrealizable.",
        newTicket: "New ticket",
        noPosInfoFound: "Informazioni PV (nome, cittÃ ) non trovate",
        noTicketSelected: "Ticket non selezionato",
        openTicket: "Apri ticket",
        posName: "Nome PV",
        posted: "Inserito",
        request: "Richiesta",
        requestDate: "Data Richiesta",
        requestId: "Richiesta ID",
        resolvedBy: "Risolto da",
        responseDate: "Data Risposta",
        saveToCustomFormula: "Salva nelle formule personali",
        sending: "Inviando",
        service: "Service",
        successfulCreation: "Ticket creato con successo. In invioâ¦",
        ticketAnswered: "Un Ticket ha ricevuto risposta.",
        ticketDelivered: "Un Ticket Ã¨ stato inviato.",
        ticketId: "Ticket ID",
        ticketType: "Tipo Messaggio",
        waitingForAnswer: "Aspettando per una risposta"
    },
    tutorial: {
        last: "Ultimo",
        next: "Prossimo"
    },
    ufiCodeModal: {
        currentStatus: "Stato attuale",
        detailedInfoForColorant: "Informazioni dettagliate per il colorante %{colorantName}",
        userSetUfiCode: "Codice UFI impostato dall'utente, valore attuale"
    },
    ufiCodeSettings: {
        baseUfiCodeValidation: "Convalidazione del codice UFI della base",
        confirmColorantRefilling: "Conferma la ricarica del colorante",
        enableUfiCodes: "Abilitare i codici UFI",
        printUfiCode: "Stampa se la quantitÃ  di colorante Ã¨ finita",
        printUfiCodePercentage: "Stampare la percentuale se la quantitÃ  di colorante Ã¨ finita",
        scanOrTypeUfiCode: "Scansionare o digitare il codice UFI",
        scanOrTypeUfiCodeOfBase: "Scansionare o digitare il codice UFI della latta di base",
        ufiCodesByPercentage: "Utilizzare i codici UFI per percentuale",
        ufiCodesFromDatabase: "Utilizzare i codici UFI dal database",
        ufiCodesFromLastFilling: "Utilizzare i codici UFI dall'ultimo riempimento"
    },
    userSettings: {
        addUser: "Aggiungi utente",
        assignedUserGroups: "Gruppi di utenti assegnati",
        availableUserGroups: "Gruppi di utenti disponibili",
        barcode: "Codice a barre",
        confirmNewPassword: "Conferma nuova password",
        editPassword: "Modifica password",
        editUser: "Modifica utente",
        enableAutoLogin: "Abilita login automatico",
        newPassword: "Nuova password",
        noChange: "Non c'Ã¨ nessun cambiamento da salvare",
        oldPassword: "Vecchia password",
        password: "Password",
        passwordsDoNotMatch: "Le password non corrispondono",
        restoreUser: "Questo utente Ã¨ stato eliminato. Vuoi ripristinarlo?",
        userGroup: "User Group",
        userGroups: "Gruppi di utenti",
        userManagement: "Gestione degli utenti",
        userSettings: "Impostazioni utente",
        username: "Nome utente",
        usernameIsMissing: "Manca il nome utente."
    },
    warningMissingDataModal: {
        continue: "Mancano gli stessi dati, vuoi continuare?",
        notFoundBase:
            "La base per questo prodotto non Ã¨ disponibile. Confermare e fare attenzione a ottenere una base del prodotto compatibile dallo scaffale o annullare questo ordine.",
        notFoundProduct:
            "Questo prodotto non Ã¨ disponibile. Confermare e fare attenzione ad ottenere un prodotto compatibile dallo scaffale o annullare questo ordine."
    },
    weekdays: {
        friday: "VenerdÃ¬",
        monday: "LunedÃ¬",
        saturday: "Sabato",
        sunday: "Domenica",
        thursday: "GiovedÃ¬",
        tuesday: "MartedÃ¬",
        wednesday: "MercoledÃ¬"
    },
    welcome: {
        availableDatabase: "Il server non si connette al database. Controllare la configurazione del database.",
        availableDatabaseLocalError:
            "Errore durante la connessione al database locale (file errato, password non valida)",
        availableDatabaseLocalMissing: "Manca il file del database locale",
        availableDatabaseLocalUpdate: "Il database locale deve essere aggiornato alla versione piÃ¹ recente",
        availableDatabaseMainAndLocalError:
            "Errore durante la connessione al database principale e a quello locale (file sbagliato, password non valida)",
        availableDatabaseMainAndLocalMissing: "Mancano i files di database principale e locale",
        availableDatabaseMainAndLocalUpdate:
            "Sia il database principale che quello locale devono essere aggiornati alla versione piÃ¹ recente",
        availableDatabaseMainError:
            "Errore durante la connessione al database principale (file errato, password non valida)",
        availableDatabaseMainMissing: "Manca il file di database principale",
        availableDatabaseMainPartialUpdate:
            "Il database principale deve essere aggiornato alla versione piÃ¹ recente tramite aggiornamento parziale",
        availableDatabaseMainPartialUpdateAndLocalUpdate:
            "Il database principale deve essere aggiornato alla versione piÃ¹ recente tramite aggiornamento parziale e il database locale deve essere aggiornato alla versione piÃ¹ recente",
        availableDatabaseMainUpdate: "Il database principale deve essere aggiornato alla versione piÃ¹ recente",
        closing: "Il software sta chiudendo",
        compatibility:
            "Controllare la versione del tuo server. L'utente Ã¨ compatibile solo con server %{0} o superiore.",
        compatibilityCheck: "La ricerca di compatibilitÃ  Ã¨ in progresso",
        compatibilityDatabase:
            "Il tuo database non Ã¨ compatibile con il server. Controlla la configurazione del tuo database.",
        connectingServer: "Connessione al server al %{ip}",
        databaseCompatibility: "Il tuo database non Ã¨ compatibile con il software attuale",
        databasesCompatibility: "I vostri database non sono compatibili con il software attuale",
        licenseVerification: "La verifica della licenza Ã¨ in progresso",
        loading: "In caricamento",
        lostConnection: "Connessione al server persa",
        moduleMessage:
            "Fate attenzione alla selezione del modulo, perchÃ© il futuro cambio di modulo sarÃ  disponibile solo per gli utenti privilegiati.",
        refresh: "Aggiona",
        restoring: "Ripristinare la connessione",
        selectModule: "Selezionare uno dei moduli disponibili.",
        stopUpdate: "Arresta l'aggiornamento",
        updateDatabase: "Aggiornamento database",
        updatingDatabase: "Il database Ã¨ in fase di aggiornamento",
        updatingDatabases: "I database sono in fase di aggiornamento",
        updatingWarning:
            "La struttura del database Ã¨ in fase di aggiornamento alla versione piÃ¹ recente, si prega di attendere.",
        updatingWarningInfo:
            "Non chiudete questa finestra perchÃ© ciÃ² comporterebbe la necessitÃ  di rifare l'aggiornamento da zero."
    }
};
